import * as i0 from '@angular/core';
import { EventEmitter, QueryList, forwardRef, Component, ViewEncapsulation, Input, Output, ViewChild, ViewChildren, HostListener, Pipe, NgModule } from '@angular/core';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import { SvgIcons, ObjectUtils, ComponentKeys } from '@niceltd/cxone-components/shared-services';
import moment from 'moment';
import { trigger, state, style, transition, animate } from '@angular/animations';
import * as i4 from '@angular/forms';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormsModule } from '@angular/forms';
import * as i1 from '@angular/platform-browser';
import * as i4$1 from '@niceltd/cxone-components/text-input';
import { TextInputModule } from '@niceltd/cxone-components/text-input';
import { defineLocale } from 'ngx-bootstrap/chronos';
import * as i2 from 'ngx-bootstrap/datepicker';
import { BsDatepickerConfig, BsDatepickerDirective, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import * as i2$1 from '@niceltd/cxone-components/translation';
import { TranslationModule } from '@niceltd/cxone-components/translation';
import * as i5 from 'ngx-bootstrap/dropdown';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import * as i6 from '@niceltd/cxone-components/numeric-selector';
import { NumericSelectorModule } from '@niceltd/cxone-components/numeric-selector';
import { CalendarModule } from 'primeng/calendar';
import { I18NEXT_NAMESPACE } from 'angular-i18next';
const _c0 = ["timePickerElement"];
const _c1 = ["scrollableContainerEl"];
const _c2 = ["itemEl"];
function TimePickerComponent_cxone_text_input_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cxone-text-input", 10, 11);
    i0.ɵɵtwoWayListener("ngModelChange", function TimePickerComponent_cxone_text_input_3_Template_cxone_text_input_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r6 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r6.selectedTimeString, $event) || (ctx_r6.selectedTimeString = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("input", function TimePickerComponent_cxone_text_input_3_Template_cxone_text_input_input_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r8 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r8.onDateChange($event));
    })("blur", function TimePickerComponent_cxone_text_input_3_Template_cxone_text_input_blur_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r9 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r9.onTouchedCallback());
    })("keydown.enter", function TimePickerComponent_cxone_text_input_3_Template_cxone_text_input_keydown_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r10 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r10.onEnter($event));
    })("focusEvent", function TimePickerComponent_cxone_text_input_3_Template_cxone_text_input_focusEvent_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r11 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r11.toggleTimeOptions());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.selectedTimeString);
    i0.ɵɵproperty("name", ctx_r1.name)("disabled", ctx_r1.disabled);
  }
}
function TimePickerComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵlistener("keydown.enter", function TimePickerComponent_div_4_Template_div_keydown_enter_0_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r12 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r12.toggleTimeOptions());
    })("click", function TimePickerComponent_div_4_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r14 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r14.toggleTimeOptions());
    });
    i0.ɵɵelementStart(1, "span", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", ctx_r2.selectedTimeString)("aria-pressed", ctx_r2.showTimeOptions);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.selectedTimeString);
  }
}
const _c3 = a0 => ({
  "selected-item": a0
});
function TimePickerComponent_div_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14, 15);
    i0.ɵɵlistener("click", function TimePickerComponent_div_9_Template_div_click_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r18);
      const item_r15 = restoredCtx.$implicit;
      const ctx_r17 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r17.setTime(item_r15));
    })("keydown.enter", function TimePickerComponent_div_9_Template_div_keydown_enter_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r18);
      const item_r15 = restoredCtx.$implicit;
      const ctx_r19 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r19.setTime(item_r15));
    });
    i0.ɵɵelementStart(2, "span", 16);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r15 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c3, ctx_r4.selectedTimeString === item_r15.label));
    i0.ɵɵattribute("aria-label", ctx_r4.displayAsDuration ? item_r15.diff : item_r15.label);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r4.displayAsDuration ? item_r15.diff : item_r15.label);
  }
}
const _c4 = (a0, a1, a2, a3, a4) => ({
  "invalid": a0,
  "expanded": a1,
  "disabled": a2,
  "header": a3,
  "page": a4
});
const _c5 = a0 => ({
  transitionParams: a0,
  height: "*"
});
const _c6 = a1 => ({
  value: "visible",
  params: a1
});
const _c7 = a0 => ({
  transitionParams: a0,
  height: "0",
  border: "0"
});
const _c8 = a1 => ({
  value: "hidden",
  params: a1
});
const _c9 = ["inputEl"];
const _c10 = ["footerEl"];
const _c11 = ["dp"];
function DatePickerComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵlistener("click", function DatePickerComponent_div_3_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r7 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r7.previousDay());
    });
    i0.ɵɵelement(1, "div", 14);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.svgIcons.getSvgIcons("icon-arrow-left"), i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("ariaLabel", i0.ɵɵpipeBind1(2, 2, "cxone-components.datetimepicker.prevDay"));
  }
}
function DatePickerComponent_label_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("for", ctx_r1.datePickerId);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.dayNameText);
  }
}
function DatePickerComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 16);
  }
}
function DatePickerComponent_div_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵlistener("click", function DatePickerComponent_div_13_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r9 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r9.nextDay());
    });
    i0.ɵɵelement(1, "div", 14);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r5.svgIcons.getSvgIcons("icon-arrow-right"), i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("ariaLabel", i0.ɵɵpipeBind1(2, 2, "cxone-components.datetimepicker.nextDay"));
  }
}
function DatePickerComponent_div_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18, 19)(2, "a", 20);
    i0.ɵɵlistener("click", function DatePickerComponent_div_14_Template_a_click_2_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r12 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r12.gotoToday());
    });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("ariaLabel", i0.ɵɵpipeBind1(3, 2, "cxone-components.datetimepicker.today"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 4, "cxone-components.datetimepicker.today"));
  }
}
const _c12 = (a0, a1, a2, a3) => ({
  "disabled": a0,
  "invalid": a1,
  "header": a2,
  "page": a3
});
const _c13 = ["calIcon"];
function CombinedDatetimePickerComponent_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "cxone-components.datetimepicker.realtime"));
  }
}
function CombinedDatetimePickerComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵlistener("click", function CombinedDatetimePickerComponent_div_7_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r6 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r6.setRealtime(true, $event));
    });
    i0.ɵɵelement(1, "div", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r2.svgIcons.getSvgIcons("icon-real-time"), i0.ɵɵsanitizeHtml);
  }
}
function CombinedDatetimePickerComponent_div_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17, 18)(2, "a", 19);
    i0.ɵɵlistener("click", function CombinedDatetimePickerComponent_div_14_Template_a_click_2_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r9 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r9.gotoToday());
    });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 1, "cxone-components.datetimepicker.today"));
  }
}
const _c14 = (a0, a1, a2, a3, a4) => ({
  "disabled": a0,
  "header": a1,
  "page": a2,
  "real-time-enabled": a3,
  "real-time-active": a4
});
function WeekPickerComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵlistener("click", function WeekPickerComponent_div_3_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r5 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r5.moveToDate(-7));
    });
    i0.ɵɵelement(1, "div", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.svgIcons.getSvgIcons("icon-arrow-left"), i0.ɵɵsanitizeHtml);
  }
}
function WeekPickerComponent_div_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵlistener("click", function WeekPickerComponent_div_12_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r7 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r7.moveToDate(7));
    });
    i0.ɵɵelement(1, "div", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r3.svgIcons.getSvgIcons("icon-arrow-right"), i0.ɵɵsanitizeHtml);
  }
}
function WeekPickerComponent_div_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15, 16)(2, "a", 17);
    i0.ɵɵlistener("click", function WeekPickerComponent_div_13_Template_a_click_2_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r10 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r10.gotoCurrentWeek());
    });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 1, "cxone-components.datetimepicker.today"));
  }
}
const _c15 = (a0, a1, a2, a3) => ({
  disabled: a0,
  invalid: a1,
  header: a2,
  page: a3
});
const _c16 = (a0, a1, a2) => ({
  "disabled": a0,
  "header": a1,
  "page": a2
});
const _c17 = ["dropdownBtn"];
function DateRangeDropdownComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxoneMomentDate");
    i0.ɵɵpipe(3, "cxoneMomentDate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind2(2, 2, ctx_r1.dateRange.fromDate, ctx_r1.dateFormat), " - ", i0.ɵɵpipeBind2(3, 5, ctx_r1.dateRange.toDate, ctx_r1.dateFormat), "");
  }
}
function DateRangeDropdownComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.selectedDateItem.title);
  }
}
function DateRangeDropdownComponent_ng_container_7_ul_1_li_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 13);
    i0.ɵɵlistener("click", function DateRangeDropdownComponent_ng_container_7_ul_1_li_1_Template_li_click_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r10);
      const dateItem_r8 = restoredCtx.$implicit;
      const ctx_r9 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r9.dateDropdownChanged(dateItem_r8));
    });
    i0.ɵɵelementStart(1, "span", 14);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const dateItem_r8 = ctx.$implicit;
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c3, dateItem_r8.id === ctx_r7.selectedDateItem.id));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(dateItem_r8.title);
  }
}
function DateRangeDropdownComponent_ng_container_7_ul_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 11);
    i0.ɵɵtemplate(1, DateRangeDropdownComponent_ng_container_7_ul_1_li_1_Template, 3, 4, "li", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r6.datePickerOptions);
  }
}
function DateRangeDropdownComponent_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DateRangeDropdownComponent_ng_container_7_ul_1_Template, 2, 1, "ul", 10);
    i0.ɵɵelementContainerEnd();
  }
}
function DateRangeDropdownComponent_div_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵlistener("click", function DateRangeDropdownComponent_div_8_Template_div_click_0_listener($event) {
      return $event.stopPropagation();
    });
    i0.ɵɵelementStart(1, "cxone-date-time-range-picker", 16);
    i0.ɵɵtwoWayListener("fromDateChange", function DateRangeDropdownComponent_div_8_Template_cxone_date_time_range_picker_fromDateChange_1_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r12 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r12.customFrom, $event) || (ctx_r12.customFrom = $event);
      return i0.ɵɵresetView($event);
    })("toDateChange", function DateRangeDropdownComponent_div_8_Template_cxone_date_time_range_picker_toDateChange_1_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r14 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r14.customTo, $event) || (ctx_r14.customTo = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("realtimeChange", function DateRangeDropdownComponent_div_8_Template_cxone_date_time_range_picker_realtimeChange_1_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r15 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r15.onRealTimeChanged($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 17)(3, "button", 18);
    i0.ɵɵlistener("click", function DateRangeDropdownComponent_div_8_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r16 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r16.setCustomRange());
    });
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "button", 19);
    i0.ɵɵlistener("click", function DateRangeDropdownComponent_div_8_Template_button_click_6_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r17 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r17.cancelCustomRange());
    });
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("minDate", ctx_r4.customRangeMinAndMax ? ctx_r4.customRangeMinAndMax.minDate : null)("maxDate", ctx_r4.customRangeMinAndMax ? ctx_r4.customRangeMinAndMax.maxDate : null);
    i0.ɵɵtwoWayProperty("fromDate", ctx_r4.customFrom)("toDate", ctx_r4.customTo);
    i0.ɵɵproperty("dateRangePickerContainer", ctx_r4.dateRangeDropdownContainer)("isRealtimeActive", ctx_r4.isRealtimeActive)("realTimeOptionEnabled", ctx_r4.realTimeOptionEnabled)("removeShadowForPicker", true)("addLeds", ctx_r4.addLeds)("activeLedDays", ctx_r4.activeLedDays);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 12, "cxone-components.commonButtons.set"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 14, "cxone-components.commonButtons.cancel"));
  }
}
function DateRangeDropdownComponent_div_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵlistener("click", function DateRangeDropdownComponent_div_9_Template_div_click_0_listener($event) {
      return $event.stopPropagation();
    });
    i0.ɵɵelementStart(1, "form", 21);
    i0.ɵɵlistener("ngSubmit", function DateRangeDropdownComponent_div_9_Template_form_ngSubmit_1_listener() {
      i0.ɵɵrestoreView(_r20);
      const ctx_r19 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r19.LastDayPicker.setLastDays());
    });
    i0.ɵɵelementStart(2, "div", 22)(3, "span", 23);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 24)(7, "cxone-numeric-selector", 25);
    i0.ɵɵtwoWayListener("ngModelChange", function DateRangeDropdownComponent_div_9_Template_cxone_numeric_selector_ngModelChange_7_listener($event) {
      i0.ɵɵrestoreView(_r20);
      const ctx_r21 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r21.LastDayPickerValue, $event) || (ctx_r21.LastDayPickerValue = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("signClicked", function DateRangeDropdownComponent_div_9_Template_cxone_numeric_selector_signClicked_7_listener() {
      i0.ɵɵrestoreView(_r20);
      const ctx_r22 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r22.LastDayPicker.updateDates());
    })("change", function DateRangeDropdownComponent_div_9_Template_cxone_numeric_selector_change_7_listener() {
      i0.ɵɵrestoreView(_r20);
      const ctx_r23 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r23.validateLastDaysInput());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "span", 26);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "div", 27);
    i0.ɵɵelement(12, "span", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 29)(14, "button", 30);
    i0.ɵɵlistener("click", function DateRangeDropdownComponent_div_9_Template_button_click_14_listener() {
      i0.ɵɵrestoreView(_r20);
      const ctx_r24 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r24.LastDayPicker.cancelLastDays());
    });
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "button", 31);
    i0.ɵɵlistener("click", function DateRangeDropdownComponent_div_9_Template_button_click_17_listener() {
      i0.ɵɵrestoreView(_r20);
      const ctx_r25 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r25.LastDayPicker.setLastDays());
    });
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 9, "cxone-components.niceDateRangeDropdown.lastDaysPreLabel"));
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r5.LastDayPickerValue);
    i0.ɵɵproperty("step", 1)("min", 1)("max", 999);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 11, "cxone-components.niceDateRangeDropdown.lastDaysPostLabel"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", ctx_r5.dateRangeFormatted);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(16, 13, "cxone-components.commonButtons.cancel"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(19, 15, "cxone-components.commonButtons.set"));
  }
}
const _c18 = (a0, a1) => ({
  "dropdown-open": a0,
  "dropdown-closed": a1
});
class TimePickerComponent {
  constructor(domSanitizer, renderer) {
    this.domSanitizer = domSanitizer;
    this.renderer = renderer;
    this.alwaysOpen = false;
    /*
      disable typing in the timepicker input box; force users to select from list.
    */
    this.disableTextInput = false;
    /*
      determines whether to show the duration from the minDate beside each of the options.
    */
    this.displayAsDuration = false;
    /*
      sets the maximum time range of the dropdown
    */
    this.mode = 'page';
    /*
      callback which is called whenever a time is set
    */
    this.timeChanged = new EventEmitter();
    this.itemElementRefs = new QueryList();
    this.baseDate = moment().toDate();
    this.isDropdownOpen = false;
    this.svgIcons = new SvgIcons(this.domSanitizer);
    this.timeOptions = [];
    this.showTimeOptions = false;
    this.disabled = false;
    this.isValidTime = true;
    this.animating = false;
    /* Default transition animation options for the toggle behavior of the dropdown */
    this.transitionOptions = '300ms cubic-bezier(0.86, 0, 0.07, 1)';
    this.DEFAULTS = {
      steps: 15,
      timeFormat: 'hh:mm A',
      durationFormat: 'HH:mm',
      getDefaultMinTime: (date, format) => moment(date, format).startOf('day').toDate(),
      getDefaultMaxTime: (date, format) => this.displayAsDuration ? moment(date, format).endOf('day').toDate() : moment(date, format).endOf('day').add(1, 'second').toDate()
    };
  }
  writeValue(obj) {
    if (obj != null) {
      this.baseDate = this.getInitializedMomentObj(moment(obj, this.format));
    }
    this.selectedTimeString = moment(this.baseDate).format(this.format);
    this.isValidTime = this.areInputsValid() ? true : false;
  }
  registerOnChange(fn) {
    this.onChangedCallback = fn;
  }
  registerOnTouched(fn) {
    this.onTouchedCallback = fn;
  }
  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
    if (!this.timePickerElementRef || !this.timePickerElementRef.nativeElement) return;
    if (isDisabled) {
      this.renderer.addClass(this.timePickerElementRef.nativeElement, 'disabled');
    } else {
      this.renderer.removeClass(this.timePickerElementRef.nativeElement, 'disabled');
    }
  }
  ngOnInit() {
    this.initialize();
  }
  ngOnChanges(changes) {
    if (changes && changes.steps && !changes.steps.firstChange || changes && changes.displayAsDuration && !changes.displayAsDuration.firstChange || changes && changes.format && !changes.format.firstChange || changes && changes.minTime && !changes.minTime.firstChange || changes && changes.maxTime && !changes.maxTime.firstChange) {
      this.initialize();
    }
    if (changes && changes.alwaysOpen && !changes.alwaysOpen.firstChange) {
      this.toggleTimeOptions();
    }
  }
  /**
   * This initialises all the variables in the time picker
   */
  initialize() {
    this.steps = this.steps === undefined ? this.DEFAULTS.steps : this.steps;
    if (this.displayAsDuration) {
      this.format = this.DEFAULTS.durationFormat;
    } else if (this.format === undefined) {
      this.format = this.DEFAULTS.timeFormat;
    }
    this.selectedTimeString = moment(this.baseDate).format(this.format);
    this.minTime = this.minTime === undefined ? this.DEFAULTS.getDefaultMinTime(this.baseDate, this.format) : this.getInitializedMomentObj(moment(this.minTime, this.format));
    this.maxTime = this.maxTime === undefined ? this.DEFAULTS.getDefaultMaxTime(this.baseDate, this.format) : this.getInitializedMomentObj(moment(this.maxTime, this.format));
    if (moment(this.minTime).isSame(moment(this.maxTime), 'day') && moment(this.maxTime).format(this.DEFAULTS.timeFormat) === '12:00 AM') {
      this.maxTime = moment(this.maxTime).add(1, 'day').toDate();
    }
    this.populateTimeOptions();
    this.isValidTime = this.areInputsValid() ? true : false;
    this.autoCorrectTime = this.autoCorrectTime ? true : false;
  }
  /**
   * This sets the time in the baseDate moment object
   */
  getInitializedMomentObj(obj) {
    return moment(this.baseDate).set({
      hour: moment(obj).get('hour'),
      minute: moment(obj).get('minute'),
      second: moment(obj).get('second'),
      millisecond: moment(obj).get('millisecond')
    }).toDate();
  }
  /**
   * This validates the time ranges
   */
  areInputsValid() {
    if (moment(this.minTime).isAfter(moment(this.maxTime)) || moment(this.minTime).isSame(moment(this.maxTime))) {
      console.error('minTime should be less than maxTime');
      return false;
    }
    const maxTimeFormatted = moment(this.maxTime).format(this.DEFAULTS.timeFormat); // reassign for clarity
    if (moment(this.baseDate).isBefore(moment(this.minTime)) && !moment(this.baseDate).isSame(moment(this.minTime)) || moment(this.baseDate).isAfter(moment(this.maxTime)) && !moment(this.baseDate).isSame(moment(this.maxTime)) && maxTimeFormatted !== '12:00 AM') {
      const minTimeFormatted = moment(this.minTime).format(this.DEFAULTS.timeFormat);
      const baseDateFormatted = moment(this.baseDate).format(this.DEFAULTS.timeFormat);
      if (baseDateFormatted !== minTimeFormatted && baseDateFormatted !== maxTimeFormatted) {
        // handle edge cases for midnight
        return false;
      }
    }
    return true;
  }
  /**
   * This populates the options in the dropdown
   */
  populateTimeOptions() {
    this.timeOptions = [];
    let startTime = this.minTime;
    do {
      const timeDiff = moment(startTime).diff(this.minTime);
      this.timeOptions.push({
        datetime: startTime,
        label: moment(startTime).format(this.format),
        diff: this.prepareStringRepresentationOfTime(timeDiff)
      });
      startTime = moment(startTime).add(this.steps, 'minutes').toDate();
    } while (moment(startTime).isBefore(moment(this.maxTime)));
  }
  /**
   * This is responsible for preparing the time difference in string format
   */
  prepareStringRepresentationOfTime(timeDiffInMilliseconds) {
    const duration = moment.duration(timeDiffInMilliseconds);
    return this.padWithZero(duration.hours()) + ':' + this.padWithZero(duration.minutes());
  }
  /**
   * This is responsible for padding a number with zeros to make it double digits
   */
  padWithZero(num) {
    return ('0' + num).slice(-2);
  }
  /**
   * This is responsible for toggling the time picker dropdown
   */
  toggleTimeOptions() {
    this.isDropdownOpen = !this.isDropdownOpen;
    this.animating = true;
    if (this.alwaysOpen) {
      this.showTimeOptions = true;
    } else {
      this.showTimeOptions = !this.showTimeOptions;
    }
    if (this.showTimeOptions) {
      this.scrollToElementMatchingText(this.selectedTimeString);
    }
  }
  /**
   * This is the function which executes once all animations are complete
   */
  onToggleDone(_event) {
    this.animating = false;
  }
  /**
   * This sets the time whenever a time is selected from the dropdown options
   */
  setTime(time) {
    this.isValidTime = true;
    if (this.displayAsDuration) {
      this.selectedTimeString = time.diff;
      this.onTimeChanged(time.diff);
    } else {
      this.selectedTimeString = time.label;
      this.onTimeChanged(time.datetime);
    }
    this.toggleTimeOptions();
  }
  /**
   * Responsible for handling the callbacks back to the parent consumer
   */
  onTimeChanged(obj) {
    this.onChangedCallback(obj);
    this.timeChanged.emit({
      value: obj,
      isValid: this.isValidTime
    });
  }
  /**
   * This sets the time whenever a time is typed into the input box by the user
   */
  onDateChange(event) {
    this.scrollToElementMatchingText(event.target.value);
    if (!this.isAValidTimeString(event.target.value, this.format)) {
      this.isValidTime = false;
      this.onTimeChanged();
    } else {
      this.baseDate = this.getInitializedMomentObj(moment(event.target.value, this.format));
      if (this.displayAsDuration && this.isDurationValid(event.target.value)) {
        this.isValidTime = true;
        this.onTimeChanged(event.target.value);
      } else if (!this.displayAsDuration && this.areInputsValid()) {
        this.isValidTime = true;
        this.onTimeChanged(this.baseDate);
      } else {
        this.isValidTime = false;
        this.onTimeChanged();
      }
    }
  }
  isDurationValid(durationString) {
    const hours = +durationString.split(':')[0];
    const minutes = +durationString.split(':')[1];
    const milliseconds = (hours * 3600 + minutes * 60) * 1000;
    const maxDuration = moment(this.maxTime).diff(moment(this.minTime));
    return milliseconds <= maxDuration;
  }
  /**
   * Checks if a string is a valid time string
   */
  isAValidTimeString(timeStrting, format) {
    if (moment(timeStrting, format, true).isValid()) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * This is responsible to scroll to the matching text in the dropdown as and when the user types
   */
  scrollToElementMatchingText(text) {
    let flag = false;
    let index = 0;
    for (index = 0; index < this.itemElementRefs.length; index = index + 1) {
      if (this.itemElementRefs.toArray()[index].nativeElement.innerText.toLowerCase().includes(text.toLowerCase())) {
        flag = true;
        break;
      }
    }
    if (flag) {
      setTimeout(() => {
        this.scrollableContainerElementRef.nativeElement.scrollTo({
          top: this.itemElementRefs.toArray()[index].nativeElement.offsetTop - this.itemElementRefs.toArray()[index].nativeElement.clientHeight,
          left: 0,
          behavior: 'smooth'
        });
      });
    }
  }
  onEnter(event) {
    const value = event.target.value.replace(/\s/g, '');
    const validTime = this.toValidFormat(value);
    if (this.autoCorrectTime && !this.isAValidTimeString(value, this.format) && validTime != null && validTime !== 'Invalid date') {
      this.selectedTimeString = validTime;
      this.isValidTime = true;
      const date = this.getInitializedMomentObj(moment(value, this.format));
      this.onTimeChanged(date);
    }
  }
  customParse(input) {
    // Regular expression to extract hour, minute, second, and meridiem parts
    const regex = /^([01]?\d|2[0-3])[.:]?([0-5]\d)?[.:]?([0-5]\d)?\s*([apAP])?$/;
    const match = input.match(regex);
    if (match) {
      let hour = parseInt(match[1]);
      const minute = match[2] ? parseInt(match[2]) : 0;
      const second = match[3] ? parseInt(match[3]) : 0;
      const meridiem = match[4] ? match[4].toLowerCase() : undefined;
      // Adjust hour for PM times
      if ((meridiem === 'p' || meridiem === 'P') && hour < 12) {
        hour += 12;
      } else if ((meridiem === 'a' || meridiem === 'A') && hour === 12) {
        hour = 0;
      }
      return {
        hour,
        minute,
        second
      };
    }
    return null; // invalid input
  }
  toValidFormat(input) {
    return moment(this.customParse(input)).format(this.format);
  }
  /* This function closes the dropdown whenever there is a click outside the dropdown area */
  closeDropdown(event) {
    if (!this.timePickerElementRef.nativeElement.contains(event.target) && this.showTimeOptions) {
      this.toggleTimeOptions();
    }
  }
  /** @nocollapse */
  static {
    this.ɵfac = function TimePickerComponent_Factory(t) {
      return new (t || TimePickerComponent)(i0.ɵɵdirectiveInject(i1.DomSanitizer), i0.ɵɵdirectiveInject(i0.Renderer2));
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TimePickerComponent,
      selectors: [["cxone-time-picker"]],
      viewQuery: function TimePickerComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
          i0.ɵɵviewQuery(_c1, 5);
          i0.ɵɵviewQuery(_c2, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.timePickerElementRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.scrollableContainerElementRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.itemElementRefs = _t);
        }
      },
      hostBindings: function TimePickerComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function TimePickerComponent_click_HostBindingHandler($event) {
            return ctx.closeDropdown($event);
          }, false, i0.ɵɵresolveDocument);
        }
      },
      inputs: {
        alwaysOpen: "alwaysOpen",
        disableTextInput: "disableTextInput",
        displayAsDuration: "displayAsDuration",
        format: "format",
        minTime: "minTime",
        maxTime: "maxTime",
        mode: "mode",
        name: "name",
        steps: "steps",
        autoCorrectTime: "autoCorrectTime"
      },
      outputs: {
        timeChanged: "timeChanged"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => TimePickerComponent),
        multi: true
      }]), i0.ɵɵNgOnChangesFeature],
      decls: 10,
      vars: 23,
      consts: [[1, "cxone-time-picker", 3, "ngClass"], ["timePickerElement", ""], [1, "control-section"], ["placeholder", "", "tabindex", "0", 3, "ngModel", "name", "disabled", "ngModelChange", "input", "blur", "keydown.enter", "focusEvent", 4, "ngIf"], ["role", "button", "class", "display-button", "tabindex", "0", 3, "keydown.enter", "click", 4, "ngIf"], ["role", "button", "tabindex", "0", 1, "button-item", 3, "keydown.enter", "click"], ["role", "img", "alt", "", 1, "icon-time", 3, "innerHTML"], ["role", "dialog", 1, "options-wrapper", 3, "hidden"], ["scrollableContainerEl", ""], ["class", "item-row", "role", "option", "tabindex", "0", 3, "ngClass", "click", "keydown.enter", 4, "ngFor", "ngForOf"], ["placeholder", "", "tabindex", "0", 3, "ngModel", "name", "disabled", "ngModelChange", "input", "blur", "keydown.enter", "focusEvent"], ["textInputElement", ""], ["role", "button", "tabindex", "0", 1, "display-button", 3, "keydown.enter", "click"], [1, "selected-text"], ["role", "option", "tabindex", "0", 1, "item-row", 3, "ngClass", "click", "keydown.enter"], ["itemEl", ""], [1, "item-text"]],
      template: function TimePickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0, 1)(2, "div", 2);
          i0.ɵɵtemplate(3, TimePickerComponent_cxone_text_input_3_Template, 2, 3, "cxone-text-input", 3)(4, TimePickerComponent_div_4_Template, 3, 3, "div", 4);
          i0.ɵɵelementStart(5, "div", 5);
          i0.ɵɵlistener("keydown.enter", function TimePickerComponent_Template_div_keydown_enter_5_listener() {
            return ctx.toggleTimeOptions();
          })("click", function TimePickerComponent_Template_div_click_5_listener() {
            return ctx.toggleTimeOptions();
          });
          i0.ɵɵelement(6, "div", 6);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(7, "div", 7, 8);
          i0.ɵɵlistener("@dropdownContent.done", function TimePickerComponent_Template_div_animation_dropdownContent_done_7_listener($event) {
            return ctx.onToggleDone($event);
          });
          i0.ɵɵtemplate(9, TimePickerComponent_div_9_Template, 4, 5, "div", 9);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction5(9, _c4, ctx.isValidTime === false, ctx.showTimeOptions, ctx.disabled, ctx.mode === "header", ctx.mode === "page"));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", !ctx.disableTextInput);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.disableTextInput);
          i0.ɵɵadvance();
          i0.ɵɵattribute("aria-label", ctx.selectedTimeString)("aria-pressed", ctx.showTimeOptions);
          i0.ɵɵadvance();
          i0.ɵɵproperty("innerHTML", ctx.svgIcons.getSvgIcons("icon-time"), i0.ɵɵsanitizeHtml);
          i0.ɵɵadvance();
          i0.ɵɵproperty("hidden", !ctx.isDropdownOpen)("@dropdownContent", ctx.showTimeOptions ? i0.ɵɵpureFunction1(17, _c6, i0.ɵɵpureFunction1(15, _c5, ctx.animating ? ctx.transitionOptions : "0ms")) : i0.ɵɵpureFunction1(21, _c8, i0.ɵɵpureFunction1(19, _c7, ctx.transitionOptions)));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.timeOptions);
        }
      },
      dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i4.NgControlStatus, i4.NgModel, i4$1.TextInputComponent],
      styles: [".cxone-time-picker{position:relative}.cxone-time-picker.header{box-shadow:0 2px 6px #00000017}.cxone-time-picker.header .control-section .button-item,.cxone-time-picker.header .control-section input[type=text]{border:none}.cxone-time-picker.header.expanded .options-wrapper{border-top:1px solid rgb(208,210,211);border-top-left-radius:2px;border-top-right-radius:2px}.cxone-time-picker.header.expanded .button-item{background:#fff}.cxone-time-picker.invalid .control-section .button-item,.cxone-time-picker.invalid .control-section .button-item:hover{border-top:1px solid rgb(245,57,70);border-right:1px solid rgb(245,57,70);border-bottom:1px solid rgb(245,57,70)}.cxone-time-picker.invalid .control-section cxone-text-input input[type=text]{border-top:1px solid rgb(245,57,70);border-left:1px solid rgb(245,57,70);border-bottom:1px solid rgb(245,57,70)}.cxone-time-picker.invalid .control-section cxone-text-input input[type=text]:hover{border-right-color:#b8c5cc!important}.cxone-time-picker.disabled .display-button{background-color:#f8f8f8;border-color:#dae2e8;pointer-events:none}.cxone-time-picker.disabled .display-button .selected-text{color:#707e8d}.cxone-time-picker.disabled .button-item{border-color:#dae2e8!important;background-color:#f8f8f8;pointer-events:none}.cxone-time-picker.disabled .button-item .icon-time{fill:#6c8492!important}.cxone-time-picker.expanded .button-item{cursor:pointer;border-color:#d0d2d3;background-color:#fff}.cxone-time-picker.expanded .button-item .icon-time{fill:#748894}.cxone-time-picker.expanded .options-wrapper{border-bottom:1px solid rgb(208,210,211)}.cxone-time-picker .control-section{display:flex}.cxone-time-picker .control-section cxone-text-input{flex:1}.cxone-time-picker .control-section .display-button{background-color:#fff;width:100%;display:flex;align-items:center;border:1px solid rgb(184,197,204);cursor:pointer}.cxone-time-picker .control-section .display-button .selected-text{font-size:13px;color:#2e2e2e;padding:0 10px}.cxone-time-picker .control-section .display-button:hover{border-color:#007cbe}.cxone-time-picker .control-section .button-item{border:1px solid rgb(184,197,204);border-left:0;width:35px;height:35px;cursor:pointer;background-color:#fff}.cxone-time-picker .control-section .button-item .icon-time{transform:scale(.5);fill:#93a4aa;pointer-events:none}.cxone-time-picker .control-section .button-item:hover{background-color:#007cbe;border-left:1px solid;border-color:#007cbe}.cxone-time-picker .control-section .button-item:hover .icon-time{fill:#fff}.cxone-time-picker .options-wrapper{position:absolute;background-color:#fff;max-height:210px;width:100%;overflow:auto;border-left:1px solid rgb(208,210,211);border-right:1px solid rgb(208,210,211);z-index:9999}.cxone-time-picker .options-wrapper .item-row{display:flex;height:35px;align-items:center;cursor:pointer}.cxone-time-picker .options-wrapper .item-row .item-text{color:#2e2e2e;font-size:13px;margin-left:10px;flex-grow:0;flex-shrink:0}.cxone-time-picker .options-wrapper .item-row:hover:not(.selected-item){background-color:#007cbe}.cxone-time-picker .options-wrapper .item-row:hover:not(.selected-item) .item-text{color:#fff}.cxone-time-picker .options-wrapper .item-row.selected-item{background-color:#eff6fb}\n"],
      encapsulation: 2,
      data: {
        animation: [trigger('dropdownContent', [state('hidden', style({
          height: '0'
        })), state('void', style({
          height: '{{ height }}'
        }), {
          params: {
            height: '0'
          }
        }), state('visible', style({
          height: '*'
        })), transition('visible <=> hidden', animate('{{ transitionParams }}')), transition('void <=> hidden', animate('{{ transitionParams }}')), transition('void <=> visible', animate('{{ transitionParams }}'))])]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TimePickerComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-time-picker',
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => TimePickerComponent),
        multi: true
      }],
      encapsulation: ViewEncapsulation.None,
      animations: [trigger('dropdownContent', [state('hidden', style({
        height: '0'
      })), state('void', style({
        height: '{{ height }}'
      }), {
        params: {
          height: '0'
        }
      }), state('visible', style({
        height: '*'
      })), transition('visible <=> hidden', animate('{{ transitionParams }}')), transition('void <=> hidden', animate('{{ transitionParams }}')), transition('void <=> visible', animate('{{ transitionParams }}'))])],
      template: "<div class=\"cxone-time-picker\" #timePickerElement [ngClass]=\"{'invalid': isValidTime === false, 'expanded': showTimeOptions, 'disabled': disabled, 'header': mode === 'header', 'page': mode === 'page' }\">\n    <div class=\"control-section\">\n          <cxone-text-input #textInputElement *ngIf=\"!disableTextInput\"\n                            [(ngModel)]=\"selectedTimeString\"\n                            [name]=\"name\"\n                            placeholder=\"\"\n                            (input)=\"onDateChange($event)\"\n                            (blur)=\"onTouchedCallback()\"\n                            tabindex=\"0\"\n                            [disabled]=\"disabled\"\n                            (keydown.enter)=\"onEnter($event)\"\n                            (focusEvent)=\"toggleTimeOptions()\"></cxone-text-input>\n        <div [attr.aria-label]=\"selectedTimeString\" role=\"button\" [attr.aria-pressed]=\"showTimeOptions\" (keydown.enter)=\"toggleTimeOptions()\"  class=\"display-button\" *ngIf=\"disableTextInput\" tabindex=\"0\" (click)=\"toggleTimeOptions()\">\n            <span class=\"selected-text\">{{ selectedTimeString }}</span>\n        </div>\n        <div class=\"button-item\" [attr.aria-label]=\"selectedTimeString\" (keydown.enter)=\"toggleTimeOptions()\" (click)=\"toggleTimeOptions()\" role=\"button\" [attr.aria-pressed]=\"showTimeOptions\" tabindex=\"0\"  >\n            <div class=\"icon-time\" role=\"img\" alt='' [innerHTML]=\"svgIcons.getSvgIcons('icon-time')\"></div>\n        </div>\n    </div>\n    <div [hidden]=\"!isDropdownOpen\" class=\"options-wrapper\" role=\"dialog\" #scrollableContainerEl [@dropdownContent]=\"showTimeOptions ? { value: 'visible', params: { transitionParams: animating ? transitionOptions: '0ms', height: '*'}} : { value: 'hidden', params: { transitionParams: transitionOptions, height: '0', border: '0' }}\" (@dropdownContent.done)=\"onToggleDone($event)\">\n        <div class=\"item-row\" *ngFor=\"let item of timeOptions\" role=\"option\"\n          [attr.aria-label]=\"displayAsDuration? item.diff : item.label\" (click)=\"setTime(item)\" (keydown.enter)=\"setTime(item)\" tabindex=\"0\"\n          [ngClass]=\"{ 'selected-item': selectedTimeString === item.label }\" #itemEl>\n            <span class=\"item-text\">{{ displayAsDuration? item.diff : item.label }}</span>\n        </div>\n    </div>\n</div>\n",
      styles: [".cxone-time-picker{position:relative}.cxone-time-picker.header{box-shadow:0 2px 6px #00000017}.cxone-time-picker.header .control-section .button-item,.cxone-time-picker.header .control-section input[type=text]{border:none}.cxone-time-picker.header.expanded .options-wrapper{border-top:1px solid rgb(208,210,211);border-top-left-radius:2px;border-top-right-radius:2px}.cxone-time-picker.header.expanded .button-item{background:#fff}.cxone-time-picker.invalid .control-section .button-item,.cxone-time-picker.invalid .control-section .button-item:hover{border-top:1px solid rgb(245,57,70);border-right:1px solid rgb(245,57,70);border-bottom:1px solid rgb(245,57,70)}.cxone-time-picker.invalid .control-section cxone-text-input input[type=text]{border-top:1px solid rgb(245,57,70);border-left:1px solid rgb(245,57,70);border-bottom:1px solid rgb(245,57,70)}.cxone-time-picker.invalid .control-section cxone-text-input input[type=text]:hover{border-right-color:#b8c5cc!important}.cxone-time-picker.disabled .display-button{background-color:#f8f8f8;border-color:#dae2e8;pointer-events:none}.cxone-time-picker.disabled .display-button .selected-text{color:#707e8d}.cxone-time-picker.disabled .button-item{border-color:#dae2e8!important;background-color:#f8f8f8;pointer-events:none}.cxone-time-picker.disabled .button-item .icon-time{fill:#6c8492!important}.cxone-time-picker.expanded .button-item{cursor:pointer;border-color:#d0d2d3;background-color:#fff}.cxone-time-picker.expanded .button-item .icon-time{fill:#748894}.cxone-time-picker.expanded .options-wrapper{border-bottom:1px solid rgb(208,210,211)}.cxone-time-picker .control-section{display:flex}.cxone-time-picker .control-section cxone-text-input{flex:1}.cxone-time-picker .control-section .display-button{background-color:#fff;width:100%;display:flex;align-items:center;border:1px solid rgb(184,197,204);cursor:pointer}.cxone-time-picker .control-section .display-button .selected-text{font-size:13px;color:#2e2e2e;padding:0 10px}.cxone-time-picker .control-section .display-button:hover{border-color:#007cbe}.cxone-time-picker .control-section .button-item{border:1px solid rgb(184,197,204);border-left:0;width:35px;height:35px;cursor:pointer;background-color:#fff}.cxone-time-picker .control-section .button-item .icon-time{transform:scale(.5);fill:#93a4aa;pointer-events:none}.cxone-time-picker .control-section .button-item:hover{background-color:#007cbe;border-left:1px solid;border-color:#007cbe}.cxone-time-picker .control-section .button-item:hover .icon-time{fill:#fff}.cxone-time-picker .options-wrapper{position:absolute;background-color:#fff;max-height:210px;width:100%;overflow:auto;border-left:1px solid rgb(208,210,211);border-right:1px solid rgb(208,210,211);z-index:9999}.cxone-time-picker .options-wrapper .item-row{display:flex;height:35px;align-items:center;cursor:pointer}.cxone-time-picker .options-wrapper .item-row .item-text{color:#2e2e2e;font-size:13px;margin-left:10px;flex-grow:0;flex-shrink:0}.cxone-time-picker .options-wrapper .item-row:hover:not(.selected-item){background-color:#007cbe}.cxone-time-picker .options-wrapper .item-row:hover:not(.selected-item) .item-text{color:#fff}.cxone-time-picker .options-wrapper .item-row.selected-item{background-color:#eff6fb}\n"]
    }]
  }], () => [{
    type: i1.DomSanitizer
  }, {
    type: i0.Renderer2
  }], {
    alwaysOpen: [{
      type: Input
    }],
    disableTextInput: [{
      type: Input
    }],
    displayAsDuration: [{
      type: Input
    }],
    format: [{
      type: Input
    }],
    minTime: [{
      type: Input
    }],
    maxTime: [{
      type: Input
    }],
    mode: [{
      type: Input
    }],
    name: [{
      type: Input
    }],
    steps: [{
      type: Input
    }],
    autoCorrectTime: [{
      type: Input
    }],
    timeChanged: [{
      type: Output
    }],
    timePickerElementRef: [{
      type: ViewChild,
      args: ['timePickerElement', {
        static: false
      }]
    }],
    scrollableContainerElementRef: [{
      type: ViewChild,
      args: ['scrollableContainerEl', {
        static: false
      }]
    }],
    itemElementRefs: [{
      type: ViewChildren,
      args: ['itemEl']
    }],
    closeDropdown: [{
      type: HostListener,
      args: ['document:click', ['$event']]
    }]
  });
})();
const DEFAULT_LOCALE = {
  abbr: 'en-gb',
  months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
  monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
  weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
  weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
  weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
  weekdaysParseExact: true,
  longDateFormat: {
    LT: 'h:mm A',
    LTS: 'h:mm:ss A',
    L: 'MM/DD/YYYY',
    LL: 'MMMM [de] D [de] YYYY',
    LLL: 'MMMM [de] D [de] YYYY h:mm A',
    LLLL: 'dddd, MMMM [de] D [de] YYYY h:mm A'
  },
  calendar: {
    sameDay: '[Today at] LT',
    nextDay: '[Tomorrow at] LT',
    nextWeek: 'dddd [at] LT',
    lastDay: '[Yesterday at] LT',
    lastWeek: '[Last] dddd [at] LT',
    sameElse: 'L'
  },
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: 'a few seconds',
    ss: '%d seconds',
    m: 'a minute',
    mm: '%d minutes',
    h: 'an hour',
    hh: '%d hours',
    d: 'a day',
    dd: '%d days',
    M: 'a month',
    MM: '%d months',
    y: 'a year',
    yy: '%d years'
  },
  dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
  ordinal: '%d',
  week: {
    dow: 0,
    doy: 4 // The week that contains Jan 4th is the first week of the year.
  }
};
class DatePickerComponent {
  static {
    this.uniqueId = 0;
  }
  get orientationClass() {
    const isOpenClass = this.showFooter ? 'opened-date-picker-button' : 'closed-date-picker-button';
    return isOpenClass;
  }
  constructor(sanitizer, localeService, cd) {
    this.sanitizer = sanitizer;
    this.localeService = localeService;
    this.cd = cd;
    /* set container for date picker */
    this.datePickerContainer = 'body';
    /* Is the calendar displayed */
    this.isOpen = false;
    /* Determines whether the datepicker opens in in-page mode or in-header mode */
    this.mode = 'page';
    /* Placement of the datepicker */
    this.placement = 'bottom';
    /* Short date format */
    this.shortDateFormat = 'MMM D, YYYY';
    /* Configuration options for the date picker */
    this.dpConfig = new BsDatepickerConfig();
    /* object which provides methods to fetch svg icons */
    this.svgIcons = new SvgIcons(this.sanitizer);
    this.isNotValid = false;
    this.showFooter = false;
    this.onChangedCallback = _ => {}; // eslint-disable-line @typescript-eslint/no-unused-vars
    this.onTouchedCallback = () => {};
    this.setDateValue = date => {
      this.tmpDateValue = null;
      this.dateValue = date;
      this.isNotValid = false;
    };
    this.clearDateValue = () => {
      this.setDateUndefined();
      return this.onChangedCallback(undefined);
    };
    this.setDateUndefined = () => {
      if (this.isDateValid(this.dateValue)) {
        this.tmpDateValue = this.dateValue;
      }
      this.dateValue = undefined;
      this.dayNameText = '';
      this.isNotValid = true;
    };
    this.isDateValid = date => {
      if (date === null || date === undefined || !date.getDay || DEFAULT_LOCALE.weekdaysShort[date.getDay()] === undefined) {
        return false;
      }
      return true;
    };
    this.isDateInRange = date => {
      const mDate = moment(date);
      if (this.minDate && mDate.isBefore(this.minDate)) {
        this.tmpDateValue = this.minDate;
        this.isNotValid = true;
        return false;
      }
      if (this.maxDate && mDate.isAfter(this.maxDate)) {
        this.tmpDateValue = this.maxDate;
        this.isNotValid = true;
        return false;
      }
      return true;
    };
    this.initLocaleData();
  }
  writeValue(obj) {
    if (obj !== undefined && obj !== null) {
      this.setDateValue(obj);
      this.dayNameText = DEFAULT_LOCALE.weekdaysShort[obj.getDay()];
    } else {
      this.setDateValue(null);
      this.dayNameText = null;
    }
  }
  registerOnChange(fn) {
    this.onChangedCallback = fn;
  }
  registerOnTouched(fn) {
    this.onTouchedCallback = fn;
  }
  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
  }
  validate() {
    // reset isNotValid to be valid if date is valid
    return this.isNotValid && {
      invalid: true
    };
  }
  initLocaleData() {
    const momentLocaleData = moment.localeData(navigator.language);
    DEFAULT_LOCALE.months = momentLocaleData.months();
    DEFAULT_LOCALE.monthsShort = momentLocaleData.monthsShort();
    DEFAULT_LOCALE.weekdays = momentLocaleData.weekdays();
    DEFAULT_LOCALE.weekdaysShort = momentLocaleData.weekdaysShort();
    DEFAULT_LOCALE.weekdaysMin = momentLocaleData.weekdaysMin();
    DEFAULT_LOCALE.week.dow = momentLocaleData.firstDayOfWeek();
    DEFAULT_LOCALE.week.doy = momentLocaleData.firstDayOfYear();
    DEFAULT_LOCALE.longDateFormat = {
      ...momentLocaleData._longDateFormat
    };
  }
  setTodayStyle() {
    this.dateCustomClasses.push({
      date: new Date(),
      classes: ['cxone-custom-today']
    });
  }
  ngOnInit() {
    if (this.dateCustomClasses === undefined || this.dateCustomClasses === null) {
      this.dateCustomClasses = [];
    }
    if (this.customToday === true) {
      this.setTodayStyle();
    }
    this.dpConfig = {
      showWeekNumbers: false,
      containerClass: 'theme-nice',
      dateInputFormat: this.shortDateFormat
    };
    if (this.startDOW >= 0) {
      DEFAULT_LOCALE.week.dow = this.startDOW;
    }
    defineLocale('custom', DEFAULT_LOCALE);
    this.localeService.use('custom');
  }
  ngOnChanges(changes) {
    if (changes.startDOW && !changes.startDOW.firstChange) {
      DEFAULT_LOCALE.week.dow = changes.startDOW.currentValue ? changes.startDOW.currentValue : 0;
      defineLocale('custom', DEFAULT_LOCALE);
      this.localeService.use('custom');
    }
  }
  valueChanged(value) {
    this.setTodayStyle();
    if (this.dateValue === value) {
      return;
    }
    if (!this.isDateValid(value)) {
      this.setDateUndefined();
      return this.onChangedCallback(undefined);
    }
    if (this.isDateInRange(value)) {
      this.dayNameText = DEFAULT_LOCALE.weekdaysShort[value.getDay()];
      this.setDateValue(value);
      return this.onChangedCallback(value);
    }
    this.dayNameText = DEFAULT_LOCALE.weekdaysShort[this.tmpDateValue.getDay()];
    return this.onChangedCallback(undefined);
  }
  gotoToday() {
    this.setDateValue(new Date());
    this.dayNameText = DEFAULT_LOCALE.weekdaysShort[this.dateValue.getDay()];
    this.onChangedCallback(new Date());
  }
  previousDay() {
    const date = new Date(this.tmpDateValue || this.dateValue);
    date.setHours(0, 0, 0, 0);
    let minDate;
    if (this.minDate) {
      minDate = new Date(this.minDate.getTime());
      minDate.setHours(0, 0, 0, 0);
    }
    if (!minDate || date > minDate) {
      date.setDate(date.getDate() - 1);
      this.setDateValue(date);
      this.dayNameText = DEFAULT_LOCALE.weekdaysShort[date.getDay()];
      this.onChangedCallback(date);
    } else {
      this.isNotValid = true;
      return this.onChangedCallback(undefined);
    }
  }
  nextDay() {
    const date = new Date(this.tmpDateValue || this.dateValue);
    date.setHours(0, 0, 0, 0);
    let maxDate;
    if (this.maxDate) {
      maxDate = new Date(this.maxDate.getTime());
      maxDate.setHours(0, 0, 0, 0);
    }
    if (!maxDate || date < maxDate) {
      date.setDate(date.getDate() + 1);
      this.setDateValue(date);
      this.dayNameText = DEFAULT_LOCALE.weekdaysShort[date.getDay()];
      this.onChangedCallback(date);
    } else {
      this.isNotValid = true;
      return this.onChangedCallback(undefined);
    }
  }
  makeValidAndToggle(bsDatepicker) {
    // Check if the footer is not shown and the date value is invalid
    if (!this.showFooter && !this.isDateValid(this.dateValue)) {
      // Check if the temporary date value and bsDatepicker value are valid
      const isTmpDateValid = this.tmpDateValue && this.isDateValid(this.tmpDateValue);
      const isBsDateValid = this.isDateValid(bsDatepicker.bsValue);
      // Set the date value to the temporary date value if it's valid
      if (isTmpDateValid && this.innerDatepickerRef._bsValue !== undefined) {
        this.setDateValue(this.tmpDateValue);
      }
      // Set the date value to today if the bsDatepicker value is valid
      else if (isBsDateValid) {
        this.gotoToday();
      }
      // Clear the date value, inner datepicker reference value, and datepicker element value
      this.setDateValue(null);
      this.innerDatepickerRef._bsValue = null;
      bsDatepicker._elementRef.nativeElement.value = null;
    }
    // Toggle the datepicker visibility
    bsDatepicker.toggle();
  }
  onOpen() {
    this.showFooter = true;
    this.positionFooter();
  }
  onClose() {
    this.showFooter = false;
  }
  positionFooter() {
    this.cd.detectChanges();
    const datePickerEl = document.querySelectorAll(this.datePickerContainer + '> bs-datepicker-container .bs-calendar-container');
    const datePickerPopover = document.querySelectorAll(this.datePickerContainer + '> bs-datepicker-container .bs-datepicker');
    if (datePickerEl != null) {
      datePickerEl.forEach(datePicker => {
        datePicker.appendChild(this.footerElRef.nativeElement);
      });
    }
    if (!this.prevNextButtons && !this.dayName) {
      if (datePickerPopover != null) {
        datePickerPopover.forEach(datePicker => {
          datePicker.classList.add('align-dp');
        });
      }
    }
  }
  onTouched() {
    this.onTouchedCallback();
  }
  ngAfterContentChecked() {
    if (!this.datePickerId) {
      DatePickerComponent.uniqueId = DatePickerComponent.uniqueId + 1;
      this.datePickerId = 'cxone-date-picker-' + DatePickerComponent.uniqueId;
    }
  }
  /** @nocollapse */
  static {
    this.ɵfac = function DatePickerComponent_Factory(t) {
      return new (t || DatePickerComponent)(i0.ɵɵdirectiveInject(i1.DomSanitizer), i0.ɵɵdirectiveInject(i2.BsLocaleService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DatePickerComponent,
      selectors: [["cxone-date-picker"]],
      viewQuery: function DatePickerComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c9, 5);
          i0.ɵɵviewQuery(_c10, 5);
          i0.ɵɵviewQuery(_c11, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputElRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerElRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.innerDatepickerRef = _t.first);
        }
      },
      inputs: {
        datePickerContainer: "datePickerContainer",
        dateCustomClasses: "dateCustomClasses",
        datePickerId: "datePickerId",
        dayName: "dayName",
        isOpen: "isOpen",
        maxDate: "maxDate",
        mode: "mode",
        minDate: "minDate",
        placement: "placement",
        prevNextButtons: "prevNextButtons",
        shortDateFormat: "shortDateFormat",
        startDOW: "startDOW",
        customToday: "customToday"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DatePickerComponent),
        multi: true
      }, {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => DatePickerComponent),
        multi: true
      }]), i0.ɵɵNgOnChangesFeature],
      decls: 15,
      vars: 26,
      consts: [[1, "cxone-datepicker-container", 3, "ngClass"], [1, "dp-container"], [1, "controls-wrapper"], ["class", "button-wrapper", "id", "btn-prev", 3, "click", 4, "ngIf"], [1, "input-wrapper"], ["class", "static-value", 3, "for", 4, "ngIf"], ["class", "vertical", 4, "ngIf"], ["type", "text", "bsDatepicker", "", "tabindex", "0", "triggers", "none", 3, "id", "isOpen", "bsConfig", "container", "isDisabled", "minDate", "maxDate", "dateCustomClasses", "placement", "ngModel", "ngModelChange", "onShown", "onHidden", "blur"], ["dp", "bsDatepicker", "inputEl", ""], [1, "button-wrapper", 3, "ngClass", "click"], ["tabindex", "0", 1, "cal", 3, "innerHTML"], ["class", "button-wrapper", "id", "btn-next", 3, "click", 4, "ngIf"], ["class", "dp-footer", 4, "ngIf"], ["id", "btn-prev", 1, "button-wrapper", 3, "click"], ["tabindex", "0", 1, "button-inner", 3, "innerHTML"], [1, "static-value", 3, "for"], [1, "vertical"], ["id", "btn-next", 1, "button-wrapper", 3, "click"], [1, "dp-footer"], ["footerEl", ""], ["tabindex", "0", 3, "click"]],
      template: function DatePickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r14 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
          i0.ɵɵtemplate(3, DatePickerComponent_div_3_Template, 3, 4, "div", 3);
          i0.ɵɵelementStart(4, "div", 4);
          i0.ɵɵtemplate(5, DatePickerComponent_label_5_Template, 2, 2, "label", 5)(6, DatePickerComponent_div_6_Template, 1, 0, "div", 6);
          i0.ɵɵelementStart(7, "input", 7, 8);
          i0.ɵɵlistener("ngModelChange", function DatePickerComponent_Template_input_ngModelChange_7_listener($event) {
            return ctx.valueChanged($event);
          })("onShown", function DatePickerComponent_Template_input_onShown_7_listener() {
            return ctx.onOpen();
          })("onHidden", function DatePickerComponent_Template_input_onHidden_7_listener() {
            return ctx.onClose();
          });
          i0.ɵɵtwoWayListener("ngModelChange", function DatePickerComponent_Template_input_ngModelChange_7_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.dateValue, $event) || (ctx.dateValue = $event);
            return $event;
          });
          i0.ɵɵlistener("blur", function DatePickerComponent_Template_input_blur_7_listener() {
            return ctx.onTouched();
          });
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(10, "div", 9);
          i0.ɵɵlistener("click", function DatePickerComponent_Template_div_click_10_listener() {
            i0.ɵɵrestoreView(_r14);
            const _r3 = i0.ɵɵreference(8);
            return i0.ɵɵresetView(ctx.makeValidAndToggle(_r3));
          });
          i0.ɵɵelement(11, "div", 10);
          i0.ɵɵpipe(12, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(13, DatePickerComponent_div_13_Template, 3, 4, "div", 11);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(14, DatePickerComponent_div_14_Template, 6, 6, "div", 12);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(21, _c12, ctx.disabled, ctx.isNotValid === true, ctx.mode === "header", ctx.mode === "page"));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.prevNextButtons);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.dayName);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.dayName);
          i0.ɵɵadvance();
          i0.ɵɵproperty("id", ctx.datePickerId)("isOpen", ctx.isOpen)("bsConfig", ctx.dpConfig)("container", ctx.datePickerContainer)("isDisabled", ctx.disabled)("minDate", ctx.minDate)("maxDate", ctx.maxDate)("dateCustomClasses", ctx.dateCustomClasses)("placement", ctx.placement);
          i0.ɵɵtwoWayProperty("ngModel", ctx.dateValue);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngClass", ctx.orientationClass);
          i0.ɵɵadvance();
          i0.ɵɵproperty("innerHTML", ctx.svgIcons.getSvgIcons("icon-date"), i0.ɵɵsanitizeHtml);
          i0.ɵɵattribute("ariaLabel", i0.ɵɵpipeBind1(12, 19, "cxone-components.datetimepicker.open"));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.prevNextButtons);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showFooter);
        }
      },
      dependencies: [i3.NgClass, i3.NgIf, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel, i2.BsDatepickerDirective, i2.BsDatepickerInputDirective, i2$1.TranslationPipe],
      styles: [".cxone-custom-today{border:1px solid #2d78c2!important}.cxone-custom-today:hover{background-color:#2d78c2!important;color:#fff!important}.cxone-datepicker-container{position:relative;display:inline-block;font-family:OpenSans;width:100%}.cxone-datepicker-container.page .dp-container .controls-wrapper{border:1px solid #D0D2D3}.cxone-datepicker-container.page .dp-container .controls-wrapper .button-wrapper:nth-child(1){border-right:1px solid #D0D2D3}.cxone-datepicker-container.page .dp-container .controls-wrapper .button-wrapper:nth-child(3){border-left:1px solid #D0D2D3;border-right:1px solid #D0D2D3}.cxone-datepicker-container.invalid .dp-container .controls-wrapper .input-wrapper{border:1px solid rgb(217,33,51)}.cxone-datepicker-container.disabled .dp-container .controls-wrapper{border-color:#dae2e8}.cxone-datepicker-container.disabled .dp-container .controls-wrapper .input-wrapper{background-color:#f8f8f8}.cxone-datepicker-container.disabled .dp-container .controls-wrapper input[type=text]{pointer-events:none;color:#707e8d}.cxone-datepicker-container.disabled .dp-container .controls-wrapper .button-wrapper{pointer-events:none;border-color:#dae2e8;background-color:#f8f8f8}.cxone-datepicker-container.disabled .dp-container .controls-wrapper .button-wrapper .cal svg{fill:#dae2e8}.cxone-datepicker-container.disabled .dp-container .controls-wrapper .button-wrapper .button-inner{background-color:#f8f8f8}.cxone-datepicker-container.disabled .dp-container .controls-wrapper .button-wrapper .button-inner svg{fill:#dae2e8}.dp-container{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;height:35px;position:relative;display:flex;align-items:center;width:100%}.dp-container .controls-wrapper{height:100%;padding:0;margin:0 10px 0 0;display:inline-flex;position:relative;align-items:stretch;background:#fff 0% 0% no-repeat padding-box;box-shadow:0 1px 2px #1f324d33;border-radius:2px;width:100%}.dp-container .controls-wrapper.today{margin-left:10px}.dp-container .controls-wrapper .button-wrapper{cursor:pointer}.dp-container .controls-wrapper .button-wrapper:hover{background:#007cbe}.dp-container .controls-wrapper .button-wrapper:hover .cal svg{fill:#fff}.dp-container .controls-wrapper .button-wrapper:active{background:#f0f7fc}.dp-container .controls-wrapper .button-wrapper.today-button{font-size:13px;padding:8px 15px;height:35px;box-sizing:border-box}.dp-container .controls-wrapper .button-wrapper.today-button .button-inner{color:#046;font-weight:600}.dp-container .controls-wrapper .button-wrapper .cal svg{height:20px;fill:#526b7a;opacity:.8;position:relative;pointer-events:none}.dp-container .controls-wrapper .button-wrapper .button-inner{color:#526b7a;opacity:.8;height:100%;display:flex;align-items:center;width:35px}.dp-container .controls-wrapper .button-wrapper .button-inner svg{height:14px;fill:#526b7a;opacity:.8;pointer-events:none}.dp-container .controls-wrapper .input-wrapper{display:flex;align-items:center;height:100%;flex:1}.dp-container .controls-wrapper .input-wrapper input{border:none;font-size:13px;color:#2e2e2e;width:124px;height:100%;outline:none;background-color:transparent;padding-left:10px}.dp-container .controls-wrapper .input-wrapper input:required{border:none}.dp-container .controls-wrapper .input-wrapper .static-value{color:#2e2e2e;opacity:.5;font-size:13px;line-height:35px;width:45px;margin-bottom:0;padding:0 10px}.dp-container .controls-wrapper .input-wrapper .vertical{border-left:1px solid #D0D2D3;height:25px}.dp-container .controls-wrapper .cal{color:#526b7a;height:100%;display:flex;opacity:.8;align-items:center;justify-content:center;width:35px}.opened-date-picker-button{background:#d9ebf5}.closed-date-picker-button{background:#fff}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatePickerComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-date-picker',
      encapsulation: ViewEncapsulation.None,
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DatePickerComponent),
        multi: true
      }, {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => DatePickerComponent),
        multi: true
      }],
      template: "<div class=\"cxone-datepicker-container\" [ngClass]=\"{ 'disabled': disabled, 'invalid': isNotValid === true, 'header': mode === 'header', 'page': mode === 'page' }\">\n\t<div class=\"dp-container\">\n\t\t<div class=\"controls-wrapper\">\n\t\t\t<div class=\"button-wrapper\" *ngIf=\"prevNextButtons\" (click)=\"previousDay()\" id=\"btn-prev\">\n\t\t\t\t<div class=\"button-inner\" tabindex=\"0\" [attr.ariaLabel]=\"'cxone-components.datetimepicker.prevDay' | translate\" [innerHTML]=\"svgIcons.getSvgIcons('icon-arrow-left')\"></div>\n\t\t\t</div>\n\t\t\t<div class=\"input-wrapper\">\n\t\t\t\t<label [for]=\"datePickerId\" class=\"static-value\" *ngIf=\"dayName\">{{ dayNameText}}</label>\n\t\t\t\t<div class=\"vertical\" *ngIf=\"dayName\"></div>\n\t\t\t\t<input [id]=\"datePickerId\"\n\t\t\t\t       type=\"text\"\n\t\t\t\t\t   #dp=\"bsDatepicker\"\n\t\t\t\t\t   bsDatepicker\n\t\t\t\t\t   [isOpen]=\"isOpen\"\n\t\t\t\t\t   [bsConfig]=\"dpConfig\"\n\t\t\t\t\t   tabindex=\"0\"\n                       [container]=\"datePickerContainer\"\n\t\t\t\t\t   (ngModelChange)=\"valueChanged($event)\"\n\t\t\t\t\t   [isDisabled]=\"disabled\"\n\t\t\t\t\t   [minDate]=\"minDate\"\n\t\t\t\t\t   (onShown)=\"onOpen()\"\n\t\t\t\t\t   [maxDate]=\"maxDate\"\n\t\t\t\t\t   [dateCustomClasses]=\"dateCustomClasses\"\n\t\t\t\t\t   (onHidden)=\"onClose()\"\n\t\t\t\t\t   triggers=\"none\"\n\t\t\t\t\t   [placement]=\"placement\"\n\t\t\t\t\t   [(ngModel)]=\"dateValue\"\n\t\t\t\t\t   (blur)=\"onTouched()\"\n\t\t\t\t\t    #inputEl>\n\t\t\t</div>\n\t\t\t<div class=\"button-wrapper\"  [ngClass]=\"orientationClass\"  (click)=\"makeValidAndToggle(dp);\">\n\t\t\t\t<div class=\"cal\" tabindex=\"0\" [attr.ariaLabel]=\"'cxone-components.datetimepicker.open' | translate\"  [innerHTML]=\"svgIcons.getSvgIcons('icon-date')\"></div>\n\t\t\t</div>\n\t\t\t<div class=\"button-wrapper\" *ngIf=\"prevNextButtons\" (click)=\"nextDay()\" id=\"btn-next\">\n\t\t\t\t<div class=\"button-inner\" tabindex=\"0\" [attr.ariaLabel]=\"'cxone-components.datetimepicker.nextDay' | translate\"  [innerHTML]=\"svgIcons.getSvgIcons('icon-arrow-right')\"></div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"dp-footer\" *ngIf=\"showFooter\" #footerEl>\n\t\t\t<a (click)=\"gotoToday()\" tabindex=\"0\" [attr.ariaLabel]=\"'cxone-components.datetimepicker.today' | translate\">{{ 'cxone-components.datetimepicker.today' | translate}}</a>\n\t\t</div>\n\t</div>\n</div>\n",
      styles: [".cxone-custom-today{border:1px solid #2d78c2!important}.cxone-custom-today:hover{background-color:#2d78c2!important;color:#fff!important}.cxone-datepicker-container{position:relative;display:inline-block;font-family:OpenSans;width:100%}.cxone-datepicker-container.page .dp-container .controls-wrapper{border:1px solid #D0D2D3}.cxone-datepicker-container.page .dp-container .controls-wrapper .button-wrapper:nth-child(1){border-right:1px solid #D0D2D3}.cxone-datepicker-container.page .dp-container .controls-wrapper .button-wrapper:nth-child(3){border-left:1px solid #D0D2D3;border-right:1px solid #D0D2D3}.cxone-datepicker-container.invalid .dp-container .controls-wrapper .input-wrapper{border:1px solid rgb(217,33,51)}.cxone-datepicker-container.disabled .dp-container .controls-wrapper{border-color:#dae2e8}.cxone-datepicker-container.disabled .dp-container .controls-wrapper .input-wrapper{background-color:#f8f8f8}.cxone-datepicker-container.disabled .dp-container .controls-wrapper input[type=text]{pointer-events:none;color:#707e8d}.cxone-datepicker-container.disabled .dp-container .controls-wrapper .button-wrapper{pointer-events:none;border-color:#dae2e8;background-color:#f8f8f8}.cxone-datepicker-container.disabled .dp-container .controls-wrapper .button-wrapper .cal svg{fill:#dae2e8}.cxone-datepicker-container.disabled .dp-container .controls-wrapper .button-wrapper .button-inner{background-color:#f8f8f8}.cxone-datepicker-container.disabled .dp-container .controls-wrapper .button-wrapper .button-inner svg{fill:#dae2e8}.dp-container{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;height:35px;position:relative;display:flex;align-items:center;width:100%}.dp-container .controls-wrapper{height:100%;padding:0;margin:0 10px 0 0;display:inline-flex;position:relative;align-items:stretch;background:#fff 0% 0% no-repeat padding-box;box-shadow:0 1px 2px #1f324d33;border-radius:2px;width:100%}.dp-container .controls-wrapper.today{margin-left:10px}.dp-container .controls-wrapper .button-wrapper{cursor:pointer}.dp-container .controls-wrapper .button-wrapper:hover{background:#007cbe}.dp-container .controls-wrapper .button-wrapper:hover .cal svg{fill:#fff}.dp-container .controls-wrapper .button-wrapper:active{background:#f0f7fc}.dp-container .controls-wrapper .button-wrapper.today-button{font-size:13px;padding:8px 15px;height:35px;box-sizing:border-box}.dp-container .controls-wrapper .button-wrapper.today-button .button-inner{color:#046;font-weight:600}.dp-container .controls-wrapper .button-wrapper .cal svg{height:20px;fill:#526b7a;opacity:.8;position:relative;pointer-events:none}.dp-container .controls-wrapper .button-wrapper .button-inner{color:#526b7a;opacity:.8;height:100%;display:flex;align-items:center;width:35px}.dp-container .controls-wrapper .button-wrapper .button-inner svg{height:14px;fill:#526b7a;opacity:.8;pointer-events:none}.dp-container .controls-wrapper .input-wrapper{display:flex;align-items:center;height:100%;flex:1}.dp-container .controls-wrapper .input-wrapper input{border:none;font-size:13px;color:#2e2e2e;width:124px;height:100%;outline:none;background-color:transparent;padding-left:10px}.dp-container .controls-wrapper .input-wrapper input:required{border:none}.dp-container .controls-wrapper .input-wrapper .static-value{color:#2e2e2e;opacity:.5;font-size:13px;line-height:35px;width:45px;margin-bottom:0;padding:0 10px}.dp-container .controls-wrapper .input-wrapper .vertical{border-left:1px solid #D0D2D3;height:25px}.dp-container .controls-wrapper .cal{color:#526b7a;height:100%;display:flex;opacity:.8;align-items:center;justify-content:center;width:35px}.opened-date-picker-button{background:#d9ebf5}.closed-date-picker-button{background:#fff}\n"]
    }]
  }], () => [{
    type: i1.DomSanitizer
  }, {
    type: i2.BsLocaleService
  }, {
    type: i0.ChangeDetectorRef
  }], {
    datePickerContainer: [{
      type: Input
    }],
    dateCustomClasses: [{
      type: Input
    }],
    datePickerId: [{
      type: Input
    }],
    dayName: [{
      type: Input
    }],
    isOpen: [{
      type: Input
    }],
    maxDate: [{
      type: Input
    }],
    mode: [{
      type: Input
    }],
    minDate: [{
      type: Input
    }],
    placement: [{
      type: Input
    }],
    prevNextButtons: [{
      type: Input
    }],
    shortDateFormat: [{
      type: Input
    }],
    startDOW: [{
      type: Input
    }],
    customToday: [{
      type: Input
    }],
    inputElRef: [{
      type: ViewChild,
      args: ['inputEl', {
        static: false
      }]
    }],
    footerElRef: [{
      type: ViewChild,
      args: ['footerEl', {
        static: false
      }]
    }],
    innerDatepickerRef: [{
      type: ViewChild,
      args: ['dp', {
        static: false
      }]
    }]
  });
})();
const MIN_YEAR = 1970;
class CombinedDatetimePickerComponent {
  /* The minimum selectable date */
  set minDate(value) {
    this._minDate = !value || value.getFullYear() < MIN_YEAR ? new Date(MIN_YEAR, 0) : value;
  }
  get minDate() {
    return this._minDate;
  }
  get orientationClass() {
    const isOpenClass = this.showFooter ? 'opened-date-picker-button' : 'closed-date-picker-button';
    return isOpenClass;
  }
  constructor(domSanitizer, cd, localeService) {
    this.domSanitizer = domSanitizer;
    this.cd = cd;
    this.localeService = localeService;
    /* set container for date time picker */
    this.datetimePickerContainer = 'body';
    /* Determines whether the datepicker opens in in-page mode or in-header mode */
    this.mode = 'page';
    /* flag if we want to remove shadow of date time picker */
    this.removeShadows = false;
    /* Short date time format */
    this.shortDateTimeFormat = 'MMM D, YYYY h:mm:ss A';
    this.timeFormat = 'h:mm A';
    this.realtimeOptionEnabled = false;
    this.forceValidDates = false;
    this.realtimeChange = new EventEmitter();
    /* Configuration options for the date picker */
    this.dpConfig = new BsDatepickerConfig();
    /* object which provides methods to fetch svg icons */
    this.svgIcons = new SvgIcons(this.domSanitizer);
    this.isNotValid = false;
    this.showFooter = false;
    this.isOpen = false;
    this.timePickerAlwaysOpen = false;
    this.customCssClass = [];
    this.lockTimeout = false;
    this.TODAY_REAL_TIME_CLASS = 'real-time-today';
    this.onChangedCallback = _ => {}; // eslint-disable-line @typescript-eslint/no-unused-vars
    this.onTouchedCallback = () => {};
    this.setSelectedDate = date => {
      this.selectedDate = date;
      this.previousValidDate = date;
      this.isNotValid = false;
    };
    this.setSelectedDateUndefined = () => {
      if (this.isDateValid(this.selectedDate)) {
        this.previousValidDate = this.selectedDate;
      }
      this.selectedDate = undefined;
      this.isNotValid = true;
    };
    this.emitDateUndefined = () => {
      if (!this.isNotValid) {
        // callback only first time invalid date entered
        this.onChangedCallback(undefined);
      }
    };
    this.isDateValid = date => {
      if (date === null || date === undefined || isNaN(date.valueOf())) {
        return false;
      }
      if (date.getFullYear() < MIN_YEAR) {
        return false;
      }
      return true;
    };
    this.isDateTimeInRange = date => {
      const mDate = moment(date);
      if (this.minDate && mDate.isBefore(this.minDate, 'minutes')) {
        setTimeout(() => {
          this.writeValue(this.minDate);
          this.isNotValid = true;
        }, 10);
        return false;
      }
      if (this.maxDate && mDate.isAfter(this.maxDate, 'minutes')) {
        setTimeout(() => {
          this.writeValue(this.maxDate);
          this.isNotValid = true;
        }, 10);
        return false;
      }
      return true;
    };
    this.initLocaleData();
  }
  static {
    this.uniqueId = 0;
  }
  static hasTimeOfDayChanged(selectedDate, value) {
    if (selectedDate && value) {
      return selectedDate.getHours() !== value.getHours() || selectedDate.getMinutes() !== value.getMinutes() || selectedDate.getSeconds() !== value.getSeconds();
    }
    return false;
  }
  initLocaleData() {
    const momentLocaleData = moment.localeData(navigator.language);
    DEFAULT_LOCALE.months = momentLocaleData.months();
    DEFAULT_LOCALE.monthsShort = momentLocaleData.monthsShort();
    DEFAULT_LOCALE.weekdays = momentLocaleData.weekdays();
    DEFAULT_LOCALE.weekdaysShort = momentLocaleData.weekdaysShort();
    DEFAULT_LOCALE.weekdaysMin = momentLocaleData.weekdaysMin();
    DEFAULT_LOCALE.week.dow = momentLocaleData.firstDayOfWeek();
    DEFAULT_LOCALE.week.doy = momentLocaleData.firstDayOfYear();
    DEFAULT_LOCALE.longDateFormat = {
      ...momentLocaleData._longDateFormat
    };
  }
  isInArray(dateToClassMapper, date) {
    const timestamp = date.getTime();
    return dateToClassMapper[timestamp] ?? -1;
  }
  createCustomClasses(date1, date2) {
    const customClasses = [];
    const dateToClassMapper = {};
    if (this.dateCustomClasses && this.dateCustomClasses.length !== 0) {
      this.dateCustomClasses.forEach((val, idx) => {
        customClasses.push(Object.assign({}, ObjectUtils.cloneDeep(val)));
        val.date.setHours(0, 0, 0, 0);
        dateToClassMapper[val.date.getTime()] = idx;
      });
    }
    const hlFrom = new Date(date1);
    const hlTo = new Date(date2);
    hlFrom.setHours(0, 0, 0, 0);
    hlTo.setHours(0, 0, 0, 0);
    let selectedDateAtMidnight;
    if (this.selectedDate) {
      selectedDateAtMidnight = new Date(this.selectedDate.getTime());
      selectedDateAtMidnight.setHours(0, 0, 0, 0);
    }
    while (hlFrom <= hlTo) {
      if (selectedDateAtMidnight.getTime() !== hlFrom.getTime()) {
        const inArrayIndex = this.isInArray(dateToClassMapper, new Date(hlFrom));
        if (inArrayIndex > -1) {
          customClasses[inArrayIndex].classes.push(this.highlightClass);
        } else {
          customClasses.push({
            date: new Date(hlFrom),
            classes: [this.highlightClass]
          });
        }
      } else {
        customClasses.push({
          date: new Date(hlFrom),
          classes: ['selected-date']
        });
      }
      hlFrom.setDate(hlFrom.getDate() + 1);
    }
    return customClasses;
  }
  getDateClass(dateValue) {
    let customClasses = [];
    const currentDate = new Date(this.highlightFrom);
    if (dateValue && (!(dateValue < currentDate) || !(dateValue > this.highlightTo))) {
      customClasses = this.createCustomClasses(currentDate, dateValue);
    } else {
      customClasses = this.createCustomClasses(currentDate, this.highlightTo);
    }
    return customClasses;
  }
  ngOnInit() {
    this.dpConfig = {
      showWeekNumbers: false,
      containerClass: 'theme-nice-date-time-picker',
      dateInputFormat: this.shortDateTimeFormat,
      customTodayClass: '',
      withTimepicker: true
    };
    if (!this.selectedDate) {
      this.selectedDate = new Date();
    }
    if (!this.alwaysOpen) {
      this.alwaysOpen = false;
    }
    if (this.minDate) {
      this.minDate.setSeconds(0, 0);
    }
    if (this.maxDate) {
      this.maxDate.setSeconds(0, 0);
    }
    this.selectedTime = moment(this.selectedDate).format(this.timeFormat);
    setTimeout(() => {
      if (this.alwaysOpen) {
        this.isOpen = true;
      }
    });
    defineLocale('custom', DEFAULT_LOCALE);
    this.localeService.use('custom');
    if (this.realtimeOptionEnabled && this.isRealtimeActive) {
      this.toggleRealTimeDateClass();
      const today = new Date();
      this.valueChanged(today);
    } else {
      this.isRealtimeActive = false;
    }
  }
  ngOnDestroy() {
    if (this.datepicker) {
      this.alwaysOpen = false;
      this.datepicker.hide();
    }
  }
  toggleDatePicker(shouldChangeRealTime = false, bsDatepicker = null) {
    if (this.alwaysOpen) {
      if (shouldChangeRealTime && this.isRealtimeActive) {
        // disable the real time only on actual click
        this.setRealtime(false);
      }
      this.isOpen = false;
      setTimeout(() => {
        this.isOpen = true;
      });
    } else {
      if (!this.isOpen && !this.isDateValid(this.selectedDate)) {
        if (this.previousValidDate && this.isDateValid(this.previousValidDate)) {
          this.setSelectedDate(this.previousValidDate);
        } else {
          this.setSelectedDate(new Date());
        }
        setTimeout(() => {
          if (bsDatepicker) {
            bsDatepicker._elementRef.nativeElement.value = '';
          }
        });
      }
      setTimeout(() => {
        this.isOpen = !this.isOpen;
      });
    }
  }
  toggleRealTimeDateClass() {
    if (!this.realtimeOptionEnabled) {
      return;
    }
    if (this.isRealtimeActive) {
      // mark real time in the calendar
      this.dpConfig.customTodayClass = this.TODAY_REAL_TIME_CLASS;
    } else {
      this.dpConfig.customTodayClass = '';
    }
  }
  setRealtime(enable, $event = null) {
    if (!this.realtimeOptionEnabled || this.isRealtimeActive === enable && $event) {
      return;
    }
    const today = new Date();
    this.valueChanged(today);
    this.isRealtimeActive = enable;
    this.toggleRealTimeDateClass();
    this.realtimeChange.emit(this.isRealtimeActive);
  }
  writeValue(obj) {
    if (this.isDateValid(obj)) {
      this.setSelectedDate(obj);
      if (this.datepicker) {
        this.datepicker.bsValueChange.next(this.selectedDate);
      }
    } else {
      this.setSelectedDateUndefined();
    }
  }
  valueChanged(value) {
    if (this.forceValidDates && value && !this.isDateValid(value)) {
      value = this.previousValidDate;
    }
    const isPreviousDateValid = this.isDateValid(this.selectedDate);
    if (this.realtimeOptionEnabled && this.isRealtimeActive && (!isPreviousDateValid || !value || value.getTime() !== this.selectedDate.getTime())) {
      this.isRealtimeActive = false;
      this.realtimeChange.emit(this.isRealtimeActive);
      this.toggleRealTimeDateClass();
    }
    if (!this.isDateValid(value)) {
      this.emitDateUndefined();
      this.setSelectedDateUndefined(); //
    } else if (!this.isDateTimeInRange(value)) {
      // part of error handling is done in the function itself (isDateTimeInRange)
      this.emitDateUndefined();
      this.isNotValid = true;
    } else if (!isPreviousDateValid || this.selectedDate.getTime() !== value.getTime()) {
      this.isNotValid = false;
      this.selectedTime = moment(value).format('h:mm A');
      if (this.highlightClass !== undefined && this.highlightClass !== null) {
        this.customCssClass = this.getDateClass(this.selectedDate);
      }
      this.onChangedCallback(value);
    } else if (this.highlightClass !== undefined && this.highlightClass !== null) {
      setTimeout(() => {
        this.customCssClass = this.getDateClass();
      }, 0);
    }
    if (this.alwaysOpen) {
      this.toggleDatePicker(false);
    }
  }
  validate() {
    return this.isNotValid && {
      invalid: true
    };
  }
  registerOnChange(fn) {
    this.onChangedCallback = fn;
  }
  registerOnTouched(fn) {
    this.onTouchedCallback = fn;
  }
  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
  }
  onTouched() {
    this.onTouchedCallback();
  }
  onTimePickerOpen() {
    this.isOpen = false;
    if (this.alwaysOpen) {
      this.timePickerAlwaysOpen = true;
    }
  }
  setTime(date, hour, minute, second) {
    if (!date) return;
    date.setHours(hour);
    date.setMinutes(minute);
    date.setSeconds(second);
    date.setMilliseconds(0);
    return date;
  }
  updateTimeForDate() {
    const timeObj = moment(this.selectedTime, this.timeFormat);
    const tmpSelectedDate = new Date(this.selectedDate);
    this.setTime(tmpSelectedDate, timeObj.hour(), timeObj.minutes(), timeObj.seconds());
    if (!this.isDateTimeInRange(tmpSelectedDate)) {
      this.emitDateUndefined();
      this.isNotValid = true;
      return;
    }
    this.isNotValid = false;
    this.datepicker.bsValueChange.next(tmpSelectedDate);
    this.setSelectedDate(tmpSelectedDate);
  }
  onOpen() {
    this.showFooter = true;
    if (this.alwaysOpen) {
      this.timePickerAlwaysOpen = false;
    }
    this.positionFooterAndDatepicker();
  }
  onClose() {
    this.showFooter = false;
    if (this.alwaysOpen && !this.timePickerAlwaysOpen && !this.lockTimeout) {
      if (!this.datepicker.isOpen) this.datepicker.show();
      setTimeout(() => {
        if (this.alwaysOpen) {
          this.lockTimeout = true;
          this.datepicker.hide();
          this.datepicker.show();
          this.lockTimeout = false;
        }
      });
    }
  }
  gotoToday() {
    this.setSelectedDate(new Date());
    this.onChangedCallback(new Date());
  }
  positionFooterAndDatepicker() {
    this.cd.detectChanges();
    const datePickerEl = document.querySelectorAll(this.datetimePickerContainer + '> bs-datepicker-container .bs-calendar-container');
    const datePickerContainers = document.querySelectorAll(this.datetimePickerContainer + '> bs-datepicker-container .bs-datepicker');
    if (datePickerEl != null) {
      datePickerEl.forEach(datePicker => {
        datePicker.appendChild(this.footerElRef.nativeElement);
      });
    }
    if (datePickerContainers != null) {
      datePickerContainers.forEach(datePicker => {
        datePicker.classList.add('align-dp');
        if (this.removeShadows) {
          datePicker.classList.add('remove-shadow');
        }
      });
    }
  }
  ngOnChanges(changes) {
    if (changes && changes.highlightFrom && !moment(changes.highlightFrom.currentValue).isSame(moment(changes.highlightFrom.previousValue)) && !changes.highlightFrom.firstChange || changes && changes.highlightTo && !moment(changes.highlightTo.currentValue).isSame(moment(changes.highlightTo.previousValue)) && !changes.highlightTo.firstChange) {
      this.valueChanged(this.selectedDate);
    }
    if (changes && changes.isRealtimeActive) {
      this.toggleRealTimeDateClass();
    }
  }
  ngAfterContentChecked() {
    if (!this.datetimePickerId) {
      CombinedDatetimePickerComponent.uniqueId = CombinedDatetimePickerComponent.uniqueId + 1;
      this.datetimePickerId = 'cxone-date-picker-' + CombinedDatetimePickerComponent.uniqueId;
    }
  }
  /* This function updates isOpen whenever there is a click outside the calIcon area */
  updateIsOpenFlag(event) {
    if (!this.calIcon.nativeElement.contains(event.target) && !this.alwaysOpen) {
      this.isOpen = false;
    }
  }
  /** @nocollapse */
  static {
    this.ɵfac = function CombinedDatetimePickerComponent_Factory(t) {
      return new (t || CombinedDatetimePickerComponent)(i0.ɵɵdirectiveInject(i1.DomSanitizer), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2.BsLocaleService));
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CombinedDatetimePickerComponent,
      selectors: [["cxone-combined-datetime-picker"]],
      viewQuery: function CombinedDatetimePickerComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c10, 5);
          i0.ɵɵviewQuery(_c13, 5);
          i0.ɵɵviewQuery(BsDatepickerDirective, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerElRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.calIcon = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.datepicker = _t.first);
        }
      },
      hostBindings: function CombinedDatetimePickerComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function CombinedDatetimePickerComponent_click_HostBindingHandler($event) {
            return ctx.updateIsOpenFlag($event);
          }, false, i0.ɵɵresolveDocument);
        }
      },
      inputs: {
        minDate: "minDate",
        alwaysOpen: "alwaysOpen",
        datetimePickerId: "datetimePickerId",
        datetimePickerContainer: "datetimePickerContainer",
        dateCustomClasses: "dateCustomClasses",
        highlightFrom: "highlightFrom",
        highlightTo: "highlightTo",
        highlightClass: "highlightClass",
        mode: "mode",
        maxDate: "maxDate",
        removeShadows: "removeShadows",
        shortDateTimeFormat: "shortDateTimeFormat",
        timeFormat: "timeFormat",
        realtimeOptionEnabled: "realtimeOptionEnabled",
        isRealtimeActive: "isRealtimeActive",
        forceValidDates: "forceValidDates"
      },
      outputs: {
        realtimeChange: "realtimeChange"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => CombinedDatetimePickerComponent),
        multi: true
      }, {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => CombinedDatetimePickerComponent),
        multi: true
      }]), i0.ɵɵNgOnChangesFeature],
      decls: 15,
      vars: 29,
      consts: [[1, "cxone-combined-datepicker-wrapper", 3, "ngClass"], [1, "dtp-container"], [1, "controls-wrapper"], [1, "input-wrapper", 3, "ngClass"], ["type", "text", "bsDatepicker", "", "triggers", "none", 3, "bsConfig", "container", "isDisabled", "minDate", "maxDate", "isOpen", "dateCustomClasses", "bsValue", "outsideClick", "bsValueChange", "onShown", "onHidden", "blur"], ["dp", "bsDatepicker"], ["class", "real-time-label", 4, "ngIf"], ["class", "button-wrapper button-item real-time-button", 3, "click", 4, "ngIf"], [1, "button-wrapper", 3, "ngClass", "click"], ["calIcon", ""], [1, "cal", 3, "innerHTML"], [1, "button-wrapper", "time-picker-section"], [3, "steps", "displayAsDuration", "disabled", "mode", "alwaysOpen", "ngModel", "format", "ngModelChange", "timeChanged", "click"], ["class", "dp-footer", 4, "ngIf"], [1, "real-time-label"], [1, "button-wrapper", "button-item", "real-time-button", 3, "click"], [1, "icon-real-time", 3, "innerHTML"], [1, "dp-footer"], ["footerEl", ""], [3, "click"]],
      template: function CombinedDatetimePickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r11 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "input", 4, 5);
          i0.ɵɵlistener("bsValueChange", function CombinedDatetimePickerComponent_Template_input_bsValueChange_4_listener($event) {
            return ctx.valueChanged($event);
          });
          i0.ɵɵtwoWayListener("bsValueChange", function CombinedDatetimePickerComponent_Template_input_bsValueChange_4_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.selectedDate, $event) || (ctx.selectedDate = $event);
            return $event;
          });
          i0.ɵɵlistener("onShown", function CombinedDatetimePickerComponent_Template_input_onShown_4_listener() {
            return ctx.onOpen();
          })("onHidden", function CombinedDatetimePickerComponent_Template_input_onHidden_4_listener() {
            return ctx.onClose();
          })("blur", function CombinedDatetimePickerComponent_Template_input_blur_4_listener() {
            return ctx.onTouched();
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(6, CombinedDatetimePickerComponent_span_6_Template, 3, 3, "span", 6);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(7, CombinedDatetimePickerComponent_div_7_Template, 2, 1, "div", 7);
          i0.ɵɵelementStart(8, "div", 8, 9);
          i0.ɵɵlistener("click", function CombinedDatetimePickerComponent_Template_div_click_8_listener() {
            i0.ɵɵrestoreView(_r11);
            const _r0 = i0.ɵɵreference(5);
            return i0.ɵɵresetView(ctx.toggleDatePicker(ctx.realtimeOptionEnabled, _r0));
          });
          i0.ɵɵelement(10, "div", 10, 9);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(12, "div", 11)(13, "cxone-time-picker", 12);
          i0.ɵɵtwoWayListener("ngModelChange", function CombinedDatetimePickerComponent_Template_cxone_time_picker_ngModelChange_13_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.selectedTime, $event) || (ctx.selectedTime = $event);
            return $event;
          });
          i0.ɵɵlistener("timeChanged", function CombinedDatetimePickerComponent_Template_cxone_time_picker_timeChanged_13_listener() {
            return ctx.updateTimeForDate();
          })("click", function CombinedDatetimePickerComponent_Template_cxone_time_picker_click_13_listener() {
            return ctx.onTimePickerOpen();
          });
          i0.ɵɵelementEnd()()();
          i0.ɵɵtemplate(14, CombinedDatetimePickerComponent_div_14_Template, 5, 3, "div", 13);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction5(23, _c14, ctx.disabled, ctx.mode === "header", ctx.mode === "page", ctx.realtimeOptionEnabled, ctx.isRealtimeActive));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngClass", !ctx.isNotValid ? "" : "error");
          i0.ɵɵadvance();
          i0.ɵɵproperty("bsConfig", ctx.dpConfig)("container", ctx.datetimePickerContainer)("isDisabled", ctx.disabled)("minDate", ctx.minDate)("maxDate", ctx.maxDate)("isOpen", ctx.isOpen)("dateCustomClasses", ctx.customCssClass);
          i0.ɵɵtwoWayProperty("bsValue", ctx.selectedDate);
          i0.ɵɵproperty("outsideClick", !ctx.alwaysOpen);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.isRealtimeActive);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.realtimeOptionEnabled);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", ctx.orientationClass);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("innerHTML", ctx.svgIcons.getSvgIcons("icon-date"), i0.ɵɵsanitizeHtml);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("steps", 30)("displayAsDuration", false)("disabled", ctx.disabled)("mode", ctx.mode)("alwaysOpen", ctx.timePickerAlwaysOpen);
          i0.ɵɵtwoWayProperty("ngModel", ctx.selectedTime);
          i0.ɵɵproperty("format", ctx.timeFormat);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showFooter);
        }
      },
      dependencies: [i3.NgClass, i3.NgIf, i4.NgControlStatus, i4.NgModel, i2.BsDatepickerDirective, i2.BsDatepickerInputDirective, TimePickerComponent, i2$1.TranslationPipe],
      styles: [".cxone-combined-datepicker-wrapper{position:relative;display:inline-block;font-family:OpenSans}.cxone-combined-datepicker-wrapper.page .dtp-container .controls-wrapper{border:1px solid rgb(208,210,211)}.cxone-combined-datepicker-wrapper.page .button-wrapper:nth-child(2){border-left:1px solid rgb(208,210,211);border-right:1px solid rgb(208,210,211)}.cxone-combined-datepicker-wrapper.header .button-item{left:252px!important;top:0!important;border:0px!important;box-shadow:6px 2px 6px #00000017}.cxone-combined-datepicker-wrapper.header .dtp-container{box-shadow:0 2px 6px #00000017}.cxone-combined-datepicker-wrapper.invalid .dtp-container .controls-wrapper .input-wrapper{border:1px solid rgb(217,33,51)}.cxone-combined-datepicker-wrapper.disabled .dtp-container .controls-wrapper{border-color:#dae2e8}.cxone-combined-datepicker-wrapper.disabled .dtp-container .controls-wrapper .input-wrapper{background-color:#f8f8f8}.cxone-combined-datepicker-wrapper.disabled .dtp-container .controls-wrapper input[type=text]{pointer-events:none;color:#707e8d}.cxone-combined-datepicker-wrapper.disabled .dtp-container .controls-wrapper .button-wrapper{pointer-events:none;border-color:#dae2e8;background-color:#f8f8f8}.cxone-combined-datepicker-wrapper.disabled .dtp-container .controls-wrapper .button-wrapper .cal svg,.cxone-combined-datepicker-wrapper.disabled .dtp-container .controls-wrapper .button-wrapper .icon-real-time svg{fill:#dae2e8}.cxone-combined-datepicker-wrapper.disabled .dtp-container .controls-wrapper .button-item{pointer-events:none;border-color:#dae2e8;background-color:#f8f8f8}.cxone-combined-datepicker-wrapper.disabled .dtp-container .controls-wrapper .button-item .icon-time svg{fill:#dae2e8}.selected-date{background-color:#007cbe}.dtp-container{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;height:35px;position:relative;display:flex;align-items:center}.dtp-container .controls-wrapper{height:100%;padding:0;margin:0;display:inline-flex;position:relative;align-items:stretch;background:#fff 0% 0% no-repeat padding-box;border-radius:2px}.dtp-container .controls-wrapper .button-wrapper{cursor:pointer}.dtp-container .controls-wrapper .button-wrapper:hover{background:#f7fafc}.dtp-container .controls-wrapper .button-wrapper:active{background:#f0f7fc}.dtp-container .controls-wrapper .button-wrapper.today-button{font-size:13px;padding:8px 15px;height:35px;box-sizing:border-box}.dtp-container .controls-wrapper .button-wrapper.today-button .button-inner{color:#046;font-weight:600}.dtp-container .controls-wrapper .button-wrapper .icon-real-time svg{width:18px}.dtp-container .controls-wrapper .button-wrapper .cal svg,.dtp-container .controls-wrapper .button-wrapper .icon-real-time svg{height:20px;fill:#93a4aa;position:relative}.dtp-container .controls-wrapper .button-item{background-color:#fff;cursor:pointer}.dtp-container .controls-wrapper .button-item .icon-time{transform:scale(.5);fill:#93a4aa;pointer-events:none}.dtp-container .controls-wrapper .button-item:hover{background-color:#007cbe;border-left:1px solid;border-color:#007cbe}.dtp-container .controls-wrapper .button-item:hover .icon-time{fill:#fff}.dtp-container .controls-wrapper .input-wrapper{align-items:center;height:100%;display:flex}.dtp-container .controls-wrapper .input-wrapper.error{border:solid 1px rgb(217,33,51)}.dtp-container .controls-wrapper .input-wrapper input{border:none;font-size:13px;color:#2e2e2e;height:40px;width:217px;outline:none;background-color:transparent;padding-left:10px}.dtp-container .controls-wrapper .input-wrapper input:required{border:none}.dtp-container .controls-wrapper .input-wrapper .real-time-label{position:absolute;width:183px;height:100%;color:#93a4aa;padding:10px 18px;font-size:13px}.dtp-container .controls-wrapper .cal,.dtp-container .controls-wrapper .icon-real-time{color:#93a4aa;height:100%;display:flex;align-items:center;justify-content:center;width:35px}.dtp-container .controls-wrapper .cal svg,.dtp-container .controls-wrapper .icon-real-time svg{pointer-events:none}.dtp-container .controls-wrapper .cal:hover,.dtp-container .controls-wrapper .icon-real-time:hover{background-color:#007cbe;border-left:1px solid;border-color:#007cbe}.dtp-container .controls-wrapper .cal:hover svg,.dtp-container .controls-wrapper .icon-real-time:hover svg{fill:#fff}.dtp-container .time-picker-section{position:absolute}.dtp-container .time-picker-section .cxone-time-picker .options-wrapper{width:289px;top:35px}.dtp-container .time-picker-section .cxone-time-picker .button-item{position:absolute;left:254px;top:-1px;border:1px solid #D0D2D3;border-left:none;border-top-right-radius:2px;border-bottom-right-radius:2px;display:inline-flex}.dtp-container .time-picker-section .cxone-text-input{display:none}.dtp-container .time-picker-section:hover{background-color:transparent}.real-time-enabled .dtp-container .controls-wrapper .input-wrapper input{margin-right:-34px}.real-time-enabled.real-time-active .real-time-button{background:#d9ebf5}.real-time-enabled.real-time-active .input-wrapper input{visibility:hidden}.real-time-enabled.real-time-active .opened-date-picker-button{background:#fff}.real-time-today{background-color:#0fd9d3!important;background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 24.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 40 35' style='enable-background:new 0 0 40 35;fill:%23fff' xml:space='preserve'%3E%3Cpath d='M33,8h-1V6.5C32,6.22,31.78,6,31.5,6C31.22,6,31,6.22,31,6.5v1.75C31,8.67,31.33,9,31.75,9H33c0.28,0,0.5-0.22,0.5-0.5 C33.5,8.22,33.28,8,33,8z M33.4,4.25c0.34,0.13,0.66,0.29,0.95,0.5l-0.21,0.17c-0.15,0.12-0.12,0.36,0.06,0.43l1.52,0.6 c0.18,0.07,0.37-0.08,0.34-0.27l-0.23-1.61c-0.03-0.19-0.25-0.28-0.4-0.16l-0.26,0.2c-0.42-0.34-0.9-0.61-1.42-0.8 c-1.26-0.46-2.62-0.4-3.84,0.16c-1.22,0.56-2.14,1.56-2.6,2.81c-0.46,1.25-0.41,2.61,0.16,3.82c0.08,0.18,0.27,0.29,0.46,0.29 c0.07,0,0.14-0.01,0.21-0.05c0.25-0.12,0.36-0.41,0.24-0.66c-0.45-0.97-0.5-2.05-0.13-3.06c0.37-1,1.11-1.8,2.08-2.25 C31.3,3.92,32.39,3.88,33.4,4.25z M29.13,10.77c-0.19-0.2-0.51-0.2-0.71-0.01c-0.2,0.19-0.21,0.51-0.01,0.71 c0.24,0.25,0.51,0.47,0.8,0.67c0.09,0.06,0.18,0.09,0.28,0.09c0.16,0,0.32-0.08,0.42-0.22c0.16-0.23,0.1-0.54-0.13-0.69 C29.53,11.15,29.32,10.97,29.13,10.77z M32.15,12c-0.01,0-0.01,0-0.02,0l-0.12,0c-0.24,0-0.48-0.02-0.71-0.06 c-0.28-0.05-0.53,0.13-0.58,0.4c-0.05,0.27,0.13,0.53,0.4,0.58c0.29,0.05,0.59,0.08,0.89,0.08l0.15,0c0.28-0.01,0.49-0.24,0.48-0.52 C32.64,12.21,32.42,12,32.15,12z M36.49,8.81c-0.27-0.08-0.55,0.07-0.62,0.34c-0.08,0.26-0.19,0.52-0.32,0.77 c-0.13,0.24-0.04,0.55,0.2,0.68c0.08,0.04,0.16,0.06,0.24,0.06c0.18,0,0.35-0.09,0.44-0.26c0.17-0.31,0.3-0.63,0.4-0.96 C36.91,9.17,36.75,8.89,36.49,8.81z M34.46,11.17c-0.22,0.17-0.46,0.31-0.71,0.43c-0.25,0.12-0.36,0.42-0.24,0.67 c0.09,0.18,0.27,0.28,0.45,0.28c0.07,0,0.15-0.02,0.22-0.05c0.32-0.15,0.61-0.33,0.89-0.54c0.22-0.17,0.26-0.48,0.09-0.7 C35,11.05,34.68,11.01,34.46,11.17z M36.89,6.82c-0.07-0.27-0.34-0.43-0.61-0.37c-0.27,0.07-0.43,0.34-0.37,0.6 C35.95,7.2,35.98,7.35,36,7.5c0.03,0.25,0.25,0.44,0.5,0.44c0.02,0,0.04,0,0.06,0c0.27-0.03,0.47-0.29,0.43-0.56 C36.97,7.19,36.94,7,36.89,6.82z'/%3E%3C/svg%3E%0A\")}.opened-date-picker-button{background:#d9ebf5}.closed-date-picker-button{background:#fff}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CombinedDatetimePickerComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-combined-datetime-picker',
      encapsulation: ViewEncapsulation.None,
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => CombinedDatetimePickerComponent),
        multi: true
      }, {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => CombinedDatetimePickerComponent),
        multi: true
      }],
      template: "<div class=\"cxone-combined-datepicker-wrapper\"\n     [ngClass]=\"{ 'disabled': disabled,\n                  'header': mode === 'header',\n                  'page': mode === 'page',\n                  'real-time-enabled':realtimeOptionEnabled,\n                  'real-time-active': isRealtimeActive }\">\n  <div class=\"dtp-container\">\n    <div class=\"controls-wrapper\">\n      <div class = \"input-wrapper\" [ngClass]=\"(!isNotValid)?(''):('error')\">\n        <input type=\"text\"\n               #dp=\"bsDatepicker\"\n               bsDatepicker\n               [bsConfig]=\"dpConfig\"\n               [container]=\"datetimePickerContainer\"\n               (bsValueChange)=\"valueChanged($event)\"\n               [isDisabled]=\"disabled\"\n               [minDate]=\"minDate\"\n               [maxDate]=\"maxDate\"\n               [isOpen]=\"isOpen\"\n               [dateCustomClasses]=\"customCssClass\"\n               triggers=\"none\"\n               [(bsValue)]=\"selectedDate\"\n               [outsideClick]=\"!alwaysOpen\"\n               (onShown)=\"onOpen()\"\n               (onHidden)=\"onClose()\"\n               (blur)=\"onTouched()\">\n        <span *ngIf=\"isRealtimeActive\"\n              class=\"real-time-label\">{{ 'cxone-components.datetimepicker.realtime' | translate }}</span>\n      </div>\n      <div *ngIf=\"realtimeOptionEnabled\"\n           class=\"button-wrapper button-item real-time-button\"\n           (click)=\"setRealtime(true, $event)\">\n          <div class=\"icon-real-time\"\n               [innerHTML]=\"svgIcons.getSvgIcons('icon-real-time')\"></div>\n      </div>\n      <div class=\"button-wrapper\"\n           [ngClass]=\"orientationClass\"\n           (click)=\"toggleDatePicker(realtimeOptionEnabled, dp)\"\n           #calIcon>\n        <div class=\"cal\"\n             [innerHTML]=\"svgIcons.getSvgIcons('icon-date')\"\n             #calIcon></div>\n      </div>\n      <div class=\"button-wrapper time-picker-section\">\n        <cxone-time-picker [steps]=\"30\"\n                           [displayAsDuration]=\"false\"\n                           [disabled]=\"disabled\"\n                           [mode]=\"mode\"\n                           [alwaysOpen]=\"timePickerAlwaysOpen\"\n                           [(ngModel)]=\"selectedTime\"\n                           [format]=\"timeFormat\"\n                           (timeChanged)=\"updateTimeForDate()\"\n                           (click)=\"onTimePickerOpen()\"></cxone-time-picker>\n      </div>\n    </div>\n    <div class=\"dp-footer\"\n         *ngIf=\"showFooter\"\n         #footerEl>\n      <a (click)=\"gotoToday()\">{{ 'cxone-components.datetimepicker.today' | translate }}</a>\n    </div>\n  </div>\n</div>\n",
      styles: [".cxone-combined-datepicker-wrapper{position:relative;display:inline-block;font-family:OpenSans}.cxone-combined-datepicker-wrapper.page .dtp-container .controls-wrapper{border:1px solid rgb(208,210,211)}.cxone-combined-datepicker-wrapper.page .button-wrapper:nth-child(2){border-left:1px solid rgb(208,210,211);border-right:1px solid rgb(208,210,211)}.cxone-combined-datepicker-wrapper.header .button-item{left:252px!important;top:0!important;border:0px!important;box-shadow:6px 2px 6px #00000017}.cxone-combined-datepicker-wrapper.header .dtp-container{box-shadow:0 2px 6px #00000017}.cxone-combined-datepicker-wrapper.invalid .dtp-container .controls-wrapper .input-wrapper{border:1px solid rgb(217,33,51)}.cxone-combined-datepicker-wrapper.disabled .dtp-container .controls-wrapper{border-color:#dae2e8}.cxone-combined-datepicker-wrapper.disabled .dtp-container .controls-wrapper .input-wrapper{background-color:#f8f8f8}.cxone-combined-datepicker-wrapper.disabled .dtp-container .controls-wrapper input[type=text]{pointer-events:none;color:#707e8d}.cxone-combined-datepicker-wrapper.disabled .dtp-container .controls-wrapper .button-wrapper{pointer-events:none;border-color:#dae2e8;background-color:#f8f8f8}.cxone-combined-datepicker-wrapper.disabled .dtp-container .controls-wrapper .button-wrapper .cal svg,.cxone-combined-datepicker-wrapper.disabled .dtp-container .controls-wrapper .button-wrapper .icon-real-time svg{fill:#dae2e8}.cxone-combined-datepicker-wrapper.disabled .dtp-container .controls-wrapper .button-item{pointer-events:none;border-color:#dae2e8;background-color:#f8f8f8}.cxone-combined-datepicker-wrapper.disabled .dtp-container .controls-wrapper .button-item .icon-time svg{fill:#dae2e8}.selected-date{background-color:#007cbe}.dtp-container{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;height:35px;position:relative;display:flex;align-items:center}.dtp-container .controls-wrapper{height:100%;padding:0;margin:0;display:inline-flex;position:relative;align-items:stretch;background:#fff 0% 0% no-repeat padding-box;border-radius:2px}.dtp-container .controls-wrapper .button-wrapper{cursor:pointer}.dtp-container .controls-wrapper .button-wrapper:hover{background:#f7fafc}.dtp-container .controls-wrapper .button-wrapper:active{background:#f0f7fc}.dtp-container .controls-wrapper .button-wrapper.today-button{font-size:13px;padding:8px 15px;height:35px;box-sizing:border-box}.dtp-container .controls-wrapper .button-wrapper.today-button .button-inner{color:#046;font-weight:600}.dtp-container .controls-wrapper .button-wrapper .icon-real-time svg{width:18px}.dtp-container .controls-wrapper .button-wrapper .cal svg,.dtp-container .controls-wrapper .button-wrapper .icon-real-time svg{height:20px;fill:#93a4aa;position:relative}.dtp-container .controls-wrapper .button-item{background-color:#fff;cursor:pointer}.dtp-container .controls-wrapper .button-item .icon-time{transform:scale(.5);fill:#93a4aa;pointer-events:none}.dtp-container .controls-wrapper .button-item:hover{background-color:#007cbe;border-left:1px solid;border-color:#007cbe}.dtp-container .controls-wrapper .button-item:hover .icon-time{fill:#fff}.dtp-container .controls-wrapper .input-wrapper{align-items:center;height:100%;display:flex}.dtp-container .controls-wrapper .input-wrapper.error{border:solid 1px rgb(217,33,51)}.dtp-container .controls-wrapper .input-wrapper input{border:none;font-size:13px;color:#2e2e2e;height:40px;width:217px;outline:none;background-color:transparent;padding-left:10px}.dtp-container .controls-wrapper .input-wrapper input:required{border:none}.dtp-container .controls-wrapper .input-wrapper .real-time-label{position:absolute;width:183px;height:100%;color:#93a4aa;padding:10px 18px;font-size:13px}.dtp-container .controls-wrapper .cal,.dtp-container .controls-wrapper .icon-real-time{color:#93a4aa;height:100%;display:flex;align-items:center;justify-content:center;width:35px}.dtp-container .controls-wrapper .cal svg,.dtp-container .controls-wrapper .icon-real-time svg{pointer-events:none}.dtp-container .controls-wrapper .cal:hover,.dtp-container .controls-wrapper .icon-real-time:hover{background-color:#007cbe;border-left:1px solid;border-color:#007cbe}.dtp-container .controls-wrapper .cal:hover svg,.dtp-container .controls-wrapper .icon-real-time:hover svg{fill:#fff}.dtp-container .time-picker-section{position:absolute}.dtp-container .time-picker-section .cxone-time-picker .options-wrapper{width:289px;top:35px}.dtp-container .time-picker-section .cxone-time-picker .button-item{position:absolute;left:254px;top:-1px;border:1px solid #D0D2D3;border-left:none;border-top-right-radius:2px;border-bottom-right-radius:2px;display:inline-flex}.dtp-container .time-picker-section .cxone-text-input{display:none}.dtp-container .time-picker-section:hover{background-color:transparent}.real-time-enabled .dtp-container .controls-wrapper .input-wrapper input{margin-right:-34px}.real-time-enabled.real-time-active .real-time-button{background:#d9ebf5}.real-time-enabled.real-time-active .input-wrapper input{visibility:hidden}.real-time-enabled.real-time-active .opened-date-picker-button{background:#fff}.real-time-today{background-color:#0fd9d3!important;background-image:url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 24.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 40 35' style='enable-background:new 0 0 40 35;fill:%23fff' xml:space='preserve'%3E%3Cpath d='M33,8h-1V6.5C32,6.22,31.78,6,31.5,6C31.22,6,31,6.22,31,6.5v1.75C31,8.67,31.33,9,31.75,9H33c0.28,0,0.5-0.22,0.5-0.5 C33.5,8.22,33.28,8,33,8z M33.4,4.25c0.34,0.13,0.66,0.29,0.95,0.5l-0.21,0.17c-0.15,0.12-0.12,0.36,0.06,0.43l1.52,0.6 c0.18,0.07,0.37-0.08,0.34-0.27l-0.23-1.61c-0.03-0.19-0.25-0.28-0.4-0.16l-0.26,0.2c-0.42-0.34-0.9-0.61-1.42-0.8 c-1.26-0.46-2.62-0.4-3.84,0.16c-1.22,0.56-2.14,1.56-2.6,2.81c-0.46,1.25-0.41,2.61,0.16,3.82c0.08,0.18,0.27,0.29,0.46,0.29 c0.07,0,0.14-0.01,0.21-0.05c0.25-0.12,0.36-0.41,0.24-0.66c-0.45-0.97-0.5-2.05-0.13-3.06c0.37-1,1.11-1.8,2.08-2.25 C31.3,3.92,32.39,3.88,33.4,4.25z M29.13,10.77c-0.19-0.2-0.51-0.2-0.71-0.01c-0.2,0.19-0.21,0.51-0.01,0.71 c0.24,0.25,0.51,0.47,0.8,0.67c0.09,0.06,0.18,0.09,0.28,0.09c0.16,0,0.32-0.08,0.42-0.22c0.16-0.23,0.1-0.54-0.13-0.69 C29.53,11.15,29.32,10.97,29.13,10.77z M32.15,12c-0.01,0-0.01,0-0.02,0l-0.12,0c-0.24,0-0.48-0.02-0.71-0.06 c-0.28-0.05-0.53,0.13-0.58,0.4c-0.05,0.27,0.13,0.53,0.4,0.58c0.29,0.05,0.59,0.08,0.89,0.08l0.15,0c0.28-0.01,0.49-0.24,0.48-0.52 C32.64,12.21,32.42,12,32.15,12z M36.49,8.81c-0.27-0.08-0.55,0.07-0.62,0.34c-0.08,0.26-0.19,0.52-0.32,0.77 c-0.13,0.24-0.04,0.55,0.2,0.68c0.08,0.04,0.16,0.06,0.24,0.06c0.18,0,0.35-0.09,0.44-0.26c0.17-0.31,0.3-0.63,0.4-0.96 C36.91,9.17,36.75,8.89,36.49,8.81z M34.46,11.17c-0.22,0.17-0.46,0.31-0.71,0.43c-0.25,0.12-0.36,0.42-0.24,0.67 c0.09,0.18,0.27,0.28,0.45,0.28c0.07,0,0.15-0.02,0.22-0.05c0.32-0.15,0.61-0.33,0.89-0.54c0.22-0.17,0.26-0.48,0.09-0.7 C35,11.05,34.68,11.01,34.46,11.17z M36.89,6.82c-0.07-0.27-0.34-0.43-0.61-0.37c-0.27,0.07-0.43,0.34-0.37,0.6 C35.95,7.2,35.98,7.35,36,7.5c0.03,0.25,0.25,0.44,0.5,0.44c0.02,0,0.04,0,0.06,0c0.27-0.03,0.47-0.29,0.43-0.56 C36.97,7.19,36.94,7,36.89,6.82z'/%3E%3C/svg%3E%0A\")}.opened-date-picker-button{background:#d9ebf5}.closed-date-picker-button{background:#fff}\n"]
    }]
  }], () => [{
    type: i1.DomSanitizer
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i2.BsLocaleService
  }], {
    minDate: [{
      type: Input
    }],
    alwaysOpen: [{
      type: Input
    }],
    datetimePickerId: [{
      type: Input
    }],
    datetimePickerContainer: [{
      type: Input
    }],
    dateCustomClasses: [{
      type: Input
    }],
    highlightFrom: [{
      type: Input
    }],
    highlightTo: [{
      type: Input
    }],
    highlightClass: [{
      type: Input
    }],
    mode: [{
      type: Input
    }],
    maxDate: [{
      type: Input
    }],
    removeShadows: [{
      type: Input
    }],
    shortDateTimeFormat: [{
      type: Input
    }],
    timeFormat: [{
      type: Input
    }],
    realtimeOptionEnabled: [{
      type: Input
    }],
    isRealtimeActive: [{
      type: Input
    }],
    forceValidDates: [{
      type: Input
    }],
    realtimeChange: [{
      type: Output
    }],
    footerElRef: [{
      type: ViewChild,
      args: ['footerEl', {
        static: false
      }]
    }],
    calIcon: [{
      type: ViewChild,
      args: ['calIcon', {
        static: false
      }]
    }],
    datepicker: [{
      type: ViewChild,
      args: [BsDatepickerDirective, {
        static: false
      }]
    }],
    updateIsOpenFlag: [{
      type: HostListener,
      args: ['document:click', ['$event']]
    }]
  });
})();
class DateRange {
  transform(value, shortDateFormat) {
    const f = new Date(value);
    f.setDate(value.getDate() - value.getDay());
    const l = new Date(f);
    l.setDate(f.getDate() + 6);
    return `${moment(f).format(shortDateFormat)} - ${moment(l).format(shortDateFormat)}`;
  }
  /** @nocollapse */
  static {
    this.ɵfac = function DateRange_Factory(t) {
      return new (t || DateRange)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "dateRange",
      type: DateRange,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateRange, [{
    type: Pipe,
    args: [{
      name: 'dateRange'
    }]
  }], null, null);
})();
class WeekPickerComponent {
  static {
    this.uniqueId = 0;
  }
  set setStartDOW(num) {
    this.startDOW = num;
  }
  get orientationClass() {
    const isOpenClass = this.showFooter ? 'opened-date-picker-button' : 'closed-date-picker-button';
    return isOpenClass;
  }
  constructor(sanitizer, localeService, cd) {
    this.sanitizer = sanitizer;
    this.localeService = localeService;
    this.cd = cd;
    /* set container for week picker */
    this.weekPickerContainer = 'body';
    /* Is the calendar displayed */
    this.isOpen = false;
    /* Determines whether the datepicker opens in in-page mode or in-header mode */
    this.mode = 'page';
    /* Placement of the datepicker */
    this.placement = 'bottom';
    this.shortDateFormat = 'MMM DD, YYYY';
    /* Configuration options for the date picker */
    this.config = {
      showWeekNumbers: false,
      selectFromOtherMonth: true,
      containerClass: 'theme-nice-week-picker',
      dateInputFormat: this.shortDateFormat,
      isAnimated: true,
      dateCustomClasses: []
    };
    /* object which provides methods to fetch svg icons */
    this.svgIcons = new SvgIcons(this.sanitizer);
    this.isNotValid = true;
    this.showFooter = false;
    this.onChangedCallback = _ => {}; // eslint-disable-line @typescript-eslint/no-unused-vars
    this.onTouchedCallback = () => {};
    this.config.isAnimated = true;
    this.config.dateCustomClasses = [];
    this.today = new Date();
    this.startDOW = this.startDOW !== null && this.startDOW !== undefined ? this.startDOW : 0;
    this.dateValue = this.getStartDOW(new Date());
  }
  // directive methods
  clearSelections() {
    this.config.dateCustomClasses = [];
  }
  isAvailableDate(value) {
    return (!this.minDate || value >= this.minDate) && (!this.maxDate || value <= this.maxDate) && (!this.config.datesDisabled || this.config.datesDisabled.filter(e => this.compareDates(e, value)).length === 0) && (!this.config.daysDisabled || this.config.daysDisabled.filter(e => e === value.getDay()).length === 0);
  }
  compareDates(d1, d2) {
    return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate() ? true : false;
  }
  isDateSelected(value) {
    return this.config.dateCustomClasses.filter(e => this.compareDates(e.date, value)).length === 0 ? false : true;
  }
  selectDate(value) {
    if (this.isAvailableDate(value)) {
      this.config.dateCustomClasses.push({
        date: value,
        classes: ['current-selected-date-background']
      });
      return true;
    }
    return false;
  }
  selectWeek(value) {
    const indexes = [0, 1, 2, 3, 4, 5, 6];
    indexes.forEach(i => {
      const d = this.getStartDOW(value);
      d.setDate(d.getDate() + i);
      this.selectDate(d);
    });
  }
  writeValue(obj) {
    if (obj !== null && obj !== undefined) {
      const f = this.getStartDOW(obj);
      this.dateValue = new Date(f);
      if (!this.isDateSelected(this.dateValue)) {
        this.clearSelections();
        this.selectWeek(obj);
      }
    }
  }
  registerOnChange(fn) {
    this.onChangedCallback = fn;
  }
  registerOnTouched(fn) {
    this.onTouchedCallback = fn;
  }
  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
  }
  validate({
    value
  }) {
    this.isNotValid = value === undefined ? true : false;
    return this.isNotValid && {
      invalid: true
    };
  }
  initLocaleData() {
    moment.locale(this.language || navigator.language);
    const momentLocaleData = moment.localeData(this.language || navigator.language);
    DEFAULT_LOCALE.months = momentLocaleData.months();
    DEFAULT_LOCALE.monthsShort = momentLocaleData.monthsShort();
    DEFAULT_LOCALE.weekdays = momentLocaleData.weekdays();
    DEFAULT_LOCALE.weekdaysShort = momentLocaleData.weekdaysShort();
    DEFAULT_LOCALE.weekdaysMin = momentLocaleData.weekdaysMin();
    DEFAULT_LOCALE.week.dow = momentLocaleData.firstDayOfWeek();
    DEFAULT_LOCALE.week.doy = momentLocaleData.firstDayOfYear();
    DEFAULT_LOCALE.longDateFormat = {
      ...momentLocaleData._longDateFormat
    };
  }
  ngOnInit() {
    this.initLocaleData();
    this.dateValue = new Date();
    if (this.startDOW > 0 || this.startDOW === 0) {
      DEFAULT_LOCALE.week.dow = this.startDOW;
      this.today = new Date();
    }
    defineLocale('custom', DEFAULT_LOCALE);
    this.localeService.use('custom');
  }
  ngOnChanges(changes) {
    if (changes.startDOW && !changes.startDOW.firstChange) {
      DEFAULT_LOCALE.week.dow = changes.startDOW.currentValue ? changes.startDOW.currentValue : 0;
      defineLocale('custom', DEFAULT_LOCALE);
      this.localeService.use('custom');
    }
  }
  valueChanged(value) {
    if (value === null || value === undefined || DEFAULT_LOCALE.weekdaysShort[value.getDay()] === undefined) {
      this.dateValue = undefined;
    } else if (this.isAvailableDate(value)) {
      this.writeValue(value);
      this.onChangedCallback(this.dateValue);
    }
  }
  gotoCurrentWeek() {
    this.valueChanged(new Date());
  }
  moveToDate(range) {
    const date = new Date(this.dateValue);
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() + range);
    this.valueChanged(date);
  }
  onOpen() {
    this.showFooter = true;
    this.positionFooter();
  }
  onClose() {
    this.showFooter = false;
  }
  positionFooter() {
    this.cd.detectChanges();
    const datePickerEl = document.querySelector(this.weekPickerContainer + ' > bs-datepicker-container .bs-calendar-container');
    if (datePickerEl != null) {
      datePickerEl.appendChild(this.footerElRef.nativeElement);
    }
  }
  onTouched() {
    this.onTouchedCallback();
  }
  ngAfterContentChecked() {
    if (!this.datePickerId) {
      WeekPickerComponent.uniqueId = WeekPickerComponent.uniqueId + 1;
      this.datePickerId = 'cxone-date-picker-' + WeekPickerComponent.uniqueId;
    }
  }
  getStartDOW(date) {
    const d = new Date(date);
    d.setDate(date.getDate() - date.getDay() + this.startDOW);
    return d;
  }
  /** @nocollapse */
  static {
    this.ɵfac = function WeekPickerComponent_Factory(t) {
      return new (t || WeekPickerComponent)(i0.ɵɵdirectiveInject(i1.DomSanitizer), i0.ɵɵdirectiveInject(i2.BsLocaleService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: WeekPickerComponent,
      selectors: [["cxone-week-picker"]],
      viewQuery: function WeekPickerComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c9, 5);
          i0.ɵɵviewQuery(_c10, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputElRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerElRef = _t.first);
        }
      },
      inputs: {
        weekPickerContainer: "weekPickerContainer",
        dateCustomClasses: "dateCustomClasses",
        datePickerId: "datePickerId",
        isOpen: "isOpen",
        maxDate: "maxDate",
        mode: "mode",
        minDate: "minDate",
        placement: "placement",
        prevNextButtons: "prevNextButtons",
        shortDateFormat: "shortDateFormat",
        language: "language",
        startDOW: "startDOW"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => WeekPickerComponent),
        multi: true
      }, {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => WeekPickerComponent),
        multi: true
      }]), i0.ɵɵNgOnChangesFeature],
      decls: 14,
      vars: 26,
      consts: [[1, "cxone-weekpicker-container", 3, "ngClass"], [1, "dp-container"], [1, "controls-wrapper"], ["class", "button-wrapper", "id", "btn-prev", 3, "click", 4, "ngIf"], [1, "input-wrapper"], ["type", "text", "bsDatepicker", "", "triggers", "none", "readonly", "", 1, "cxone-weekpicker-startDOW", 3, "id", "container", "isOpen", "bsConfig", "isDisabled", "minDate", "maxDate", "dateCustomClasses", "placement", "ngModel", "ngModelChange", "onShown", "onHidden", "blur", "click"], ["dp", "bsDatepicker", "inputEl", ""], ["readonly", "", 1, "cxone-weekpicker-DateRange", 3, "ngModel", "click"], [1, "button-wrapper", 3, "ngClass", "click"], [1, "cal", 3, "innerHTML"], ["class", "button-wrapper", "id", "btn-next", 3, "click", 4, "ngIf"], ["class", "dp-footer", 4, "ngIf"], ["id", "btn-prev", 1, "button-wrapper", 3, "click"], [1, "button-inner", 3, "innerHTML"], ["id", "btn-next", 1, "button-wrapper", 3, "click"], [1, "dp-footer"], ["footerEl", ""], [3, "click"]],
      template: function WeekPickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r12 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
          i0.ɵɵtemplate(3, WeekPickerComponent_div_3_Template, 2, 1, "div", 3);
          i0.ɵɵelementStart(4, "div", 4)(5, "input", 5, 6);
          i0.ɵɵlistener("ngModelChange", function WeekPickerComponent_Template_input_ngModelChange_5_listener($event) {
            return ctx.valueChanged($event);
          })("onShown", function WeekPickerComponent_Template_input_onShown_5_listener() {
            return ctx.onOpen();
          })("onHidden", function WeekPickerComponent_Template_input_onHidden_5_listener() {
            return ctx.onClose();
          });
          i0.ɵɵtwoWayListener("ngModelChange", function WeekPickerComponent_Template_input_ngModelChange_5_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.dateValue, $event) || (ctx.dateValue = $event);
            return $event;
          });
          i0.ɵɵlistener("blur", function WeekPickerComponent_Template_input_blur_5_listener() {
            return ctx.onTouched();
          })("click", function WeekPickerComponent_Template_input_click_5_listener() {
            i0.ɵɵrestoreView(_r12);
            const _r1 = i0.ɵɵreference(6);
            return i0.ɵɵresetView(_r1.toggle());
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(8, "input", 7);
          i0.ɵɵlistener("click", function WeekPickerComponent_Template_input_click_8_listener() {
            i0.ɵɵrestoreView(_r12);
            const _r1 = i0.ɵɵreference(6);
            return i0.ɵɵresetView(_r1.toggle());
          });
          i0.ɵɵpipe(9, "dateRange");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(10, "div", 8);
          i0.ɵɵlistener("click", function WeekPickerComponent_Template_div_click_10_listener() {
            i0.ɵɵrestoreView(_r12);
            const _r1 = i0.ɵɵreference(6);
            return i0.ɵɵresetView(_r1.toggle());
          });
          i0.ɵɵelement(11, "div", 9);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(12, WeekPickerComponent_div_12_Template, 2, 1, "div", 10);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(13, WeekPickerComponent_div_13_Template, 5, 3, "div", 11);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(21, _c15, ctx.disabled, ctx.isNotValid === true, ctx.mode === "header", ctx.mode === "page"));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.prevNextButtons);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("id", ctx.datePickerId)("container", ctx.weekPickerContainer)("isOpen", ctx.isOpen)("bsConfig", ctx.config)("isDisabled", ctx.disabled)("minDate", ctx.minDate)("maxDate", ctx.maxDate)("dateCustomClasses", ctx.dateCustomClasses)("placement", ctx.placement);
          i0.ɵɵtwoWayProperty("ngModel", ctx.dateValue);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngModel", i0.ɵɵpipeBind2(9, 18, ctx.dateValue, ctx.shortDateFormat));
          i0.ɵɵattribute("disabled", ctx.disabled);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngClass", ctx.orientationClass);
          i0.ɵɵadvance();
          i0.ɵɵproperty("innerHTML", ctx.svgIcons.getSvgIcons("icon-date"), i0.ɵɵsanitizeHtml);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.prevNextButtons);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showFooter);
        }
      },
      dependencies: [i3.NgClass, i3.NgIf, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel, i2.BsDatepickerDirective, i2.BsDatepickerInputDirective, i2$1.TranslationPipe, DateRange],
      styles: [".cxone-custom-today{border:1px solid #2d78c2!important}.cxone-custom-today:hover{background-color:#2d78c2!important;color:#fff!important}.cxone-datepicker-container{position:relative;display:inline-block;font-family:OpenSans;width:100%}.cxone-datepicker-container.page .dp-container .controls-wrapper{border:1px solid #D0D2D3}.cxone-datepicker-container.page .dp-container .controls-wrapper .button-wrapper:nth-child(1){border-right:1px solid #D0D2D3}.cxone-datepicker-container.page .dp-container .controls-wrapper .button-wrapper:nth-child(3){border-left:1px solid #D0D2D3;border-right:1px solid #D0D2D3}.cxone-datepicker-container.invalid .dp-container .controls-wrapper .input-wrapper{border:1px solid rgb(217,33,51)}.cxone-datepicker-container.disabled .dp-container .controls-wrapper{border-color:#dae2e8}.cxone-datepicker-container.disabled .dp-container .controls-wrapper .input-wrapper{background-color:#f8f8f8}.cxone-datepicker-container.disabled .dp-container .controls-wrapper input[type=text]{pointer-events:none;color:#707e8d}.cxone-datepicker-container.disabled .dp-container .controls-wrapper .button-wrapper{pointer-events:none;border-color:#dae2e8;background-color:#f8f8f8}.cxone-datepicker-container.disabled .dp-container .controls-wrapper .button-wrapper .cal svg{fill:#dae2e8}.cxone-datepicker-container.disabled .dp-container .controls-wrapper .button-wrapper .button-inner{background-color:#f8f8f8}.cxone-datepicker-container.disabled .dp-container .controls-wrapper .button-wrapper .button-inner svg{fill:#dae2e8}.dp-container{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;height:35px;position:relative;display:flex;align-items:center;width:100%}.dp-container .controls-wrapper{height:100%;padding:0;margin:0 10px 0 0;display:inline-flex;position:relative;align-items:stretch;background:#fff 0% 0% no-repeat padding-box;box-shadow:0 1px 2px #1f324d33;border-radius:2px;width:100%}.dp-container .controls-wrapper.today{margin-left:10px}.dp-container .controls-wrapper .button-wrapper{cursor:pointer}.dp-container .controls-wrapper .button-wrapper:hover{background:#007cbe}.dp-container .controls-wrapper .button-wrapper:hover .cal svg{fill:#fff}.dp-container .controls-wrapper .button-wrapper:active{background:#f0f7fc}.dp-container .controls-wrapper .button-wrapper.today-button{font-size:13px;padding:8px 15px;height:35px;box-sizing:border-box}.dp-container .controls-wrapper .button-wrapper.today-button .button-inner{color:#046;font-weight:600}.dp-container .controls-wrapper .button-wrapper .cal svg{height:20px;fill:#526b7a;opacity:.8;position:relative;pointer-events:none}.dp-container .controls-wrapper .button-wrapper .button-inner{color:#526b7a;opacity:.8;height:100%;display:flex;align-items:center;width:35px}.dp-container .controls-wrapper .button-wrapper .button-inner svg{height:14px;fill:#526b7a;opacity:.8;pointer-events:none}.dp-container .controls-wrapper .input-wrapper{display:flex;align-items:center;height:100%;flex:1}.dp-container .controls-wrapper .input-wrapper input{border:none;font-size:13px;color:#2e2e2e;width:124px;height:100%;outline:none;background-color:transparent;padding-left:10px}.dp-container .controls-wrapper .input-wrapper input:required{border:none}.dp-container .controls-wrapper .input-wrapper .static-value{color:#2e2e2e;opacity:.5;font-size:13px;line-height:35px;width:45px;margin-bottom:0;padding:0 10px}.dp-container .controls-wrapper .input-wrapper .vertical{border-left:1px solid #D0D2D3;height:25px}.dp-container .controls-wrapper .cal{color:#526b7a;height:100%;display:flex;opacity:.8;align-items:center;justify-content:center;width:35px}.cxone-weekpicker-container{position:relative;display:inline-block;min-width:300px;font-family:OpenSans}.cxone-weekpicker-container.page .dp-container .controls-wrapper .input-wrapper,.cxone-weekpicker-container.header .dp-container .controls-wrapper .input-wrapper{display:block;position:relative}.cxone-weekpicker-container.page .dp-container .controls-wrapper .input-wrapper .cxone-weekpicker-startDOW,.cxone-weekpicker-container.header .dp-container .controls-wrapper .input-wrapper .cxone-weekpicker-startDOW{color:#fff;opacity:0;width:100%;margin-left:0;left:9px;position:absolute;padding:0;text-align:center}.cxone-weekpicker-container.page .dp-container .controls-wrapper .input-wrapper .cxone-weekpicker-startDOW:hover,.cxone-weekpicker-container.header .dp-container .controls-wrapper .input-wrapper .cxone-weekpicker-startDOW:hover{cursor:pointer}.cxone-weekpicker-container.page .dp-container .controls-wrapper .input-wrapper .cxone-weekpicker-DateRange,.cxone-weekpicker-container.header .dp-container .controls-wrapper .input-wrapper .cxone-weekpicker-DateRange{width:100%;margin-left:0;padding:0;text-align:center}.cxone-weekpicker-container.page .dp-container .controls-wrapper .input-wrapper .cxone-weekpicker-DateRange:hover,.cxone-weekpicker-container.header .dp-container .controls-wrapper .input-wrapper .cxone-weekpicker-DateRange:hover{cursor:pointer}.cxone-weekpicker-container.page .dp-container .controls-wrapper{border:1px solid #D0D2D3}.cxone-weekpicker-container.page .dp-container .controls-wrapper .button-wrapper:nth-child(1){border-right:1px solid #D0D2D3}.cxone-weekpicker-container.page .dp-container .controls-wrapper .button-wrapper:nth-child(3){border-left:1px solid #D0D2D3;border-right:1px solid #D0D2D3}.cxone-weekpicker-container.invalid .dp-container .controls-wrapper .input-wrapper{border:1px solid rgb(217,33,51)}.cxone-weekpicker-container.disabled .dp-container .controls-wrapper{border-color:#dae2e8}.cxone-weekpicker-container.disabled .dp-container .controls-wrapper .input-wrapper{background-color:#f8f8f8}.cxone-weekpicker-container.disabled .dp-container .controls-wrapper input[type=text]{pointer-events:none;color:#707e8d}.cxone-weekpicker-container.disabled .dp-container .controls-wrapper .button-wrapper{pointer-events:none;border-color:#dae2e8;background-color:#f8f8f8}.cxone-weekpicker-container.disabled .dp-container .controls-wrapper .button-wrapper .cal svg{fill:#dae2e8}.cxone-weekpicker-container.disabled .dp-container .controls-wrapper .button-wrapper .button-inner{background-color:#f8f8f8}.cxone-weekpicker-container.disabled .dp-container .controls-wrapper .button-wrapper .button-inner svg{fill:#dae2e8}bs-datepicker-container{top:8px}bs-datepicker-container .bs-datepicker{font-family:OpenSans!important;box-shadow:0 2px 6px #0000001a;border:1px solid rgb(208,210,211);height:332px}bs-datepicker-container .bs-datepicker.theme-nice-week-picker{margin-left:16px}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container{padding:0!important}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .dp-footer{font-size:13px;position:relative;top:10px;cursor:pointer;text-align:center}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .dp-footer a{font-size:12px;color:#2e2e2e}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container bs-days-calendar-view .bs-datepicker-head bs-datepicker-navigation-view button.current:nth-child(2) span{float:right}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container bs-days-calendar-view .bs-datepicker-head bs-datepicker-navigation-view button.current:nth-child(3) span{float:left;padding-left:5px}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-head{height:45px;background-color:#fff;padding:0;border-bottom:1px solid rgb(208,210,211);display:flex;flex-direction:column;justify-content:center}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-head bs-datepicker-navigation-view{display:flex;justify-content:space-between;align-items:center}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-head bs-datepicker-navigation-view button{padding:0}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-head bs-datepicker-navigation-view button:hover{background-color:transparent}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-head bs-datepicker-navigation-view button.previous{color:#93a4aa;float:left;background:none}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-head bs-datepicker-navigation-view button.next{color:#93a4aa;float:right;background:none}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-head bs-datepicker-navigation-view button.current{color:#2e2e2e;font-size:14px;flex:1}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body{padding:0;border-radius:0;border:0}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table{border-collapse:collapse}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table thead tr{height:35px;border-bottom:1px solid rgb(208,210,211)}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table thead tr th{color:#5b7c8c;font-size:12px;font-weight:600;text-transform:uppercase;vertical-align:middle}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table tbody{border-bottom:1px solid rgb(208,210,211)}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table tbody td span.selected{background:none}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table tbody td span.selected.current-selected-date-background{background-color:#2d78c2;color:#fff}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table tbody td span.selected.current-selected-date-background:hover{background-color:#2d78c2;color:#fff}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table tbody td{height:35px;vertical-align:middle}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table tbody td.is-highlighted span{border-radius:0%;background-color:transparent}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table tbody td span{border-radius:0;margin:0;height:100%;width:100%}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table tbody td span:not(.is-other-month):not(.is-other-month.disabled){color:#2e2e2e}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table tbody td span.selected{background-color:#d9ebf5;border-radius:0;color:#2e2e2e}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table tbody td span:hover:not(.is-other-month):not(.disabled):not(.is-other-month):not(.selected){color:#fff;background-color:#007cbe;border-radius:0}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.days tr:hover td :not(.disabled),bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.days tr:hover td span .is-highlighted .selected,bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.days tr:hover td span .selected .is-highlighted,bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table .weeks tr:hover td :not(.disabled),bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table .weeks tr:hover td span .is-highlighted .selected,bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table .weeks tr:hover td span .selected .is-highlighted{background:#237bc2!important;color:#fff!important}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.days tr:hover td .disabled,bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table .weeks tr:hover td .disabled{background:none}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.months tbody td{width:75px}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.months tbody td span{line-height:50px}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.years tbody tr:hover{background:none}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.years tbody tr td span{line-height:62px}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.days tbody td{width:35px}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.days tbody td span{line-height:35px}bs-datepicker-container .bs-datepicker.theme-nice-week-picker.align-dp{left:36px;top:-4px;width:290px}bs-datepicker-container .bs-datepicker.theme-nice-week-picker.align-dp .bs-datepicker-body{min-width:288px}.current-selected-date-background{background:#2d78c2;color:#fff}.current-selected-date-background:hover{background-color:#2d78c2;color:#fff}.opened-date-picker-button{background:#d9ebf5}.closed-date-picker-button{background:#fff}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WeekPickerComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-week-picker',
      encapsulation: ViewEncapsulation.None,
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => WeekPickerComponent),
        multi: true
      }, {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => WeekPickerComponent),
        multi: true
      }],
      template: "<div\n  class=\"cxone-weekpicker-container\"\n  [ngClass]=\"{\n    disabled: disabled,\n    invalid: isNotValid === true,\n    header: mode === 'header',\n    page: mode === 'page'\n  }\"\n>\n  <div class=\"dp-container\">\n    <div class=\"controls-wrapper\" >\n      <div class=\"button-wrapper\"\n        *ngIf=\"prevNextButtons\"\n        (click)=\"moveToDate(-7)\"\n        id=\"btn-prev\"\n      >\n        <div\n          class=\"button-inner\"\n          [innerHTML]=\"svgIcons.getSvgIcons('icon-arrow-left')\"\n        ></div>\n      </div>\n      <div class=\"input-wrapper\">\n        <input class=\"cxone-weekpicker-startDOW\"\n          [id]=\"datePickerId\"\n          type=\"text\"\n          #dp=\"bsDatepicker\"\n          bsDatepicker\n          [container]=\"weekPickerContainer\"\n          [isOpen]=\"isOpen\"\n          [bsConfig]=\"config\"\n          (ngModelChange)=\"valueChanged($event)\"\n          [isDisabled]=\"disabled\"\n          [minDate]=\"minDate\"\n          (onShown)=\"onOpen()\"\n          [maxDate]=\"maxDate\"\n          [dateCustomClasses]=\"dateCustomClasses\"\n          (onHidden)=\"onClose()\"\n          triggers=\"none\"\n          [placement]=\"placement\"\n          [(ngModel)]=\"dateValue\"\n          (blur)=\"onTouched()\"\n          #inputEl\n          readonly\n          (click)=\"dp.toggle()\"\n        />\n        <input class=\"cxone-weekpicker-DateRange\"\n          [ngModel]=\"dateValue | dateRange: shortDateFormat\"\n          [attr.disabled]=\"disabled\"\n          readonly\n          (click)=\"dp.toggle()\"\n        />\n      </div>\n      <div class=\"button-wrapper\" [ngClass]=\"orientationClass\" (click)=\"dp.toggle()\">\n        <div class=\"cal\" [innerHTML]=\"svgIcons.getSvgIcons('icon-date')\"></div>\n      </div>\n      <div class=\"button-wrapper\"\n        *ngIf=\"prevNextButtons\"\n        (click)=\"moveToDate(7)\"\n        id=\"btn-next\"\n      >\n        <div\n          class=\"button-inner\"\n          [innerHTML]=\"svgIcons.getSvgIcons('icon-arrow-right')\"\n        ></div>\n      </div>\n    </div>\n\n    <div class=\"dp-footer\" *ngIf=\"showFooter\" #footerEl>\n      <a (click)=\"gotoCurrentWeek()\">{{ \"cxone-components.datetimepicker.today\" | translate }}</a>\n    </div>\n  </div>\n</div>\n",
      styles: [".cxone-custom-today{border:1px solid #2d78c2!important}.cxone-custom-today:hover{background-color:#2d78c2!important;color:#fff!important}.cxone-datepicker-container{position:relative;display:inline-block;font-family:OpenSans;width:100%}.cxone-datepicker-container.page .dp-container .controls-wrapper{border:1px solid #D0D2D3}.cxone-datepicker-container.page .dp-container .controls-wrapper .button-wrapper:nth-child(1){border-right:1px solid #D0D2D3}.cxone-datepicker-container.page .dp-container .controls-wrapper .button-wrapper:nth-child(3){border-left:1px solid #D0D2D3;border-right:1px solid #D0D2D3}.cxone-datepicker-container.invalid .dp-container .controls-wrapper .input-wrapper{border:1px solid rgb(217,33,51)}.cxone-datepicker-container.disabled .dp-container .controls-wrapper{border-color:#dae2e8}.cxone-datepicker-container.disabled .dp-container .controls-wrapper .input-wrapper{background-color:#f8f8f8}.cxone-datepicker-container.disabled .dp-container .controls-wrapper input[type=text]{pointer-events:none;color:#707e8d}.cxone-datepicker-container.disabled .dp-container .controls-wrapper .button-wrapper{pointer-events:none;border-color:#dae2e8;background-color:#f8f8f8}.cxone-datepicker-container.disabled .dp-container .controls-wrapper .button-wrapper .cal svg{fill:#dae2e8}.cxone-datepicker-container.disabled .dp-container .controls-wrapper .button-wrapper .button-inner{background-color:#f8f8f8}.cxone-datepicker-container.disabled .dp-container .controls-wrapper .button-wrapper .button-inner svg{fill:#dae2e8}.dp-container{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;height:35px;position:relative;display:flex;align-items:center;width:100%}.dp-container .controls-wrapper{height:100%;padding:0;margin:0 10px 0 0;display:inline-flex;position:relative;align-items:stretch;background:#fff 0% 0% no-repeat padding-box;box-shadow:0 1px 2px #1f324d33;border-radius:2px;width:100%}.dp-container .controls-wrapper.today{margin-left:10px}.dp-container .controls-wrapper .button-wrapper{cursor:pointer}.dp-container .controls-wrapper .button-wrapper:hover{background:#007cbe}.dp-container .controls-wrapper .button-wrapper:hover .cal svg{fill:#fff}.dp-container .controls-wrapper .button-wrapper:active{background:#f0f7fc}.dp-container .controls-wrapper .button-wrapper.today-button{font-size:13px;padding:8px 15px;height:35px;box-sizing:border-box}.dp-container .controls-wrapper .button-wrapper.today-button .button-inner{color:#046;font-weight:600}.dp-container .controls-wrapper .button-wrapper .cal svg{height:20px;fill:#526b7a;opacity:.8;position:relative;pointer-events:none}.dp-container .controls-wrapper .button-wrapper .button-inner{color:#526b7a;opacity:.8;height:100%;display:flex;align-items:center;width:35px}.dp-container .controls-wrapper .button-wrapper .button-inner svg{height:14px;fill:#526b7a;opacity:.8;pointer-events:none}.dp-container .controls-wrapper .input-wrapper{display:flex;align-items:center;height:100%;flex:1}.dp-container .controls-wrapper .input-wrapper input{border:none;font-size:13px;color:#2e2e2e;width:124px;height:100%;outline:none;background-color:transparent;padding-left:10px}.dp-container .controls-wrapper .input-wrapper input:required{border:none}.dp-container .controls-wrapper .input-wrapper .static-value{color:#2e2e2e;opacity:.5;font-size:13px;line-height:35px;width:45px;margin-bottom:0;padding:0 10px}.dp-container .controls-wrapper .input-wrapper .vertical{border-left:1px solid #D0D2D3;height:25px}.dp-container .controls-wrapper .cal{color:#526b7a;height:100%;display:flex;opacity:.8;align-items:center;justify-content:center;width:35px}.cxone-weekpicker-container{position:relative;display:inline-block;min-width:300px;font-family:OpenSans}.cxone-weekpicker-container.page .dp-container .controls-wrapper .input-wrapper,.cxone-weekpicker-container.header .dp-container .controls-wrapper .input-wrapper{display:block;position:relative}.cxone-weekpicker-container.page .dp-container .controls-wrapper .input-wrapper .cxone-weekpicker-startDOW,.cxone-weekpicker-container.header .dp-container .controls-wrapper .input-wrapper .cxone-weekpicker-startDOW{color:#fff;opacity:0;width:100%;margin-left:0;left:9px;position:absolute;padding:0;text-align:center}.cxone-weekpicker-container.page .dp-container .controls-wrapper .input-wrapper .cxone-weekpicker-startDOW:hover,.cxone-weekpicker-container.header .dp-container .controls-wrapper .input-wrapper .cxone-weekpicker-startDOW:hover{cursor:pointer}.cxone-weekpicker-container.page .dp-container .controls-wrapper .input-wrapper .cxone-weekpicker-DateRange,.cxone-weekpicker-container.header .dp-container .controls-wrapper .input-wrapper .cxone-weekpicker-DateRange{width:100%;margin-left:0;padding:0;text-align:center}.cxone-weekpicker-container.page .dp-container .controls-wrapper .input-wrapper .cxone-weekpicker-DateRange:hover,.cxone-weekpicker-container.header .dp-container .controls-wrapper .input-wrapper .cxone-weekpicker-DateRange:hover{cursor:pointer}.cxone-weekpicker-container.page .dp-container .controls-wrapper{border:1px solid #D0D2D3}.cxone-weekpicker-container.page .dp-container .controls-wrapper .button-wrapper:nth-child(1){border-right:1px solid #D0D2D3}.cxone-weekpicker-container.page .dp-container .controls-wrapper .button-wrapper:nth-child(3){border-left:1px solid #D0D2D3;border-right:1px solid #D0D2D3}.cxone-weekpicker-container.invalid .dp-container .controls-wrapper .input-wrapper{border:1px solid rgb(217,33,51)}.cxone-weekpicker-container.disabled .dp-container .controls-wrapper{border-color:#dae2e8}.cxone-weekpicker-container.disabled .dp-container .controls-wrapper .input-wrapper{background-color:#f8f8f8}.cxone-weekpicker-container.disabled .dp-container .controls-wrapper input[type=text]{pointer-events:none;color:#707e8d}.cxone-weekpicker-container.disabled .dp-container .controls-wrapper .button-wrapper{pointer-events:none;border-color:#dae2e8;background-color:#f8f8f8}.cxone-weekpicker-container.disabled .dp-container .controls-wrapper .button-wrapper .cal svg{fill:#dae2e8}.cxone-weekpicker-container.disabled .dp-container .controls-wrapper .button-wrapper .button-inner{background-color:#f8f8f8}.cxone-weekpicker-container.disabled .dp-container .controls-wrapper .button-wrapper .button-inner svg{fill:#dae2e8}bs-datepicker-container{top:8px}bs-datepicker-container .bs-datepicker{font-family:OpenSans!important;box-shadow:0 2px 6px #0000001a;border:1px solid rgb(208,210,211);height:332px}bs-datepicker-container .bs-datepicker.theme-nice-week-picker{margin-left:16px}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container{padding:0!important}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .dp-footer{font-size:13px;position:relative;top:10px;cursor:pointer;text-align:center}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .dp-footer a{font-size:12px;color:#2e2e2e}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container bs-days-calendar-view .bs-datepicker-head bs-datepicker-navigation-view button.current:nth-child(2) span{float:right}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container bs-days-calendar-view .bs-datepicker-head bs-datepicker-navigation-view button.current:nth-child(3) span{float:left;padding-left:5px}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-head{height:45px;background-color:#fff;padding:0;border-bottom:1px solid rgb(208,210,211);display:flex;flex-direction:column;justify-content:center}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-head bs-datepicker-navigation-view{display:flex;justify-content:space-between;align-items:center}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-head bs-datepicker-navigation-view button{padding:0}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-head bs-datepicker-navigation-view button:hover{background-color:transparent}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-head bs-datepicker-navigation-view button.previous{color:#93a4aa;float:left;background:none}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-head bs-datepicker-navigation-view button.next{color:#93a4aa;float:right;background:none}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-head bs-datepicker-navigation-view button.current{color:#2e2e2e;font-size:14px;flex:1}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body{padding:0;border-radius:0;border:0}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table{border-collapse:collapse}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table thead tr{height:35px;border-bottom:1px solid rgb(208,210,211)}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table thead tr th{color:#5b7c8c;font-size:12px;font-weight:600;text-transform:uppercase;vertical-align:middle}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table tbody{border-bottom:1px solid rgb(208,210,211)}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table tbody td span.selected{background:none}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table tbody td span.selected.current-selected-date-background{background-color:#2d78c2;color:#fff}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table tbody td span.selected.current-selected-date-background:hover{background-color:#2d78c2;color:#fff}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table tbody td{height:35px;vertical-align:middle}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table tbody td.is-highlighted span{border-radius:0%;background-color:transparent}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table tbody td span{border-radius:0;margin:0;height:100%;width:100%}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table tbody td span:not(.is-other-month):not(.is-other-month.disabled){color:#2e2e2e}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table tbody td span.selected{background-color:#d9ebf5;border-radius:0;color:#2e2e2e}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table tbody td span:hover:not(.is-other-month):not(.disabled):not(.is-other-month):not(.selected){color:#fff;background-color:#007cbe;border-radius:0}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.days tr:hover td :not(.disabled),bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.days tr:hover td span .is-highlighted .selected,bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.days tr:hover td span .selected .is-highlighted,bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table .weeks tr:hover td :not(.disabled),bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table .weeks tr:hover td span .is-highlighted .selected,bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table .weeks tr:hover td span .selected .is-highlighted{background:#237bc2!important;color:#fff!important}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.days tr:hover td .disabled,bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table .weeks tr:hover td .disabled{background:none}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.months tbody td{width:75px}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.months tbody td span{line-height:50px}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.years tbody tr:hover{background:none}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.years tbody tr td span{line-height:62px}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.days tbody td{width:35px}bs-datepicker-container .bs-datepicker.theme-nice-week-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.days tbody td span{line-height:35px}bs-datepicker-container .bs-datepicker.theme-nice-week-picker.align-dp{left:36px;top:-4px;width:290px}bs-datepicker-container .bs-datepicker.theme-nice-week-picker.align-dp .bs-datepicker-body{min-width:288px}.current-selected-date-background{background:#2d78c2;color:#fff}.current-selected-date-background:hover{background-color:#2d78c2;color:#fff}.opened-date-picker-button{background:#d9ebf5}.closed-date-picker-button{background:#fff}\n"]
    }]
  }], () => [{
    type: i1.DomSanitizer
  }, {
    type: i2.BsLocaleService
  }, {
    type: i0.ChangeDetectorRef
  }], {
    weekPickerContainer: [{
      type: Input
    }],
    dateCustomClasses: [{
      type: Input
    }],
    datePickerId: [{
      type: Input
    }],
    isOpen: [{
      type: Input
    }],
    maxDate: [{
      type: Input
    }],
    mode: [{
      type: Input
    }],
    minDate: [{
      type: Input
    }],
    placement: [{
      type: Input
    }],
    prevNextButtons: [{
      type: Input
    }],
    shortDateFormat: [{
      type: Input
    }],
    language: [{
      type: Input
    }],
    startDOW: [{
      type: Input
    }],
    inputElRef: [{
      type: ViewChild,
      args: ['inputEl', {
        static: false
      }]
    }],
    footerElRef: [{
      type: ViewChild,
      args: ['footerEl', {
        static: false
      }]
    }]
  });
})();
class DatetimePickerComponent {
  get orientationClass() {
    const dayNameClass = this.dayName ? 'with-day-name' : 'no-day-name';
    return [this.orientation, dayNameClass];
  }
  constructor(domSanitizer, cd, localeService) {
    this.domSanitizer = domSanitizer;
    this.cd = cd;
    this.localeService = localeService;
    /* set container for date time picker */
    this.datetimePickerContainer = 'body';
    /* Determines whether the datepicker opens in in-page mode or in-header mode */
    this.mode = 'page';
    /* Determines whether the controls are in a line ('horizontal') or one on top of the other ('vertical' - default) */
    this.orientation = 'vertical';
    /* Short date format */
    this.shortDateFormat = 'MMM D, YYYY';
    this.timeFormat = 'h:mm A';
    this.addLeds = false;
    this.steps = 30;
    this.activeLedDays = [];
    this.isValidTime = new EventEmitter();
    /* Configuration options for the date picker */
    this.dpConfig = new BsDatepickerConfig();
    /* object which provides methods to fetch svg icons */
    this.svgIcons = new SvgIcons(this.domSanitizer);
    this.isNotValid = true;
    this.customCssClass = [];
    this.onChangedCallback = _ => {}; // eslint-disable-line @typescript-eslint/no-unused-vars
    this.onTouchedCallback = () => {};
    this.initLocaleData();
  }
  initLocaleData() {
    const momentLocaleData = moment.localeData(navigator.language);
    DEFAULT_LOCALE.months = momentLocaleData.months();
    DEFAULT_LOCALE.monthsShort = momentLocaleData.monthsShort();
    DEFAULT_LOCALE.weekdays = momentLocaleData.weekdays();
    DEFAULT_LOCALE.weekdaysShort = momentLocaleData.weekdaysShort();
    DEFAULT_LOCALE.weekdaysMin = momentLocaleData.weekdaysMin();
    DEFAULT_LOCALE.week.dow = momentLocaleData.firstDayOfWeek();
    DEFAULT_LOCALE.week.doy = momentLocaleData.firstDayOfYear();
    DEFAULT_LOCALE.longDateFormat = {
      ...momentLocaleData._longDateFormat
    };
  }
  ngOnInit() {
    this.dpConfig = {
      showWeekNumbers: false,
      containerClass: 'theme-nice-date-time-picker',
      dateInputFormat: this.shortDateFormat
    };
    if (!this.selectedDate) {
      this.selectedDate = new Date();
      this.selectedTime = moment(this.selectedDate).format(this.timeFormat);
    }
    if (this.addLeds) {
      this.customCssClass = this.activeLedDays;
    }
    defineLocale('custom', DEFAULT_LOCALE);
    this.localeService.use('custom');
    this.autoCorrectTime = this.autoCorrectTime ? true : false;
  }
  writeValue(obj) {
    if (obj !== null) {
      this.selectedDate = obj;
      this.selectedTime = moment(obj).format(this.timeFormat);
    }
  }
  valueChanged(value) {
    if (value === null || value === undefined || isNaN(value.valueOf())) {
      this.selectedDate = undefined;
      this.onChangedCallback(value);
    } else if (!this.selectedDate || this.selectedDate.getTime() !== value.getTime()) {
      if (this.selectedTime) {
        const t = moment(this.selectedTime, this.timeFormat);
        if (t) {
          this.setTime(value, t.hour(), t.minute(), t.second());
        }
      }
      const newSelectedDate = new Date(value);
      setTimeout(() => {
        this.selectedDate = new Date(newSelectedDate);
        this.writeValue(new Date(newSelectedDate));
        this.onChangedCallback(newSelectedDate);
      });
    }
  }
  validate({
    value
  }) {
    this.isNotValid = value === undefined;
    return this.isNotValid && {
      invalid: true
    };
  }
  registerOnChange(fn) {
    this.onChangedCallback = fn;
  }
  registerOnTouched(fn) {
    this.onTouchedCallback = fn;
  }
  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
  }
  onTouched() {
    this.onTouchedCallback();
  }
  setTime(date, hour, minute, second) {
    date.setHours(hour);
    date.setMinutes(minute);
    date.setSeconds(second);
    date.setMilliseconds(0);
    return date;
  }
  updateTimeForDate() {
    if (!this.selectedDate) {
      return;
    }
    if (this.selectedTime !== undefined) {
      this.setTime(this.selectedDate, 0, 0, 0);
      const timeObj = moment(this.selectedTime, this.timeFormat);
      this.setTime(this.selectedDate, timeObj.hour(), timeObj.minutes(), timeObj.seconds());
      this.selectedDate = new Date(this.selectedDate);
      this.onChangedCallback(this.selectedDate);
      this.isValidTime.emit(true);
    } else {
      this.isNotValid = false;
      this.isValidTime.emit(false);
    }
  }
  ngOnChanges() {
    if (this.addLeds) {
      this.customCssClass = this.activeLedDays;
    } else {
      this.customCssClass = [];
    }
  }
  /** @nocollapse */
  static {
    this.ɵfac = function DatetimePickerComponent_Factory(t) {
      return new (t || DatetimePickerComponent)(i0.ɵɵdirectiveInject(i1.DomSanitizer), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2.BsLocaleService));
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DatetimePickerComponent,
      selectors: [["cxone-datetime-picker"]],
      viewQuery: function DatetimePickerComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(DatePickerComponent, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.datePicker = _t.first);
        }
      },
      inputs: {
        datetimePickerContainer: "datetimePickerContainer",
        mode: "mode",
        orientation: "orientation",
        minDate: "minDate",
        maxDate: "maxDate",
        shortDateFormat: "shortDateFormat",
        timeFormat: "timeFormat",
        dayName: "dayName",
        addLeds: "addLeds",
        steps: "steps",
        autoCorrectTime: "autoCorrectTime",
        activeLedDays: "activeLedDays"
      },
      outputs: {
        isValidTime: "isValidTime"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DatetimePickerComponent),
        multi: true
      }, {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => DatetimePickerComponent),
        multi: true
      }]), i0.ɵɵNgOnChangesFeature],
      decls: 4,
      vars: 23,
      consts: [[1, "cxone-datepicker-wrapper", 3, "ngClass"], [1, "dtp-container", 3, "ngClass"], [3, "mode", "format", "ngModel", "steps", "displayAsDuration", "disabled", "autoCorrectTime", "ngModelChange", "timeChanged"], [3, "maxDate", "datePickerContainer", "minDate", "mode", "dayName", "shortDateFormat", "dateCustomClasses", "disabled", "ngModel", "ngModelChange"]],
      template: function DatetimePickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "cxone-time-picker", 2);
          i0.ɵɵtwoWayListener("ngModelChange", function DatetimePickerComponent_Template_cxone_time_picker_ngModelChange_2_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.selectedTime, $event) || (ctx.selectedTime = $event);
            return $event;
          });
          i0.ɵɵlistener("timeChanged", function DatetimePickerComponent_Template_cxone_time_picker_timeChanged_2_listener() {
            return ctx.updateTimeForDate();
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "cxone-date-picker", 3);
          i0.ɵɵlistener("ngModelChange", function DatetimePickerComponent_Template_cxone_date_picker_ngModelChange_3_listener($event) {
            return ctx.valueChanged($event);
          });
          i0.ɵɵtwoWayListener("ngModelChange", function DatetimePickerComponent_Template_cxone_date_picker_ngModelChange_3_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.selectedDate, $event) || (ctx.selectedDate = $event);
            return $event;
          });
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(19, _c16, ctx.disabled, ctx.mode === "header", ctx.mode === "page"));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", ctx.orientationClass);
          i0.ɵɵadvance();
          i0.ɵɵproperty("mode", ctx.mode)("format", ctx.timeFormat);
          i0.ɵɵtwoWayProperty("ngModel", ctx.selectedTime);
          i0.ɵɵproperty("steps", ctx.steps)("displayAsDuration", false)("disabled", ctx.disabled)("autoCorrectTime", ctx.autoCorrectTime);
          i0.ɵɵadvance();
          i0.ɵɵproperty("maxDate", ctx.maxDate)("datePickerContainer", ctx.datetimePickerContainer)("minDate", ctx.minDate)("mode", ctx.mode)("dayName", ctx.dayName)("shortDateFormat", ctx.shortDateFormat)("dateCustomClasses", ctx.customCssClass)("disabled", ctx.disabled)("dayName", ctx.dayName);
          i0.ɵɵtwoWayProperty("ngModel", ctx.selectedDate);
        }
      },
      dependencies: [i3.NgClass, i4.NgControlStatus, i4.NgModel, TimePickerComponent, DatePickerComponent],
      styles: ["bs-datepicker-container .bs-datepicker.theme-nice-date-time-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.years tbody tr td span,bs-datepicker-container .bs-datepicker.theme-nice-date-time-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.months tbody tr td span{border-radius:0;margin:0;height:61px;border:1px solid transparent}bs-datepicker-container .bs-datepicker.theme-nice-date-time-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.years tbody tr td span{width:71px}bs-datepicker-container .bs-datepicker.theme-nice-date-time-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.years tbody td span{line-height:56px}bs-datepicker-container .bs-datepicker.theme-nice-date-time-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.months tbody tr td span{width:95px}bs-datepicker-container .bs-datepicker.theme-nice-date-time-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.months tbody td span{line-height:44px}.bs-datepicker-head button[disabled],.bs-datepicker-head button[disabled]:hover,.bs-datepicker-head button[disabled]:active{background:none}.cxone-datepicker-wrapper{position:relative;display:inline-block;font-family:OpenSans}.cxone-datepicker-wrapper.page .dtp-container .cxone-datepicker-container .controls-wrapper{border:1px solid rgb(208,210,211);box-shadow:none}.cxone-datepicker-wrapper.page .button-wrapper:nth-child(2){border-left:1px solid rgb(208,210,211)}.cxone-datepicker-wrapper.header .button-item,.cxone-datepicker-wrapper.header .button-wrapper{left:252px!important;top:0!important;border:0px!important;box-shadow:6px 2px 6px #00000017}.cxone-datepicker-wrapper.header .dtp-container .cxone-datepicker-container{box-shadow:0 2px 6px #00000017}.cxone-datepicker-wrapper.invalid .dtp-container .controls-wrapper .input-wrapper{border:1px solid rgb(217,33,51)}.cxone-datepicker-wrapper.disabled .dtp-container .controls-wrapper{border-color:#dae2e8}.cxone-datepicker-wrapper.disabled .dtp-container .controls-wrapper .input-wrapper{background-color:#f8f8f8}.cxone-datepicker-wrapper.disabled .dtp-container .controls-wrapper input[type=text]{pointer-events:none;color:#707e8d}.cxone-datepicker-wrapper.disabled .dtp-container .controls-wrapper .button-wrapper{pointer-events:none;border-color:#dae2e8}.cxone-datepicker-wrapper.disabled .dtp-container .controls-wrapper .button-wrapper .cal svg{fill:#dae2e8}.cxone-datepicker-wrapper.disabled .dtp-container .controls-wrapper .button-item{pointer-events:none;border-color:#dae2e8}.cxone-datepicker-wrapper.disabled .dtp-container .controls-wrapper .button-item .icon-time svg{fill:#dae2e8}.dtp-container{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;height:35px;position:relative;align-items:center}.dtp-container .cxone-datepicker-container .dp-container .controls-wrapper{margin:0}.dtp-container.vertical{display:block}.dtp-container.vertical .cxone-datepicker-container{margin-top:10px}.dtp-container.vertical .cxone-datepicker-container .dp-container .controls-wrapper .input-wrapper input{width:128px}.dtp-container.vertical.no-day-name .cxone-datepicker-container{margin-top:10px}.dtp-container.vertical.no-day-name .cxone-datepicker-container .dp-container .controls-wrapper{margin:0}.dtp-container.vertical.no-day-name .cxone-datepicker-container .dp-container .controls-wrapper .input-wrapper input{width:174px}.dtp-container.horizontal{display:flex}.dtp-container.horizontal .cxone-datepicker-container{margin-left:10px}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatetimePickerComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-datetime-picker',
      encapsulation: ViewEncapsulation.None,
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DatetimePickerComponent),
        multi: true
      }, {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => DatetimePickerComponent),
        multi: true
      }],
      template: "<div class=\"cxone-datepicker-wrapper\" [ngClass]=\"{ 'disabled': disabled, 'header': mode === 'header', 'page': mode === 'page' }\">\n  <div class=\"dtp-container\" [ngClass]=\"orientationClass\">\n    <cxone-time-picker [mode]=\"mode\"\n                       [format]=\"timeFormat\"\n                       [(ngModel)]=\"selectedTime\"\n                       [steps]=\"steps\"\n                       [displayAsDuration]=\"false\"\n                       [disabled]=\"disabled\"\n                       [autoCorrectTime]=\"autoCorrectTime\"\n                       (timeChanged)=\"updateTimeForDate()\"\n    ></cxone-time-picker>\n    <cxone-date-picker [maxDate]=\"maxDate\"\n                       [datePickerContainer]=\"datetimePickerContainer\"\n                       [minDate]=\"minDate\"\n                       [mode]=\"mode\"\n                       [dayName]=\"dayName\"\n                       [shortDateFormat]=\"shortDateFormat\"\n                       [dateCustomClasses]=\"customCssClass\"\n                       [disabled]=\"disabled\"\n                       [dayName]=\"dayName\"\n                       (ngModelChange)=\"valueChanged($event)\"\n                       [(ngModel)]=\"selectedDate\"\n                       ></cxone-date-picker>\n  </div>\n</div>\n",
      styles: ["bs-datepicker-container .bs-datepicker.theme-nice-date-time-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.years tbody tr td span,bs-datepicker-container .bs-datepicker.theme-nice-date-time-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.months tbody tr td span{border-radius:0;margin:0;height:61px;border:1px solid transparent}bs-datepicker-container .bs-datepicker.theme-nice-date-time-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.years tbody tr td span{width:71px}bs-datepicker-container .bs-datepicker.theme-nice-date-time-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.years tbody td span{line-height:56px}bs-datepicker-container .bs-datepicker.theme-nice-date-time-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.months tbody tr td span{width:95px}bs-datepicker-container .bs-datepicker.theme-nice-date-time-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.months tbody td span{line-height:44px}.bs-datepicker-head button[disabled],.bs-datepicker-head button[disabled]:hover,.bs-datepicker-head button[disabled]:active{background:none}.cxone-datepicker-wrapper{position:relative;display:inline-block;font-family:OpenSans}.cxone-datepicker-wrapper.page .dtp-container .cxone-datepicker-container .controls-wrapper{border:1px solid rgb(208,210,211);box-shadow:none}.cxone-datepicker-wrapper.page .button-wrapper:nth-child(2){border-left:1px solid rgb(208,210,211)}.cxone-datepicker-wrapper.header .button-item,.cxone-datepicker-wrapper.header .button-wrapper{left:252px!important;top:0!important;border:0px!important;box-shadow:6px 2px 6px #00000017}.cxone-datepicker-wrapper.header .dtp-container .cxone-datepicker-container{box-shadow:0 2px 6px #00000017}.cxone-datepicker-wrapper.invalid .dtp-container .controls-wrapper .input-wrapper{border:1px solid rgb(217,33,51)}.cxone-datepicker-wrapper.disabled .dtp-container .controls-wrapper{border-color:#dae2e8}.cxone-datepicker-wrapper.disabled .dtp-container .controls-wrapper .input-wrapper{background-color:#f8f8f8}.cxone-datepicker-wrapper.disabled .dtp-container .controls-wrapper input[type=text]{pointer-events:none;color:#707e8d}.cxone-datepicker-wrapper.disabled .dtp-container .controls-wrapper .button-wrapper{pointer-events:none;border-color:#dae2e8}.cxone-datepicker-wrapper.disabled .dtp-container .controls-wrapper .button-wrapper .cal svg{fill:#dae2e8}.cxone-datepicker-wrapper.disabled .dtp-container .controls-wrapper .button-item{pointer-events:none;border-color:#dae2e8}.cxone-datepicker-wrapper.disabled .dtp-container .controls-wrapper .button-item .icon-time svg{fill:#dae2e8}.dtp-container{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;height:35px;position:relative;align-items:center}.dtp-container .cxone-datepicker-container .dp-container .controls-wrapper{margin:0}.dtp-container.vertical{display:block}.dtp-container.vertical .cxone-datepicker-container{margin-top:10px}.dtp-container.vertical .cxone-datepicker-container .dp-container .controls-wrapper .input-wrapper input{width:128px}.dtp-container.vertical.no-day-name .cxone-datepicker-container{margin-top:10px}.dtp-container.vertical.no-day-name .cxone-datepicker-container .dp-container .controls-wrapper{margin:0}.dtp-container.vertical.no-day-name .cxone-datepicker-container .dp-container .controls-wrapper .input-wrapper input{width:174px}.dtp-container.horizontal{display:flex}.dtp-container.horizontal .cxone-datepicker-container{margin-left:10px}\n"]
    }]
  }], () => [{
    type: i1.DomSanitizer
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i2.BsLocaleService
  }], {
    datetimePickerContainer: [{
      type: Input
    }],
    mode: [{
      type: Input
    }],
    orientation: [{
      type: Input
    }],
    minDate: [{
      type: Input
    }],
    maxDate: [{
      type: Input
    }],
    shortDateFormat: [{
      type: Input
    }],
    timeFormat: [{
      type: Input
    }],
    dayName: [{
      type: Input
    }],
    addLeds: [{
      type: Input
    }],
    steps: [{
      type: Input
    }],
    autoCorrectTime: [{
      type: Input
    }],
    activeLedDays: [{
      type: Input
    }],
    isValidTime: [{
      type: Output
    }],
    datePicker: [{
      type: ViewChild,
      args: [DatePickerComponent]
    }]
  });
})();
class DateTimeRangePickerComponent {
  constructor() {
    /* set container for date range picker */
    this.dateRangePickerContainer = 'body';
    this.removeShadowForPicker = false;
    this.realTimeOptionEnabled = false;
    this.isRealtimeActive = false;
    this.addLeds = false;
    this.activeLedDays = [];
    this.fromDateChange = new EventEmitter();
    this.toDateChange = new EventEmitter();
    this.realtimeChange = new EventEmitter();
    this.customCssClass = [];
  }
  ngOnInit() {
    this.highlightFrom = new Date(this.fromDate);
    this.highlightTo = new Date(this.toDate);
    if (this.addLeds) {
      this.customCssClass = this.activeLedDays;
    }
  }
  setTime(date, hour, minute, second) {
    date.setHours(hour);
    date.setMinutes(minute);
    date.setSeconds(second);
    date.setMilliseconds(0);
    return date;
  }
  setDate(dateObject, year, month, date) {
    dateObject.setFullYear(year);
    dateObject.setMonth(month);
    dateObject.setDate(date);
    return dateObject;
  }
  alignDates(from, to, alignParam) {
    if (!from || !to) {
      return;
    }
    let dateToUpdate;
    let dateToAligned;
    if (alignParam === 'to') {
      dateToUpdate = to;
      dateToAligned = from;
    } else {
      dateToUpdate = from;
      dateToAligned = to;
    }
    if (!moment(from).isSameOrBefore(moment(to))) {
      this.setDate(dateToUpdate, dateToAligned.getFullYear(), dateToAligned.getMonth(), dateToAligned.getDate());
      this.isRealtimeActive = false;
      if (!moment(from).isSameOrBefore(moment(to))) {
        this.setTime(dateToUpdate, dateToAligned.getHours(), dateToAligned.getMinutes(), dateToAligned.getSeconds());
      }
    }
    if (alignParam === 'to') {
      this.highlightTo = new Date(dateToUpdate);
      this.toDateChange.emit(this.highlightTo);
    } else {
      this.highlightFrom = new Date(dateToUpdate);
      this.fromDateChange.emit(this.highlightFrom);
    }
  }
  fromDateChanged(value) {
    if (typeof value == 'object' && !this.toDate) {
      this.toDate = value;
      this.isRealtimeActive = false;
    }
    this.alignDates(value, this.toDate, 'to');
    this.highlightFrom = value ? new Date(value) : undefined;
    this.fromDateChange.emit(this.highlightFrom);
  }
  toDateChanged(value) {
    if (typeof value == 'object' && !this.fromDate) {
      this.fromDate = value;
    }
    this.alignDates(this.fromDate, value, 'from');
    this.highlightTo = value ? new Date(value) : undefined;
    this.toDateChange.emit(this.highlightTo);
  }
  onRealtimeChanged($event) {
    this.realtimeChange.emit($event);
  }
  /** @nocollapse */
  static {
    this.ɵfac = function DateTimeRangePickerComponent_Factory(t) {
      return new (t || DateTimeRangePickerComponent)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DateTimeRangePickerComponent,
      selectors: [["cxone-date-time-range-picker"]],
      inputs: {
        dateRangePickerContainer: "dateRangePickerContainer",
        fromDate: "fromDate",
        toDate: "toDate",
        minDate: "minDate",
        maxDate: "maxDate",
        removeShadowForPicker: "removeShadowForPicker",
        realTimeOptionEnabled: "realTimeOptionEnabled",
        isRealtimeActive: "isRealtimeActive",
        addLeds: "addLeds",
        activeLedDays: "activeLedDays"
      },
      outputs: {
        fromDateChange: "fromDateChange",
        toDateChange: "toDateChange",
        realtimeChange: "realtimeChange"
      },
      decls: 3,
      vars: 27,
      consts: [[1, "date-time-range-picker"], [3, "ngModel", "maxDate", "minDate", "mode", "alwaysOpen", "disabled", "highlightClass", "highlightFrom", "highlightTo", "datetimePickerContainer", "removeShadows", "dateCustomClasses", "forceValidDates", "ngModelChange"], [3, "ngModel", "maxDate", "mode", "disabled", "highlightFrom", "highlightTo", "highlightClass", "alwaysOpen", "removeShadows", "datetimePickerContainer", "realtimeOptionEnabled", "isRealtimeActive", "dateCustomClasses", "forceValidDates", "ngModelChange", "realtimeChange"]],
      template: function DateTimeRangePickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "cxone-combined-datetime-picker", 1);
          i0.ɵɵtwoWayListener("ngModelChange", function DateTimeRangePickerComponent_Template_cxone_combined_datetime_picker_ngModelChange_1_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.fromDate, $event) || (ctx.fromDate = $event);
            return $event;
          });
          i0.ɵɵlistener("ngModelChange", function DateTimeRangePickerComponent_Template_cxone_combined_datetime_picker_ngModelChange_1_listener($event) {
            return ctx.fromDateChanged($event);
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(2, "cxone-combined-datetime-picker", 2);
          i0.ɵɵtwoWayListener("ngModelChange", function DateTimeRangePickerComponent_Template_cxone_combined_datetime_picker_ngModelChange_2_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.toDate, $event) || (ctx.toDate = $event);
            return $event;
          });
          i0.ɵɵlistener("realtimeChange", function DateTimeRangePickerComponent_Template_cxone_combined_datetime_picker_realtimeChange_2_listener($event) {
            return ctx.onRealtimeChanged($event);
          })("ngModelChange", function DateTimeRangePickerComponent_Template_cxone_combined_datetime_picker_ngModelChange_2_listener($event) {
            return ctx.toDateChanged($event);
          });
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵtwoWayProperty("ngModel", ctx.fromDate);
          i0.ɵɵproperty("maxDate", ctx.maxDate)("minDate", ctx.minDate)("mode", "page")("alwaysOpen", true)("disabled", false)("highlightClass", "selected-range")("highlightFrom", ctx.highlightFrom)("highlightTo", ctx.highlightTo)("datetimePickerContainer", ctx.dateRangePickerContainer)("removeShadows", ctx.removeShadowForPicker)("dateCustomClasses", ctx.customCssClass)("forceValidDates", true);
          i0.ɵɵadvance();
          i0.ɵɵtwoWayProperty("ngModel", ctx.toDate);
          i0.ɵɵproperty("maxDate", ctx.maxDate)("mode", "page")("disabled", false)("highlightFrom", ctx.highlightFrom)("highlightTo", ctx.highlightTo)("highlightClass", "selected-range")("alwaysOpen", true)("removeShadows", ctx.removeShadowForPicker)("datetimePickerContainer", ctx.dateRangePickerContainer)("realtimeOptionEnabled", ctx.realTimeOptionEnabled)("isRealtimeActive", ctx.isRealtimeActive)("dateCustomClasses", ctx.customCssClass)("forceValidDates", true);
        }
      },
      dependencies: [i4.NgControlStatus, i4.NgModel, CombinedDatetimePickerComponent],
      styles: ["bs-datepicker-container .bs-datepicker.theme-nice-date-time-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.years tbody tr td span,bs-datepicker-container .bs-datepicker.theme-nice-date-time-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.months tbody tr td span{border-radius:0;margin:0;height:61px;border:1px solid transparent}bs-datepicker-container .bs-datepicker.theme-nice-date-time-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.years tbody tr td span{width:71px}bs-datepicker-container .bs-datepicker.theme-nice-date-time-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.years tbody td span{line-height:56px}bs-datepicker-container .bs-datepicker.theme-nice-date-time-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.months tbody tr td span{width:95px}bs-datepicker-container .bs-datepicker.theme-nice-date-time-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.months tbody td span{line-height:44px}.bs-datepicker-head button[disabled],.bs-datepicker-head button[disabled]:hover,.bs-datepicker-head button[disabled]:active{background:none}.date-time-range-picker{width:632px;height:400px;margin-left:6px;display:inline-block}.date-time-range-picker cxone-combined-datetime-picker:first-child{margin-right:50px}.selected-range{background-color:#d9ebf5!important;color:#2e2e2e!important}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateTimeRangePickerComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-date-time-range-picker',
      encapsulation: ViewEncapsulation.None,
      template: "<div class=\"date-time-range-picker\">\n    <cxone-combined-datetime-picker\n      [(ngModel)]=\"fromDate\"\n      [maxDate]=\"maxDate\"\n      [minDate]=\"minDate\"\n      [mode]=\"'page'\"\n      [alwaysOpen]=\"true\"\n      [disabled]=\"false\"\n      [highlightClass]=\"'selected-range'\"\n      [highlightFrom]=\"highlightFrom\"\n      [highlightTo]=\"highlightTo\"\n      [datetimePickerContainer]=\"dateRangePickerContainer\"\n      [removeShadows]=\"removeShadowForPicker\"\n      [dateCustomClasses]=\"customCssClass\"\n      [forceValidDates]=\"true\"\n      (ngModelChange)=\"fromDateChanged($event)\"></cxone-combined-datetime-picker>\n    <cxone-combined-datetime-picker\n      [(ngModel)]=\"toDate\"\n      [maxDate]=\"maxDate\"\n      [mode]=\"'page'\"\n      [disabled]=\"false\"\n      [highlightFrom]=\"highlightFrom\"\n      [highlightTo]=\"highlightTo\"\n      [highlightClass]=\"'selected-range'\"\n      [alwaysOpen]=\"true\"\n      [removeShadows]=\"removeShadowForPicker\"\n      [datetimePickerContainer]=\"dateRangePickerContainer\"\n      [realtimeOptionEnabled]=\"realTimeOptionEnabled\"\n      [isRealtimeActive]=\"isRealtimeActive\"\n      (realtimeChange)=\"onRealtimeChanged($event)\"\n      [dateCustomClasses]=\"customCssClass\"\n      [forceValidDates]=\"true\"\n      (ngModelChange)=\"toDateChanged($event)\"></cxone-combined-datetime-picker>\n</div>\n",
      styles: ["bs-datepicker-container .bs-datepicker.theme-nice-date-time-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.years tbody tr td span,bs-datepicker-container .bs-datepicker.theme-nice-date-time-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.months tbody tr td span{border-radius:0;margin:0;height:61px;border:1px solid transparent}bs-datepicker-container .bs-datepicker.theme-nice-date-time-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.years tbody tr td span{width:71px}bs-datepicker-container .bs-datepicker.theme-nice-date-time-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.years tbody td span{line-height:56px}bs-datepicker-container .bs-datepicker.theme-nice-date-time-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.months tbody tr td span{width:95px}bs-datepicker-container .bs-datepicker.theme-nice-date-time-picker .bs-datepicker-container .bs-calendar-container .bs-media-container .bs-datepicker-body table.months tbody td span{line-height:44px}.bs-datepicker-head button[disabled],.bs-datepicker-head button[disabled]:hover,.bs-datepicker-head button[disabled]:active{background:none}.date-time-range-picker{width:632px;height:400px;margin-left:6px;display:inline-block}.date-time-range-picker cxone-combined-datetime-picker:first-child{margin-right:50px}.selected-range{background-color:#d9ebf5!important;color:#2e2e2e!important}\n"]
    }]
  }], null, {
    dateRangePickerContainer: [{
      type: Input
    }],
    fromDate: [{
      type: Input
    }],
    toDate: [{
      type: Input
    }],
    minDate: [{
      type: Input
    }],
    maxDate: [{
      type: Input
    }],
    removeShadowForPicker: [{
      type: Input
    }],
    realTimeOptionEnabled: [{
      type: Input
    }],
    isRealtimeActive: [{
      type: Input
    }],
    addLeds: [{
      type: Input
    }],
    activeLedDays: [{
      type: Input
    }],
    fromDateChange: [{
      type: Output
    }],
    toDateChange: [{
      type: Output
    }],
    realtimeChange: [{
      type: Output
    }]
  });
})();
class MomentDatePipe {
  transform(value, format = 'YYYY-MM-DD') {
    if (!value) {
      return '';
    }
    return moment(value).locale(navigator.language).format(format);
  }
  /** @nocollapse */
  static {
    this.ɵfac = function MomentDatePipe_Factory(t) {
      return new (t || MomentDatePipe)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "cxoneMomentDate",
      type: MomentDatePipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MomentDatePipe, [{
    type: Pipe,
    args: [{
      name: 'cxoneMomentDate'
    }]
  }], null, null);
})();
const FilterOptions = {
  Today: {
    value: 'Today',
    id: 1
  },
  Yesterday: {
    value: 'Yesterday',
    id: 2
  },
  FullDateRange: {
    value: 'FullDateRange',
    id: 3
  },
  CustomRange: {
    value: 'CustomRange',
    id: 6
  }
};
class DateRangeDropdownComponent {
  constructor(sanitizer, translationPipe, container) {
    this.sanitizer = sanitizer;
    this.translationPipe = translationPipe;
    this.container = container;
    /* set container for date range dropdown */
    this.dateRangeDropdownContainer = '.custom-picker';
    /* set the options where a date will be displayed on the dropdown */
    this.optionsWhereToShowDateOnDropdown = [];
    /*  set the date format to the displayed date on dropdown */
    this.dateFormat = 'MMM D, yyyy';
    /*  optional input for activate real time option on date-time-range-picker */
    this.isRealtimeActive = false;
    /*  optional input for enable real time option on date-time-range-picker */
    this.realTimeOptionEnabled = false;
    this.addLeds = false;
    this.activeLedDays = [];
    /*
      callback which is called whenever a dateRange is set
    */
    this.dateRangeChanged = new EventEmitter();
    /*
      callback which is called whenever a realTime is changed
    */
    this.realtimeChange = new EventEmitter();
    this.icons = {};
    this.dateLogic = {};
    this.dateEvents = {};
    this.isDropdownOpen = false;
    this.showCustomPicker = false;
    this.DisplayLastXDays = false;
    this.svgIcons = new SvgIcons(this.sanitizer);
    this.datePickerOptions = [];
    this.LastDayPickerValue = 1;
    this.LastDayPickerSaved = 1;
    this.dateFormatting = 'MMM D, YYYY h:mm:ss A';
    this.LastSelectedDateItem = {};
    this.selectedDateItem = {};
    this.LastDayPicker = {};
    this.showDropdownItems = true;
    this.count = 0;
    this.icons.arrow = this.svgIcons.getSvgIcons('icon-arrow-down');
  }
  ngOnInit() {
    this.buildDateSelectionLogicAndEvents();
    if (this.filterOptions) {
      this.addDatePickerOptionFromFilterOptions();
    } else {
      this.addDefaultDatePickerOptionFromOptions();
    }
    this.setDateRange = this.dateLogic.setDateRange;
    this.dateDropdownChanged = this.dateEvents.dateDropdownChanged;
    this.setCustomRange = this.dateEvents.setCustomRange;
    this.cancelCustomRange = this.dateEvents.cancelCustomRange;
    this.LastDayPicker = this.dateEvents.LastDayPicker;
    this.validateLastDaysInput = this.dateEvents.validateLastDaysInput;
    this.setValues = this.dateEvents.setValues;
    this.setValues();
    this.dateRangeFormatted = this.dateLogic.getRangeDateFormatted();
  }
  onRealTimeChanged($event) {
    this.realtimeChange.emit($event);
  }
  addDefaultDatePickerOptionFromOptions() {
    this.datePickerOptions = [{
      id: 1,
      title: this.translationPipe.transform('cxone-components.niceDateRangeDropdown.Today'),
      from: () => {
        return this.dateLogic.getDayStart(0);
      },
      to: this.dateLogic.getEndOfToday
    }, {
      id: 2,
      title: this.translationPipe.transform('cxone-components.niceDateRangeDropdown.LastXdays', {
        days: '2'
      }),
      from: () => {
        return this.dateLogic.getDayStart(1);
      },
      to: this.dateLogic.getEndOfToday
    }, {
      id: 3,
      title: this.translationPipe.transform('cxone-components.niceDateRangeDropdown.LastXdays', {
        days: '7'
      }),
      from: () => {
        return this.dateLogic.getDayStart(6);
      },
      to: this.dateLogic.getEndOfToday
    }, {
      id: 4,
      title: this.translationPipe.transform('cxone-components.niceDateRangeDropdown.CurrentMonth'),
      from: () => {
        return this.dateLogic.getMonthStart(0);
      },
      to: this.dateLogic.getEndOfToday
    }, {
      id: 5,
      title: this.translationPipe.transform('cxone-components.niceDateRangeDropdown.PreviousMonth'),
      from: () => {
        return this.dateLogic.getMonthStart(1);
      },
      to: () => {
        return this.dateLogic.getMonthEnd(1);
      }
    }, {
      id: 6,
      title: this.translationPipe.transform('cxone-components.niceDateRangeDropdown.CustomRange')
    }, {
      id: 7,
      title: this.translationPipe.transform('cxone-components.niceDateRangeDropdown.LastXdays', {
        days: '...'
      })
    }];
  }
  addDatePickerOptionFromFilterOptions() {
    this.datePickerOptions = [];
    let id = 8;
    this.filterOptions.forEach(option => {
      if (option === FilterOptions.CustomRange.value) {
        this.datePickerOptions.push({
          id: FilterOptions.CustomRange.id,
          title: this.translationPipe.transform('cxone-components.niceDateRangeDropdown.CustomRange'),
          showDateOnDropdown: this.optionsWhereToShowDateOnDropdown.includes(option)
        });
      } else if (option === FilterOptions.Today.value) {
        this.datePickerOptions.push({
          id: FilterOptions.Today.id,
          showDateOnDropdown: this.optionsWhereToShowDateOnDropdown.includes(option),
          title: this.translationPipe.transform('cxone-components.niceDateRangeDropdown.Today'),
          from: () => {
            return this.dateLogic.getDayStart(0);
          },
          to: this.dateLogic.getEndOfToday
        });
      } else if (option === FilterOptions.Yesterday.value) {
        this.datePickerOptions.push({
          id: FilterOptions.Yesterday.id,
          showDateOnDropdown: this.optionsWhereToShowDateOnDropdown.includes(option),
          title: this.translationPipe.transform('cxone-components.niceDateRangeDropdown.Yesterday'),
          from: () => {
            return this.dateLogic.getDayStart(1);
          },
          to: () => {
            return this.dateLogic.getDayEnd(1);
          }
        });
      } else if (option === FilterOptions.FullDateRange.value) {
        if (this.fullDateRange) {
          this.datePickerOptions.push({
            id: FilterOptions.FullDateRange.id,
            showDateOnDropdown: this.optionsWhereToShowDateOnDropdown.includes(option),
            title: this.translationPipe.transform('cxone-components.niceDateRangeDropdown.FullDateRange'),
            from: () => {
              return this.fullDateRange.fromDate;
            },
            to: () => {
              return this.fullDateRange.toDate;
            }
          });
        }
      } else {
        // option is number
        this.datePickerOptions.push({
          id: id++,
          showDateOnDropdown: this.optionsWhereToShowDateOnDropdown.includes(option),
          title: this.translationPipe.transform('cxone-components.niceDateRangeDropdown.LastXdays', {
            days: option
          }),
          from: () => {
            return this.dateLogic.getDayStart(Number(option) - 1);
          },
          to: this.dateLogic.getEndOfToday
        });
      }
    });
  }
  buildDateSelectionLogicAndEvents() {
    this.dateLogic = {
      getRangeDateFormatted: () => {
        return moment(this.LastDayPickerFromLabel).format(this.dateFormatting) + ' - ' + moment(this.endOfToday).format(this.dateFormatting);
      },
      getEndOfToday: () => {
        return moment().endOf('day').toDate();
      },
      getDayStart: daysAgo => {
        return moment().add(0 - daysAgo, 'days').startOf('day').toDate();
      },
      getDayEnd: daysAgo => {
        return moment().add(0 - daysAgo, 'days').endOf('day').toDate();
      },
      getMonthStart: monthsAgo => {
        return moment().add(0 - monthsAgo, 'months').startOf('month').toDate();
      },
      getMonthEnd: monthsAgo => {
        return moment().add(0 - monthsAgo, 'months').endOf('month').toDate();
      },
      setDateRange: (fromDate, toDate) => {
        if (this.selectedDateItem.id === 6) {
          this.buildDateRange(this.selectedDateItem.id, this.customFrom.getTime(), this.customTo.getTime());
        } else if (this.selectedDateItem.id === 7) {
          this.buildDateRange(this.selectedDateItem.id, this.LastDayPickerValue, 1);
        } else {
          this.buildDateRange(this.selectedDateItem.id, 1, 1);
        }
        this.dateRange.fromDate = new Date(fromDate);
        this.dateRange.toDate = new Date(toDate);
        this.dateRangeChanged.emit(this.dateRange);
      }
    };
    this.dateEvents = {
      dateDropdownChanged: dateItem => {
        this.LastSelectedDateItem = this.selectedDateItem;
        this.selectedDateItem = dateItem;
        this.showDateOnSelectedDateItem = false;
        if (this.selectedDateItem.showDateOnDropdown) {
          this.showDateOnSelectedDateItem = this.selectedDateItem.showDateOnDropdown;
        }
        if (dateItem.id !== 6 && dateItem.id !== 7) {
          this.showCustomPicker = false;
          this.DisplayLastXDays = false;
          this.setDateRange(dateItem.from(), dateItem.to());
        } else if (dateItem.id === 6) {
          if (this.dateRange && this.dateRange.fromDate && this.dateRange.toDate) {
            this.customFrom = this.dateRange.fromDate;
            this.customTo = this.dateRange.toDate;
          } else if (this.customFrom === undefined) {
            this.customFrom = this.dateLogic.getDayStart(0);
            this.customTo = this.dateLogic.getEndOfToday();
          }
          this.showCustomPicker = true;
          this.DisplayLastXDays = false;
        } else if (dateItem.id === 7) {
          this.endOfToday = this.dateLogic.getEndOfToday();
          this.LastDayPickerFromLabel = this.dateLogic.getDayStart(this.LastDayPickerValue - 1);
          this.showCustomPicker = false;
          this.DisplayLastXDays = true;
        }
      },
      setCustomRange: () => {
        this.setDateRange(this.customFrom, this.customTo);
        this.showCustomPicker = false;
      },
      cancelCustomRange: () => {
        this.selectedDateItem = this.LastSelectedDateItem;
        this.showCustomPicker = false;
      },
      LastDayPicker: {
        updateDates: () => {
          this.LastDayPickerFromLabel = this.dateLogic.getDayStart(this.LastDayPickerValue - 1);
          this.dateRangeFormatted = this.dateLogic.getRangeDateFormatted();
        },
        SetLastDateTitle: () => {
          this.datePickerOptions[6].title = this.translationPipe.transform('cxone-components.niceDateRangeDropdown.LastXdays', {
            days: this.LastDayPickerValue
          });
        },
        setLastDays: () => {
          this.setDateRange(this.dateLogic.getDayStart(this.LastDayPickerValue - 1), this.dateLogic.getEndOfToday());
          this.dateEvents.LastDayPicker.SetLastDateTitle();
          this.LastDayPickerSaved = this.LastDayPickerValue;
          this.DisplayLastXDays = false;
        },
        cancelLastDays: () => {
          this.DisplayLastXDays = false;
          this.LastDayPickerValue = this.LastDayPickerSaved;
          this.selectedDateItem = this.LastSelectedDateItem;
          this.dateEvents.LastDayPicker.updateDates();
        }
      },
      validateLastDaysInput: () => {
        if (this.LastDayPickerValue.toString().length > 3) {
          this.LastDayPickerValue = Number(this.LastDayPickerValue.toString().substr(0, 3));
        } else if (this.LastDayPickerValue.toString().length === 0 || Number(this.LastDayPickerValue) < 1) {
          this.LastDayPickerValue = 1;
        }
        this.LastDayPickerFromLabel = this.dateLogic.getDayStart(this.LastDayPickerValue - 1);
      },
      clickOutsidePicker: () => {
        if (this.DisplayLastXDays) {
          setTimeout(() => {
            this.dateEvents.LastDayPicker.cancelLastDays();
          }, 0);
        }
        if (this.showCustomPicker) {
          setTimeout(() => {
            this.dateEvents.cancelCustomRange();
          }, 0);
        }
      },
      // optionId between 1 to 7
      setValues: () => {
        if (!this.dateRange) {
          this.dateRange = {};
        }
        if (!this.dateRange.optionId) {
          this.dateRange.optionId = 1;
        }
        if (this.datePickerOptions[this.dateRange.optionId - 1] !== undefined) {
          this.selectedDateItem = this.datePickerOptions[this.dateRange.optionId - 1];
        } else {
          this.selectedDateItem = this.datePickerOptions[this.datePickerOptions.findIndex(p => p.id === this.dateRange.optionId)];
        }
        if (this.filterOptions) {
          this.showDateOnSelectedDateItem = this.selectedDateItem.showDateOnDropdown;
        }
        if (this.filterOptions) {
          this.showDateOnSelectedDateItem = this.selectedDateItem.showDateOnDropdown;
        }
        if (this.filterOptions && this.filterOptions[0] === 'CustomRange' && this.selectedDateItem.id === 6 && !isNaN(this.dateRange.fromDate) && !isNaN(this.dateRange.toDate)) {
          this.customFrom = this.dateRange.fromDate;
          this.customTo = this.dateRange.toDate;
          this.dateRangeChanged.emit(this.dateRange);
        } else if (this.selectedDateItem.id === 6 && !isNaN(this.dateRange.from) && !isNaN(this.dateRange.to)) {
          this.customFrom = moment(this.dateRange.from).toDate();
          this.customTo = moment(this.dateRange.to).toDate();
          this.dateRange.fromDate = new Date(this.customFrom);
          this.dateRange.toDate = new Date(this.customTo);
          this.dateRangeChanged.emit(this.dateRange);
        } else if (this.dateRange.optionId === 7 && !isNaN(this.dateRange.from)) {
          this.LastDayPickerValue = Number(this.dateRange.from);
          this.dateEvents.validateLastDaysInput();
          this.dateRange.fromDate = this.dateLogic.getDayStart(this.LastDayPickerValue - 1);
          this.dateRange.toDate = this.dateLogic.getEndOfToday();
          this.dateRangeChanged.emit(this.dateRange);
          this.dateEvents.LastDayPicker.SetLastDateTitle();
        } else {
          this.dateRange.fromDate = this.selectedDateItem.from();
          this.dateRange.toDate = this.selectedDateItem.to();
          this.dateRangeChanged.emit(this.dateRange);
        }
      }
    };
  }
  buildDateRange(optionId, from, to) {
    this.dateRange.optionId = optionId;
    this.dateRange.from = from;
    this.dateRange.to = to;
  }
  ngOnChanges(changes) {
    if (changes && changes.dateRange && !changes.dateRange.firstChange && this.setValues !== undefined) {
      this.setValues();
    }
  }
  onEvent(event) {
    if (!this.filterOptions || this.filterOptions[0] !== 'CustomRange') {
      this.isDropdownOpen = !this.isDropdownOpen;
    }
    if (this.filterOptions && this.filterOptions[0] === 'CustomRange' && this.showCustomPicker === false) {
      this.dateEvents.dateDropdownChanged(this.datePickerOptions[0]);
      this.showDropdownItems = false;
    } else {
      this.showDropdownItems = true;
      this.showCustomPicker = false;
    }
  }
  closeDropdown(event) {
    if (!this.dropdownBtn.nativeElement.contains(event.target)) {
      this.isDropdownOpen = false;
    }
    if (this.isDropdownOpen || !this.container.nativeElement.contains(event.target)) {
      if (![...event.target.classList].includes('is-highlighted') && event.target.text !== 'Today') {
        this.dateEvents.clickOutsidePicker();
      }
    }
  }
  /** @nocollapse */
  static {
    this.ɵfac = function DateRangeDropdownComponent_Factory(t) {
      return new (t || DateRangeDropdownComponent)(i0.ɵɵdirectiveInject(i1.DomSanitizer), i0.ɵɵdirectiveInject(i2$1.TranslationPipe), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DateRangeDropdownComponent,
      selectors: [["cxone-date-range-dropdown"]],
      viewQuery: function DateRangeDropdownComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c17, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdownBtn = _t.first);
        }
      },
      hostBindings: function DateRangeDropdownComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function DateRangeDropdownComponent_click_HostBindingHandler($event) {
            return ctx.closeDropdown($event);
          }, false, i0.ɵɵresolveDocument);
        }
      },
      inputs: {
        dateRangeDropdownContainer: "dateRangeDropdownContainer",
        dateRange: "dateRange",
        optionsWhereToShowDateOnDropdown: "optionsWhereToShowDateOnDropdown",
        filterOptions: "filterOptions",
        fullDateRange: "fullDateRange",
        customRangeMinAndMax: "customRangeMinAndMax",
        dateFormat: "dateFormat",
        isRealtimeActive: "isRealtimeActive",
        realTimeOptionEnabled: "realTimeOptionEnabled",
        addLeds: "addLeds",
        activeLedDays: "activeLedDays"
      },
      outputs: {
        dateRangeChanged: "dateRangeChanged",
        realtimeChange: "realtimeChange"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 10,
      vars: 10,
      consts: [[1, "cxone-date-range-dropdown"], ["dropdown", "", 1, "b-dropdown", "dropdown", "date-picker"], ["id", "button-single", "dropdownToggle", "", "aria-controls", "date-range-dropdown", 1, "dropdown-button", "dropdown-toggle", "big", "b-btn-flex-container", 3, "click"], ["dropdownBtn", ""], ["class", "button-text", 4, "ngIf"], [1, "icon-carat", 3, "ngClass", "innerHTML"], [4, "ngIf"], ["class", "custom-picker", 3, "click", 4, "ngIf"], ["class", "last-days-picker", 3, "click", 4, "ngIf"], [1, "button-text"], ["id", "dropdown-split", "class", "dropdown-menu item-big", "role", "menu", "aria-labelledby", "button-single", 4, "dropdownMenu"], ["id", "dropdown-split", "role", "menu", "aria-labelledby", "button-single", 1, "dropdown-menu", "item-big"], ["class", "range-options", "role", "menuitem", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], ["role", "menuitem", 1, "range-options", 3, "ngClass", "click"], [1, "item-text"], [1, "custom-picker", 3, "click"], [3, "minDate", "maxDate", "fromDate", "toDate", "dateRangePickerContainer", "isRealtimeActive", "realTimeOptionEnabled", "removeShadowForPicker", "addLeds", "activeLedDays", "fromDateChange", "toDateChange", "realtimeChange"], [1, "custom-picker-buttons"], [1, "btn", "cxone-btn", "btn-medium", "btn-primary", 3, "click"], ["type", "button", 1, "btn", "cxone-btn", "btn-medium", "btn-secondary", "btn-bg-is-white", 3, "click"], [1, "last-days-picker", 3, "click"], [3, "ngSubmit"], [1, "last-days-section"], [1, "date-label-last"], [1, "last-days-group"], ["name", "LastDayPickerValue", 1, "counter", 3, "ngModel", "step", "min", "max", "ngModelChange", "signClicked", "change"], [1, "date-label-days"], [1, "time-lastdays"], [3, "textContent"], [1, "last-days-picker-buttons"], ["type", "button", 1, "cxone-btn", "btn-medium", "btn-secondary", "btn-bg-is-white", "days-btn", "cancel-btn", 3, "click"], [1, "cxone-btn", "btn-medium", "btn-primary", "days-btn", 3, "click"]],
      template: function DateRangeDropdownComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "button", 2, 3);
          i0.ɵɵlistener("click", function DateRangeDropdownComponent_Template_button_click_2_listener($event) {
            return ctx.onEvent($event);
          });
          i0.ɵɵtemplate(4, DateRangeDropdownComponent_div_4_Template, 4, 8, "div", 4)(5, DateRangeDropdownComponent_div_5_Template, 2, 1, "div", 4);
          i0.ɵɵelement(6, "i", 5);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(7, DateRangeDropdownComponent_ng_container_7_Template, 2, 0, "ng-container", 6);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(8, DateRangeDropdownComponent_div_8_Template, 9, 16, "div", 7);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(9, DateRangeDropdownComponent_div_9_Template, 20, 17, "div", 8);
        }
        if (rf & 2) {
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("ngIf", ctx.showDateOnSelectedDateItem);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.showDateOnSelectedDateItem);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c18, ctx.isDropdownOpen, !ctx.isDropdownOpen))("innerHTML", ctx.icons.arrow, i0.ɵɵsanitizeHtml);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showDropdownItems);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showCustomPicker);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.DisplayLastXDays);
        }
      },
      dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i4.ɵNgNoValidate, i4.NgControlStatus, i4.NgControlStatusGroup, i4.NgModel, i4.NgForm, i5.BsDropdownMenuDirective, i5.BsDropdownToggleDirective, i5.BsDropdownDirective, i6.NumericSelectorComponent, DateTimeRangePickerComponent, i2$1.TranslationPipe, MomentDatePipe],
      styles: [".cxone-date-range-dropdown{position:relative;width:100%;font-family:OpenSans}.cxone-date-range-dropdown .date-picker #dropdown-split{z-index:1100}.cxone-date-range-dropdown .dropdown-button{display:flex;height:40px;width:100%;border:1px solid rgb(208,210,211);background-color:#fff;align-items:center;text-align:left;cursor:pointer;-webkit-user-select:none;user-select:none}.cxone-date-range-dropdown .dropdown-button.disabled{background:#f8f8f8 0% 0% no-repeat padding-box!important;border:1px solid rgb(208,210,211)!important;opacity:1;pointer-events:none}.cxone-date-range-dropdown .dropdown-button.disabled .button-text{color:#707e8d!important}.cxone-date-range-dropdown .dropdown-button.disabled svg{fill:#adadad!important}.cxone-date-range-dropdown .dropdown-button:hover{border-color:#007cbe}.cxone-date-range-dropdown .dropdown-button .button-text{flex:1;font-size:14px;padding:9px;color:#2e2e2e;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cxone-date-range-dropdown .dropdown-button .icon-carat{flex-grow:0;flex-shrink:0;transform:scale(.4)}.cxone-date-range-dropdown .dropdown-button .icon-carat svg{fill:#007cbe;position:relative;top:3px;transition:.2s;width:32px;height:32px}.cxone-date-range-dropdown .dropdown-button .icon-carat.dropdown-open svg{transform:rotate(180deg);transition:.2s}.cxone-date-range-dropdown .dropdown-button .icon-carat.dropdown-closed svg{transform:rotate(0);transition:.2s}.cxone-date-range-dropdown .dropdown-menu{margin:0;padding:0;min-width:100%;border-radius:0;border-top:none}.cxone-date-range-dropdown .dropdown-menu .range-options{height:40px;display:flex;align-items:center;cursor:pointer}.cxone-date-range-dropdown .dropdown-menu .range-options .item-text{color:#2e2e2e;margin-left:17px}.cxone-date-range-dropdown .dropdown-menu .range-options:hover:not(.selected-item){background-color:#f2f2f2}.cxone-date-range-dropdown .dropdown-menu .range-options.selected-item{background-color:#d9ebf5}.cxone-date-range-dropdown .dropdown-menu .range-options:nth-of-type(3),.cxone-date-range-dropdown .dropdown-menu .range-options:nth-of-type(5){border-bottom:1px solid rgb(211,211,211)}.cxone-date-range-dropdown .custom-picker{z-index:30;overflow:hidden;width:615px;height:430px;padding:9px 0 5px 5px;position:absolute;background:#fafafa 0% 0% no-repeat padding-box;box-shadow:0 2px 5px #0000001a;border:1px solid rgb(208,210,211);opacity:1;margin-top:-1px}.cxone-date-range-dropdown .custom-picker .date-time-range-picker{width:632px;height:380px;margin-left:6px}.cxone-date-range-dropdown .custom-picker .date-time-range-picker cxone-combined-datetime-picker:first-child{margin-right:45px!important}.cxone-date-range-dropdown .custom-picker .custom-picker-buttons .btn{float:right;width:85px;margin-right:11px}.last-days-picker{position:absolute;z-index:15;display:inline-block;border-radius:1px;background-color:#fafafa;box-shadow:0 2px 5px #0000001a;border:1px solid rgb(208,210,211);opacity:1;margin-top:-1px;width:auto;height:167px;padding:17px 15px 15px}.last-days-picker .last-days-section{margin-bottom:15px}.last-days-picker .last-days-section .date-label-last,.last-days-picker .last-days-section .date-label-days{color:#212c37;font-size:13px}.last-days-picker .last-days-section .last-days-group{width:71px;height:27px;margin:0 10px}.last-days-picker .last-days-section .last-days-group .numeric-selector-value{text-align:center}.last-days-picker .last-days-section .last-days-group .counter{display:inline-block}.last-days-picker .last-days-section .last-days-group .counter:focus{outline:none}.last-days-picker .time-lastdays{color:#212c37;font-size:13px}.last-days-picker .last-days-picker-buttons{display:flex;justify-content:flex-end;align-items:flex-end;height:72px}.last-days-picker .last-days-picker-buttons .days-btn{width:85px;padding:0 7px}.last-days-picker .last-days-picker-buttons .cancel-btn{margin-right:10px}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateRangeDropdownComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-date-range-dropdown',
      encapsulation: ViewEncapsulation.None,
      template: "<div class=\"cxone-date-range-dropdown\" >\n  <div class=\"b-dropdown dropdown date-picker\" dropdown>\n    <button id=\"button-single\"\n          class=\"dropdown-button dropdown-toggle big b-btn-flex-container\" dropdownToggle aria-controls=\"date-range-dropdown\"\n          (click)=\"onEvent($event)\" #dropdownBtn>\n      <div class=\"button-text\" *ngIf=\"showDateOnSelectedDateItem\">{{dateRange.fromDate | cxoneMomentDate:dateFormat}} - {{dateRange.toDate | cxoneMomentDate:dateFormat}}</div>\n      <div class=\"button-text\" *ngIf=\"!showDateOnSelectedDateItem\">{{selectedDateItem.title}}</div>\n      <i class=\"icon-carat\" [ngClass]=\"{'dropdown-open': isDropdownOpen, 'dropdown-closed': !isDropdownOpen}\"\n         [innerHTML]=\"icons.arrow\"></i>\n    </button>\n    <ng-container *ngIf=\"showDropdownItems\">\n    <ul id=\"dropdown-split\" class=\"dropdown-menu item-big\" *dropdownMenu\n        role=\"menu\" aria-labelledby=\"button-single\">\n      <li class=\"range-options\" role=\"menuitem\" *ngFor=\"let dateItem of datePickerOptions\"\n          [ngClass]=\"{'selected-item': dateItem.id === selectedDateItem.id}\"\n          (click)=\"dateDropdownChanged(dateItem)\">\n        <span class=\"item-text\">{{dateItem.title}}</span>\n      </li>\n    </ul>\n  </ng-container>\n  </div>\n  <div class=\"custom-picker\" *ngIf=\"showCustomPicker\" (click)=\"$event.stopPropagation()\">\n    <cxone-date-time-range-picker\n                                  [minDate]=\"customRangeMinAndMax ? customRangeMinAndMax.minDate : null\"\n                                  [maxDate]=\"customRangeMinAndMax ? customRangeMinAndMax.maxDate : null\"\n                                  [(fromDate)]=\"customFrom\"\n                                  [(toDate)]=\"customTo\"\n                                  [dateRangePickerContainer]=\"dateRangeDropdownContainer\"\n                                  [isRealtimeActive]=\"isRealtimeActive\"\n                                  [realTimeOptionEnabled]=\"realTimeOptionEnabled\"\n                                  (realtimeChange)=\"onRealTimeChanged($event)\"\n                                  [removeShadowForPicker]=\"true\"\n                                  [addLeds]=\"addLeds\"\n                                  [activeLedDays]=\"activeLedDays\"\n                                  >\n    </cxone-date-time-range-picker>\n    <div class=\"custom-picker-buttons\">\n      <button class=\"btn cxone-btn btn-medium btn-primary\" (click)=\"setCustomRange()\">{{ \"cxone-components.commonButtons.set\" | translate }}</button>\n      <button type=\"button\" class=\"btn cxone-btn btn-medium btn-secondary btn-bg-is-white\" (click)=\"cancelCustomRange()\">{{ \"cxone-components.commonButtons.cancel\" | translate }}</button>\n    </div>\n  </div>\n</div>\n<div class=\"last-days-picker\" *ngIf=\"DisplayLastXDays\" (click)=\"$event.stopPropagation()\">\n  <form (ngSubmit)=\"LastDayPicker.setLastDays()\">\n    <div class=\"last-days-section\">\n      <span class=\"date-label-last\">{{'cxone-components.niceDateRangeDropdown.lastDaysPreLabel' | translate}}</span>\n      <span class=\"last-days-group\">\n            <cxone-numeric-selector name=\"LastDayPickerValue\" class=\"counter\" [(ngModel)]=\"LastDayPickerValue\" [step]=\"1\"\n                                    [min]=\"1\" [max]=\"999\" (signClicked)=\"LastDayPicker.updateDates()\" (change)=\"validateLastDaysInput()\"></cxone-numeric-selector>\n          </span>\n      <span class=\"date-label-days\">{{'cxone-components.niceDateRangeDropdown.lastDaysPostLabel' | translate}}</span>\n    </div>\n    <div class=\"time-lastdays\">\n      <span [textContent]=\"dateRangeFormatted\"></span>\n    </div>\n    <div class=\"last-days-picker-buttons\">\n      <button type=\"button\" class=\"cxone-btn btn-medium btn-secondary btn-bg-is-white days-btn cancel-btn\" (click)=\"LastDayPicker.cancelLastDays()\">{{ \"cxone-components.commonButtons.cancel\" | translate }}</button>\n      <button class=\"cxone-btn btn-medium btn-primary days-btn\" (click)=\"LastDayPicker.setLastDays()\">{{ \"cxone-components.commonButtons.set\" | translate }}</button>\n    </div>\n  </form>\n</div>\n",
      styles: [".cxone-date-range-dropdown{position:relative;width:100%;font-family:OpenSans}.cxone-date-range-dropdown .date-picker #dropdown-split{z-index:1100}.cxone-date-range-dropdown .dropdown-button{display:flex;height:40px;width:100%;border:1px solid rgb(208,210,211);background-color:#fff;align-items:center;text-align:left;cursor:pointer;-webkit-user-select:none;user-select:none}.cxone-date-range-dropdown .dropdown-button.disabled{background:#f8f8f8 0% 0% no-repeat padding-box!important;border:1px solid rgb(208,210,211)!important;opacity:1;pointer-events:none}.cxone-date-range-dropdown .dropdown-button.disabled .button-text{color:#707e8d!important}.cxone-date-range-dropdown .dropdown-button.disabled svg{fill:#adadad!important}.cxone-date-range-dropdown .dropdown-button:hover{border-color:#007cbe}.cxone-date-range-dropdown .dropdown-button .button-text{flex:1;font-size:14px;padding:9px;color:#2e2e2e;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cxone-date-range-dropdown .dropdown-button .icon-carat{flex-grow:0;flex-shrink:0;transform:scale(.4)}.cxone-date-range-dropdown .dropdown-button .icon-carat svg{fill:#007cbe;position:relative;top:3px;transition:.2s;width:32px;height:32px}.cxone-date-range-dropdown .dropdown-button .icon-carat.dropdown-open svg{transform:rotate(180deg);transition:.2s}.cxone-date-range-dropdown .dropdown-button .icon-carat.dropdown-closed svg{transform:rotate(0);transition:.2s}.cxone-date-range-dropdown .dropdown-menu{margin:0;padding:0;min-width:100%;border-radius:0;border-top:none}.cxone-date-range-dropdown .dropdown-menu .range-options{height:40px;display:flex;align-items:center;cursor:pointer}.cxone-date-range-dropdown .dropdown-menu .range-options .item-text{color:#2e2e2e;margin-left:17px}.cxone-date-range-dropdown .dropdown-menu .range-options:hover:not(.selected-item){background-color:#f2f2f2}.cxone-date-range-dropdown .dropdown-menu .range-options.selected-item{background-color:#d9ebf5}.cxone-date-range-dropdown .dropdown-menu .range-options:nth-of-type(3),.cxone-date-range-dropdown .dropdown-menu .range-options:nth-of-type(5){border-bottom:1px solid rgb(211,211,211)}.cxone-date-range-dropdown .custom-picker{z-index:30;overflow:hidden;width:615px;height:430px;padding:9px 0 5px 5px;position:absolute;background:#fafafa 0% 0% no-repeat padding-box;box-shadow:0 2px 5px #0000001a;border:1px solid rgb(208,210,211);opacity:1;margin-top:-1px}.cxone-date-range-dropdown .custom-picker .date-time-range-picker{width:632px;height:380px;margin-left:6px}.cxone-date-range-dropdown .custom-picker .date-time-range-picker cxone-combined-datetime-picker:first-child{margin-right:45px!important}.cxone-date-range-dropdown .custom-picker .custom-picker-buttons .btn{float:right;width:85px;margin-right:11px}.last-days-picker{position:absolute;z-index:15;display:inline-block;border-radius:1px;background-color:#fafafa;box-shadow:0 2px 5px #0000001a;border:1px solid rgb(208,210,211);opacity:1;margin-top:-1px;width:auto;height:167px;padding:17px 15px 15px}.last-days-picker .last-days-section{margin-bottom:15px}.last-days-picker .last-days-section .date-label-last,.last-days-picker .last-days-section .date-label-days{color:#212c37;font-size:13px}.last-days-picker .last-days-section .last-days-group{width:71px;height:27px;margin:0 10px}.last-days-picker .last-days-section .last-days-group .numeric-selector-value{text-align:center}.last-days-picker .last-days-section .last-days-group .counter{display:inline-block}.last-days-picker .last-days-section .last-days-group .counter:focus{outline:none}.last-days-picker .time-lastdays{color:#212c37;font-size:13px}.last-days-picker .last-days-picker-buttons{display:flex;justify-content:flex-end;align-items:flex-end;height:72px}.last-days-picker .last-days-picker-buttons .days-btn{width:85px;padding:0 7px}.last-days-picker .last-days-picker-buttons .cancel-btn{margin-right:10px}\n"]
    }]
  }], () => [{
    type: i1.DomSanitizer
  }, {
    type: i2$1.TranslationPipe
  }, {
    type: i0.ElementRef
  }], {
    dateRangeDropdownContainer: [{
      type: Input
    }],
    dateRange: [{
      type: Input
    }],
    optionsWhereToShowDateOnDropdown: [{
      type: Input
    }],
    filterOptions: [{
      type: Input
    }],
    fullDateRange: [{
      type: Input
    }],
    customRangeMinAndMax: [{
      type: Input
    }],
    dateFormat: [{
      type: Input
    }],
    isRealtimeActive: [{
      type: Input
    }],
    realTimeOptionEnabled: [{
      type: Input
    }],
    addLeds: [{
      type: Input
    }],
    activeLedDays: [{
      type: Input
    }],
    dateRangeChanged: [{
      type: Output
    }],
    realtimeChange: [{
      type: Output
    }],
    dropdownBtn: [{
      type: ViewChild,
      args: ['dropdownBtn', {
        static: false
      }]
    }],
    closeDropdown: [{
      type: HostListener,
      args: ['document:click', ['$event']]
    }]
  });
})();
class DateTimePickersModule {
  /** @nocollapse */static {
    this.ɵfac = function DateTimePickersModule_Factory(t) {
      return new (t || DateTimePickersModule)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DateTimePickersModule
    });
  }
  /** @nocollapse */
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [{
        provide: I18NEXT_NAMESPACE,
        useValue: ComponentKeys.TRANSLATION_NAMESPACE
      }],
      imports: [CommonModule, FormsModule, CalendarModule, TextInputModule, BsDatepickerModule.forRoot(), TranslationModule, BsDropdownModule.forRoot(), NumericSelectorModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateTimePickersModule, [{
    type: NgModule,
    args: [{
      declarations: [DateRange, TimePickerComponent, DatePickerComponent, CombinedDatetimePickerComponent, DatetimePickerComponent, WeekPickerComponent, DateTimeRangePickerComponent, DateRangeDropdownComponent, MomentDatePipe],
      imports: [CommonModule, FormsModule, CalendarModule, TextInputModule, BsDatepickerModule.forRoot(), TranslationModule, BsDropdownModule.forRoot(), NumericSelectorModule],
      providers: [{
        provide: I18NEXT_NAMESPACE,
        useValue: ComponentKeys.TRANSLATION_NAMESPACE
      }],
      exports: [TimePickerComponent, DatePickerComponent, CombinedDatetimePickerComponent, DatetimePickerComponent, DateTimeRangePickerComponent, WeekPickerComponent, DateRangeDropdownComponent, MomentDatePipe]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { CombinedDatetimePickerComponent, DatePickerComponent, DateRangeDropdownComponent, DateTimePickersModule, DateTimeRangePickerComponent, DatetimePickerComponent, MomentDatePipe, TimePickerComponent, WeekPickerComponent };
